import {forwardRef, Inject, Injectable} from '@angular/core';
import {AlertService} from './alert.service';
import * as moment from 'moment';
import * as momentTz from 'moment-timezone';
import {
  AvailableJobAggregation,
  AvailableUserAggregation,
  Employee, EmprezPaging, Entity,
  HolidayCalculationType,
  JobAndUnitInfo,
  JobInfo,
  JSonResult,
  ResultWithNumberIds,
  ServerConfiguration,
  Unit,
  UsagerRole,
  User,
  WorkCodeData,
} from '../model/common.model';
import {SessionService} from './session.service';
import {TranslateService} from '@ngx-translate/core';
import {EmployeeForScheduling, EmployeeInfo, EmployeeSchedule} from '../model/schedule.model';
import {JSonSerializer} from '../model/JSonSerializer';
import {EmployeeTimeBankAggregation, EmployeeTimesheetAggregation} from '../model/timesheet.model';
import {
  AbsencesAggregation,
  DashboardEmployeeAggregation,
  EmployeeAvailabilityAggregation,
  EmployeeAvailabilityAndDetails,
  EmployeeAvailabilityDetail,
  EmployeeContact,
  EmployeeDocument,
  EmployeeJobAggregation, EmployeePayParams,
  EmployeePayParamsAggregation,
  EmployeePrefAppel, EmployeeScheduleParams,
  EmployeeSickDays, EmployeeTimesheetParams,
  EmployeeVacation,
  HiringAggregation,
  HiringDetail,
  JobBonus,
  PunchAndPortalParameters,
  RemunerationAndBonusAggregation,
  RemunerationDetail,
  SearchResultEmployeeAggregation
} from '../model/employee.model';
import {BatchItemVerification} from '../model/importing.model';
import {Router} from "@angular/router";
import {UserInfo} from "../model/UserInfo";
import {SchedulesForAnEmployee} from "../home/scheduleForAnEmployee/model/SchedulesForAnEmployee";
import {SchedulesForUnitAndJob} from "../home/schedulePerUnitAndJob/model/SchedulesForUnitAndJob";
import {MemoPacket} from "../home/memo/model/MemoPacket";
import {MemoAggregation, MemoEmployeeStatus} from "../home/memo/model/MemoAggregation";
import {CustomMemoAggregation} from "../home/memo/model/CustomMemoAggregation";
import {MemoContentWorkShift} from "../home/memo/model/MemoContentWorkShift";
import {MemoContentRequestVacation} from "../home/memo/model/MemoContentRequestVacation";
import {CreateNewEmployee} from "../home/employee/create/model/CreateNewEmployee";
import {WebReportParam} from "../home/reporting/model/WebReportParam";
import {WebReportRequest} from "../home/reporting/model/WebReportRequest";
import {TypeOfApproval} from "../home/memo/model/TypeOfApproval";
import {PunchData} from "../home/timesheet/model/PunchData";
import {EmployeeTemplateAggregation} from "../home/template/model/EmployeeTemplateAggregation";
import {EmployeeWorkTimeAndWage} from "../home/employee/model/EmployeeWorkTimeAndWage";
import {EmployeeVacationLeft} from "../model/EmployeeVacationLeft";
import {EmployeeSickDaysLeft} from "../model/EmployeeSickDaysLeft";
import {LateEmployee} from "../model/LateEmployee";
import {EmployeeNote} from "../home/employee/model/EmployeeNote";
import {EmployeeToNotifyAggregation} from "../model/EmployeeToNotify";
import {UserPreference} from "../model/Preferences";
import {EnterpriseAggregation} from "../home/pay/model/EnterpriseAggregation";
import {WebExportEmployeeRequest} from "../home/pay/model/WebExportEmployeeRequest";
import {EmployeeRightsAggregation} from "../home/employee/model/EmployeeRightsAggregation";
import {EmployeeRawPayInformation} from "../home/timesheet/model/EmployeeRawPayInformation";
import {BonusAggregation} from "../home/bonus/model/BonusAggregation";
import {FormatDescription} from "../home/employee/create/model/FormatDescription";
import {SearchEmployeeRequest} from "../home/employee/create/model/SearchEmployeeRequest";
import {SchedulePrintConfig, SortOrderType} from "../home/schedulePerEmployee/model/SchedulePrintConfig";
import {ExportEmployeeScheduleBean} from "../home/schedulePerEmployee/model/ExportEmployeeScheduleBean";
import {
  EmployeeBanksRequest,
  StandardEmployeeRequest,
  VerifyEmployeeRequest
} from "../home/employee/model/StandardEmployeeRequest";
import {EntityEmployeeBanks} from "../home/employee/model/EntityEmployeeBanks";
import {UpdateSomeInfoRequest} from "../home/employee/model/UpdateSomeInfoRequest";
import {MessageForPunch} from "../home/memo/punch/model/MessageForPunch";
import {CreateVacationRecordRequest} from "../home/batch/model/CreateVacationRecordRequest";
import {CreateVacationRecordAggregation} from "../home/batch/model/CreateVacationRecordAggregation";
import {CreateSickDaysRequest} from "../home/batch/model/CreateSickDaysRequest";
import {CreateSickDaysAggregation} from "../home/batch/model/CreateSickDaysAggregation";
import {CreateSalaryAdjustmentRequest} from "../home/batch/model/CreateSalaryAdjustmentRequest";
import {CreateSalaryAdjustmentAggregation} from "../home/batch/model/CreateSalaryAdjustmentAggregation";
import {ExportableEmployee} from "../home/pay/model/ExportableEmployee";
import {EmployeeGroupAggregation} from "../home/group/model/EmployeeGroupAggregation";
import {
  UpdateMatchingEmployeeWithMatriculeRequest
} from "../home/employee/create/model/UpdateMatchingEmployeeWithMatriculeRequest";
import {EmployeeVacationAggregation} from "../home/vacation/model/EmployeeVacationAggregation";
import {EmployeeVacationRange} from "../home/vacation/model/EmployeeVacationRange";
import {MatchingEmployeeResult} from "../home/employee/create/model/MatchingEmployeeResult";
import {EmployeeSkill} from "../home/employee/model/EmployeeSkill";
import {PlanningAggregation, PlanningDetail, PlanningUser} from "../home/planning/model/Planning";
import {CustomReport} from "../home/reporting/model/CustomReport";
import {VacationCalculationResult} from "../model/VacationCalculationResult";
import {AddJobRequest} from "../home/batch/model/AddJobRequest";
import {TimesheetEmployeeHoraireBean} from "../home/timesheet/model/TimesheetEmployeeHoraireBean";
import {EmployeeSpif} from "../home/spif/model/EmployeeSpif";
import {SpifType} from "../home/spif/model/SpifType";
import {TimesheetParamsAndEnterpriseId} from "../home/employee/model/TimesheetParamsAndEnterpriseId";
import {NotifyEmployeeWithFreeText} from "../home/notify/NotifyEmployeeWithFreeText";
import {ScheduleParamsAndEnterpriseId} from "../home/employee/model/ScheduleParamsAndEnterpriseId";
import {PortalParamsAndEnterpriseId} from "../home/employee/model/PortalParamsAndEnterpriseId";
import {PunchParamsAndEnterpriseId} from "../home/employee/model/PunchParamsAndEnterpriseId";
import {NamedWorkShiftAggregation} from "../home/namedWorkshift/model/NamedWorkShiftAggregation";
import {NamedWorkShiftUser} from "../home/namedWorkshift/model/NamedWorkShiftUser";
import {UnitIdJobId} from "../model/UnitIdJobId";
import {EstablishmentProgress} from "../home/establishment/EstablishmentProgress";
import {TimedTaskGroupAggregation} from "../home/task/model/TimedTaskGroupAggregation";
import {TimedTask} from "../home/task/model/TimedTask";
import {TimedTaskGroupUser} from "../home/task/model/TimedTaskGroupUser";
import {UnitAggregation} from "../halfGod/model/UnitAggregation";
import {
  NbDistinctEmployeeWithSchedulesPerUnitOfTime
} from "../halfGod/model/NbDistinctEmployeeWithSchedulesPerUnitOfTime";
import {EmployeeJobForAdminAggregation} from "../halfGod/model/EmployeeJobForAdminAggregation";
import {EmployeeTimedTaskParamsAggregation} from "../home/task/model/EmployeeTimedTaskParamsAggregation";
import {EmployeeTimedTaskParams} from "../home/task/model/EmployeeTimedTaskParams";
import {WebClientConfigurationAggregation} from "../model/WebClientConfigurationAggregation";
import {AddSpifAggregation} from "../home/batch/model/AddSpifAggregation";
import {AddSpifRequest} from "../home/batch/model/AddSpifRequest";
import {CCQConfigurationForEmployee} from "../model/CCQConfigurationForEmployee";
import {SecurityPerUser} from "../home/security/model/SecurityPerUser";
import {ApplySecurityForAllEmployee} from "../home/security/model/ApplySecurityForAllEmployee";
import {SchedulingAggregation} from "../model/SchedulingAggregation";
import {PaidFamilyLeaveCalculationResponseBean} from "../model/PaidFamilyLeaveCalculationResponseBean";
import {HolidayCalculationResult} from "../model/HolidayCalculationResult";
import {TraceService} from "./trace.service";
import {ParamsProfileAggregation} from "../home/params/model/ParamsProfileAggregation";
import {ParamsProfile} from "../home/params/model/ParamsProfile";
import {ParamsProfileUser} from "../home/params/model/ParamsProfileUser";
import {SaveDivisionRequest} from "../model/SaveDivisionRequest";
import {UdataFileResponseContainer} from "../model/UdataFileResponseContainer";
import {DetectedIssueOnEmployee} from "../home/pay/model/DetectedIssueOnEmployee";
import {EmployeeBankInformation} from "../home/timesheet/model/EmployeeBankInformation";
import {UsagerBudget} from "../home/employee/model/UsagerBudget";
import {SurveyAggregation} from "../home/survey/model/SurveyAggregation";
import {SurveyQuestionAggregation} from "../home/survey/model/SurveyQuestionAggregation";
import {SurveyAnswerChoice} from "../home/survey/model/SurveyAnswerChoice";
import {SurveyWithEmployeeProgress} from "../home/survey/model/SurveyWithEmployeeProgress";
import {SurveyEmployeeProgress} from "../home/survey/model/SurveyEmployeeProgress";
import {SearchEmployeeForSurvey} from "../home/survey/model/SearchEmployeeForSurvey";
import {ApiAccessToUser} from "../home/apiAccess/model/ApiAccessToUser";
import {AddOrModifyBonusRequest} from "../home/batch/model/AddOrModifyBonusRequest";
import {CumulativeBonusAndUnitJobs} from "../home/bonus/model/CumulativeBonusAndUnitJobs";
import {UnitJobCustomPayExport} from "../home/pay/model/UnitJobCustomPayExport";
import {EmployeePicture} from "../home/employee/model/EmployeePicture";
import {EmployeeOtherBadge} from "../home/employee/model/EmployeeOtherBadge";
import {UsagerBudgetAggregation} from "../home/budget/model/UsagerBudgetAggregation";
import {DayEventAggregation} from "../home/event/model/DayEventAggregation";
import {DaySalesCostObjectiveAggregation} from "../home/sales/model/DaySalesCostObjectiveAggregation";
import {EmprezMessageRead} from "../model/EmprezMessageRead";
import {EmployeePositionAggregation} from "../home/batch/model/EmployeePositionAggregation";
import {EmployeeSortOrder} from "../home/batch/model/EmployeeSortOrder";
import {CreateHolidaysRequest} from "../home/batch/model/CreateHolidaysRequest";
import {CreateHolidayAggregation} from "../home/batch/model/CreateHolidayAggregation";
import {CommitmentAggregation} from "../home/commitment/model/CommitmentAggregation";
import {SearchEmployeeForCommitment} from "../home/commitment/model/SearchEmployeeForCommitment";
import {CommitmentEmployee} from "../home/commitment/model/CommitmentEmployee";
import {ExportPlanningBean} from "../home/schedule/model/ExportPlanningBean";
import {ShiftBonus} from "../home/bonus/model/ShiftBonus";
import {ShiftBonusAggregation} from "../home/bonus/model/ShiftBonusAggregation";
import {WorkShiftBonus} from "../home/bonus/model/WorkShiftBonus";
import {NamedWorkShiftBonus} from "../home/namedWorkshift/model/NamedWorkShiftBonus";
import {EmployeeWithBadge} from "../home/batch/model/EmployeeWithBadge";
import {EmployeeWithBadgeRequest} from "../home/batch/model/EmployeeWithBadgeRequest";
import {GeoFenceUser} from "../home/geo/model/GeoFenceUser";
import {GeoFenceAggregation} from "../home/geo/model/GeoFenceAggregation";
import {GeoFenceSchedule} from "../home/geo/model/GeoFenceSchedule";
import {GeoFenceNamedWorkShift} from "../home/geo/model/GeoFenceNamedWorkShift";
import {EmployeeWithUserDevices} from "../model/EmployeeWithUserDevices";
import {BankTypeUser} from "../home/bank/model/BankTypeUser";
import {BankTypeAggregation} from "../home/bank/model/BankTypeAggregation";
import {BankType} from "../home/bank/model/BankType";
import {BankTypeEmployee} from "../home/bank/model/BankTypeEmployee";
import {BankTypeEmployeHoraire} from "../home/bank/model/BankTypeEmployeHoraire";
import {BankTypeCalculationResult} from "../model/BankTypeCalculationResult";
import {EmployeeHoraireAndBankType} from "../home/timesheet/model/EmployeeHoraireAndBankType";
import {BankTypeEmployeeAndBankType} from "../home/bank/model/BankTypeEmployeeAndBankType";
import {BankTypeEmployeeTransaction} from "../home/bank/model/BankTypeEmployeeTransaction";
import {BankTypeEmployeeTransactionAggregation} from "../home/bank/model/BankTypeEmployeeTransactionAggregation";
import {CreateBankTypeRecordRequest} from "../home/batch/model/CreateBankTypeRecordRequest";
import {CreateBankTypeRecordAggregation} from "../home/batch/model/CreateBankTypeRecordAggregation";
import {MemoContentRequestBankType} from "../home/memo/model/MemoContentRequestBankType";
import {UpdateLastMessage} from "../home/chat/model/UpdateLastMessage";
import {Survey} from "../home/survey/model/Survey";
import {
  UpdateMultipleEmployeeWithOptionsToUpdateFromCGIRequest
} from "../home/pay/model/UpdateMultipleEmployeeWithOptionsToUpdateFromCGIRequest";
import {CustomCumulativePremiumConfiguration} from "../home/bonus/model/CustomCumulativePremium";
import {CumulativeBonusToAdd} from "../home/batch/model/CumulativeBonusToAdd";
import {ReportToEmail} from "../home/reporting/model/ReportToEmail";
import {UpdateAllEnterprisePassword} from "../model/UpdateAllEnterprisePassword";
import {EnterpriseSegmentConfigurationFromAPI} from "../model/EnterpriseSegmentConfigurationFromAPI";
import {SegmentConfigurationRequest} from "../home/pay/model/SegmentConfigurationRequest";
import {SyncAPIConfig} from "../home/pay/model/SyncAPIConfig";
import {MainHrKPI} from '../home/hr/model/MainHrKPI';
import {WorkAccidentsPerEmployee} from "../home/hr/model/WorkAccidentsPerEmployee";
import {EmployeHoraireLock} from "../home/timesheet/model/EmployeHoraireLock";
import {DownloadInfo} from "../model/DownloadInfo";
import {HttpClient, HttpHeaders, HttpResponse} from "@angular/common/http";
import {firstValueFrom, lastValueFrom, Observable} from "rxjs";
import {EmployeeTimedTaskGroupAggregation} from "../home/task/model/EmployeeTimedTaskGroupAggregation";
import {EmployeeWithEmail} from "../home/batch/model/EmployeeWithEmail";
import {EmployeePunches} from "../halfGod/model/EmployeePunches";
import {PunchPerEmployee} from "../halfGod/model/PunchPerEmployee";
import {EmployeFTempsSommaireDetail} from "../home/timesheet/model/EmployeFTempsSommaireDetail";
import {SagesResponse} from "../home/pay/model/SagesResponse";
import {ExpenseType} from "../home/expenses/model/ExpenseType";
import {ExpenseTypeAggregation} from "../home/expenses/model/ExpenseTypeAggregation";
import {ExpenseTypeList} from "../home/expenses/model/ExpenseTypeList";
import {EmployeeExpenseAggregation} from "../home/expenses/model/EmployeeExpenseAggregation";
import {Expense} from "../home/expenses/model/Expense";
import {ExpenseFile} from "../home/expenses/model/ExpenseFile";
import {CopyEmployeeRequest} from "../home/employee/model/CopyEmployeeRequest";
import {DeleteSickDaysAggregation} from "../home/batch/model/DeleteSickDaysAggregation";
import {DeleteVacationRecordAggregation} from "../home/batch/model/DeleteVacationRecordAggregation";
import {DeleteBankTypeRecordAggregation} from "../home/batch/model/DeleteBankTypeRecordAggregation";
import {PlanningRequest} from "../home/schedule/model/PlanningRequest";
import {PlanningResponse} from "../home/schedule/model/PlanningResponse";
import {EmployeeHoraire} from "../model/EmployeHoraire";
import {EnterpriseStatutoryHoliday} from "../home/holiday/model/EnterpriseStatutoryHoliday";
import {SpifTypeAggregation} from "../home/spif/model/SpifTypeAggregation";
import {AddWeeklySpifRequest} from "../home/batch/model/AddWeeklySpifRequest";
import {AddWeeklySpifAggregation} from "../home/batch/model/AddWeeklySpifAggregation";
import {MailgunItem} from "../model/mailgun/MailgunItem";
import {MailgunEvent} from "../model/mailgun/MailgunEvent";
import {EvaluationAggregation} from "../home/evaluation/model/EvaluationAggregation";
import {EvaluationQuestionAggregation} from "../home/evaluation/model/EvaluationQuestionAggregation";
import {EvaluationAnswerChoice} from "../home/evaluation/model/EvaluationAnswerChoice";
import {EvaluationEmployee} from "../home/evaluation/model/EvaluationEmployee";
import {EvaluationEmployeeAggregation} from "../home/evaluation/model/EvaluationEmployeeAggregation";
import {Evaluation} from "../home/evaluation/model/Evaluation";
import {CloneEmployeePositions} from "../home/employee/clone/model/CloneEmployeePositions";
import {EvaluationFile} from "../home/evaluation/model/EvaluationFile";
import {ScheduleAndTSPerEmployeeAggregation} from "../model/ScheduleAndTSPerEmployeeAggregation";
import {
  InfoForSchedulingPerEmployeeAggregation
} from "../home/schedulePerEmployee/model/InfoForSchedulingPerEmployeeAggregation";
import {EmployeeJob} from "../model/EmployeeJob";
import {EmployeeAvailabilitySpecial} from "../home/memo/model/EmployeAvailabilitySpecial";
import {
  CustomValidation,
  EmployeHoraireToFillInformation, PlanningValidationAggregation,
  ValidationAggregation
} from "../model/validation/CustomValidation";
import {Enterprise} from "../model/Enterprise";
import {WebPayRequest} from "../home/pay/model/WebPayRequest";
import {ServerConfigurationForUser} from "../model/ServerConfigurationForUser";
import {GeoFence} from "../home/geo/model/GeoFence";
import {EnterpriseCostDistributionConfig} from "../home/costDistribution/model/EnterpriseCostDistributionConfig";
import {HrPerformanceForAnEmployeeAggregation} from "../home/hr/model/HrPerformanceForAnEmployeeAggregation";
import {WorkAccident} from "../home/hr/model/WorkAccident";
import {AllCustomReportAvailable} from "../home/reporting/model/AllCustomReportAvailable";
import {IntuitEmployee} from "../home/intuit/model/IntuitEmployee";
import {EmployeeTimesheetComponent} from "../home/timesheet/EmployeeTimesheetComponent";
import {BusinessItem} from "../home/pay/model/BusinessItem";
import {CompanyItem} from "../home/pay/model/CompanyItem";
import {SyncAPIConfigFolks} from "../home/pay/model/SyncAPIConfigFolks";
import {
  UpdateMultipleEmployeeWithOptionsToUpdateFromFolksRequest
} from "../home/pay/model/UpdateMultipleEmployeeWithOptionsToUpdateFromFolksRequest";
import {AiResponse} from "../home/ai/model/AiResponse";
import {EmployeeFamilyDays} from "../model/EmployeeFamilyDays";
import {CreateFamilyDaysAggregation} from "../home/batch/model/CreateFamilyDaysAggregation";
import {CreateFamilyDaysRequest} from "../home/batch/model/CreateFamilyDaysRequest";
import {DeleteFamilyDaysAggregation} from "../home/batch/model/DeleteFamilyDaysAggregation";
import {EmployeeFamilyDaysLeft} from "../model/EmployeeFamilyDaysLeft";
import {AutoAttendanceMessage} from "../home/timesheet/attendance/model/AutoAttendanceMessage";
import {CreateAutoAttendanceRequest} from "../home/batch/model/CreateAutoAttendanceRequest";
import {CreateAutoAttendanceRecordAggregation} from "../home/batch/model/CreateAutoAttendanceRecordAggregation";
import {EmployeeDocumentAggregation} from "../model/EmployeeDocumentAggregation";
import {ImportProjectType} from "../home/task/model/ImportProjectType";
import {ImportProjectResponse} from "../home/task/model/ImportProjectResponse";
import {
  UpdateMultipleEmployeeWithOptionsToUpdateFromOdooRequest
} from "../home/pay/model/UpdateMultipleEmployeeWithOptionsToUpdateFromOdooRequest";
import {SyncAPIConfigOdoo} from "../home/pay/model/SyncAPIConfigOdoo";
import {WelcomeEmployeeRequest} from "../model/WelcomeEmployeeRequest";
import {
  UpdateMultipleEmployeeWithOptionsToUpdateFromSageIntacctRequest
} from "../home/pay/model/UpdateMultipleEmployeeWithOptionsToUpdateFromSageIntacctRequest";
import {SageIntacctProjectsResponse} from "../home/task/model/sageIntacct/SageIntacctProjectsResponse";
import {EmployeeTimedTask} from "../home/task/model/EmployeeTimedTask";
import {SageIntacctProjectDetailRequest} from "../home/task/model/sageIntacct/SageIntacctProjectDetailRequest";
import {SearchEmployeeResponse} from "../model/SearchEmployeeResponse";
import {SearchEmployeeByUnitAndEnterprise} from "../model/SearchEmployeeByUnitAndEnterprise";
import {PortalParamsAndEmployeeId} from "../home/employee/model/PortalParamsAndEmployeeId";
import {PunchParamsAndEmployeeId} from "../home/employee/model/PunchParamsAndEmployeeId";
import {ScheduleParamsAndEmployeeId} from "../home/employee/model/ScheduleParamsAndEmployeeId";
import {TimesheetParamsAndEmployeeId} from "../home/employee/model/TimesheetParamsAndEmployeeId";
import {EmployeeEvaluationRequest} from "../home/batch/model/EmployeeEvaluationRequest";
import {HREmployeeAbsenceDetail} from "../home/timesheet/model/HREmployeeAbsenceDetail";
import {EmployeeAndStatus} from "../home/hr/model/EmployeeAndStatus";
import {DisciplineAggregation} from "../home/hr/model/DisciplineAggregation";
import {DisciplineFile} from "../home/hr/model/DisciplineFile";
import {Discipline} from "../home/hr/model/Discipline";
import {HRConfigParam} from "../model/hr/HRConfigParam";
import {HRConfigAggregation} from "../model/hr/HRConfigAggregation";
import {GrievanceFile} from "../home/hr/model/GrievanceFile";
import {Grievance} from "../home/hr/model/Grievance";
import {GrievanceAggregation} from "../home/hr/model/GrievanceAggregation";
import {CertificatAggregation} from "../home/learning/model/CertificatAggregation";
import {CertificatRequirement} from "../home/learning/model/CertificatRequirement";
import {Certificat} from "../home/learning/model/Certificat";
import {EmployeeCertificateAggregation} from "../home/learning/model/EmployeeCertificateAggregation";
import {EmployeeCertificate} from "../home/learning/model/EmployeeCertificate";
import {EmployeeCertificateFile} from "../home/learning/model/EmployeeCertificateFile";
import {TrainingProgramAggregation} from "../home/learning/model/TrainingProgramAggregation";
import {TrainingProgram} from "../home/learning/model/TrainingProgram";
import {EmployeeTrainingProgram} from "../home/learning/model/EmployeeTrainingProgram";
import {EmployeeWithDefaultPositionAndSalary} from "../home/learning/model/EmployeeWithDefaultPositionAndSalary";
import {EmployeeAbilitiesAggregation} from "../home/performance/model/EmployeeAbilitiesAggregation";
import {EmployeeAbility} from "../home/performance/model/EmployeeAbility";
import {EmployeePerformance} from "../home/performance/model/EmployeePerformance";
import {HRAbility} from "../home/performance/model/HRAbility";
import {HRPerformanceTemplate} from "../home/performance/model/HRPerformanceTemplate";
import {EmployeeAbilityReview} from "../home/performance/model/EmployeeAbilityReview";
import {EmployeePerformanceAggregation} from "../home/performance/model/EmployeePerformanceAggregation";
import {HRCompetency} from "../home/performance/model/HRCompetency";
import {EmployeeCompetency} from "../home/performance/model/EmployeeCompetency";
import {EmployeeCompetenciesAggregation} from "../home/performance/model/EmployeeCompetenciesAggregation";
import {EmployeeCompetencyReview} from "../home/performance/model/EmployeeCompetencyReview";
import {HRKeyResponsibilityArea} from "../home/performance/model/HRKeyResponsibilityArea";
import {EmployeeKRAsAggregation} from "../home/performance/model/EmployeeKRAsAggregation";
import {EmployeeKRA} from "../home/performance/model/EmployeeKRA";
import {EmployeeKRAReview} from "../home/performance/model/EmployeeKRAReview";
import {EmployeeGoalsAggregation} from "../home/performance/model/EmployeeGoalsAggregation";
import {EmployeeGoal} from "../home/performance/model/EmployeeGoal";
import {EmployeeGoalReview} from "../home/performance/model/EmployeeGoalReview";
import {EmployeeReview360} from "../home/performance/model/EmployeeReview360";
import {WorkAccidentFile} from "../home/hr/model/WorkAccidentFile";
import {HRGoalAggregation} from "../home/performance/model/HRGoalAggregation";
import {HRKeyResponsibilityAreaAggregation} from "../home/performance/model/HRKeyResponsibilityAreaAggregation";
import {EmployeeManagerAggregation} from "../home/performance/model/EmployeeManagerAggregation";
import {EmployeeManager} from "../home/performance/model/EmployeeManager";
import {EmployeeCareerAggregation} from "../home/learning/model/EmployeeCareerAggregation";
import {HRCareerAggregation} from "../home/learning/model/HRCareerAggregation";
import {EmployeeRecognitionAggregation} from "../home/performance/model/EmployeeRecognitionAggregation";
import {EmployeeRecognition} from "../home/performance/model/EmployeeRecognition";
import {EmployeePerformanceReportRequest} from "../home/performance/model/EmployeePerformanceReportRequest";
import {EmployeePerformanceReviewer} from "../home/performance/model/EmployeePerformanceReviewer";
import {HRDashboardInformation} from "../home/dashboard/hr/model/HRDashboardInformation";
import {MemoContentRequestFamilyDay} from "../home/memo/model/MemoContentRequestFamilyDay";
import {CommitmentUser} from "../home/commitment/model/CommitmentUser";
import {EnterpriseLog} from "../model/EnterpriseLog";


class EmprezBIForAnEmployeeInformation {
}

@Injectable()
export class ClientService {
    constructor(private http: HttpClient,  @Inject(forwardRef(() => AlertService)) private alertService: AlertService,
                @Inject(forwardRef(() => Router)) private router: Router,
                @Inject(forwardRef(() => TranslateService)) private translate: TranslateService,
                @Inject(forwardRef(() => SessionService)) private sessionService: SessionService
               ) { }

  loadConfiguration(): Promise<ServerConfiguration> {
            return this.http.get('configuration.json',{headers : this._getHeaders() }).toPromise().then(

                // response =>
                response => {
                              //
                              return response as ServerConfiguration;
                            },
                rejected => { return {server: 'No Server found.', download: 'No Download Server Found',downloadContent:'No downloadContent Server Found',storeSession: false} ; }
            );
    }

    private _getHeaders():HttpHeaders{
      // 180 days in seconds
      const headers = new HttpHeaders({'Strict-Transport-Security': 'max-age: 15552000; includeSubDomains'});
      return headers;
    }

    private _retrieveJSonHeaders():HttpHeaders{
      const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'etag' : this.sessionService.userInfo.etag , 'Accept-Language': this.sessionService.userInfo.locale,
        'X-XSRF-TOKEN':this.sessionService.xsrfToken});
      return headers;
    }

  private _retrieveHeaders():HttpHeaders{
    const headers = new HttpHeaders({ 'etag' : this.sessionService.userInfo.etag , 'Accept-Language': this.sessionService.userInfo.locale,
      'X-XSRF-TOKEN':this.sessionService.xsrfToken});
    return headers;
  }

    private _retrieveJSonRequestOptions(){
      const options = { headers: this._retrieveJSonHeaders(), withCredentials:true };
      return options;
    }

  private _retrieveJSonRequestOptionsWithBlob(){
    const options = { headers: this._retrieveHeaders(), withCredentials:true,responseType: 3 };
    return options;
  }

  private _retrieveJSonRequestOptionsWithArrayBuffer(){
    const options = { headers: this._retrieveHeaders(), withCredentials:true,responseType: 2 };
    return options;
  }


  private _handleRejected(rejected:any){

      if (rejected.hasOwnProperty('status')){
        if (rejected['status']===0){
          return {success:false,description: this.translate.instant('TemporaryInternetConnectionError')};
        }else{
          return {success:false,description: rejected + '',data:rejected['status']};
        }
      }else{
        return {success:false,description: rejected + ''};
      }
    }

  /*
  private handleError(error: any): Promise<any> {
      console.error('*Http* -> An error occurred', error);
      return Promise.reject(error.message || error);
  }
  */

    public serverUrl(url: string ): string {
        const urlComplete = this.sessionService.serverConfiguration.server.concat(url);
        //
        return urlComplete;
    }

   /*
  public serverNoDBUrl(url: string ): string {
    const urlComplete = this.session.serverConfiguration.serverNoDB.concat(url);
    //
    return urlComplete;
  }
  */

 /*
  public downloadUrl(url: string ): string {
    const urlComplete = this.sessionService.serverConfiguration.download.concat(url);
    //
    return urlComplete;
  }

  */

  public async downloadDocument(docId: number, employeeId: string ): Promise<JSonResult<string>> {
    let res =  await this.createTokenForDownloadingDocument(docId,employeeId);
    if (res.success){
      res.data = this._downloadContent('document?token=' + res.data + '&inline=true');
    }
    return res;
    // return this.downloadUrl('?docId=' + docId);
  }



  public createTokenForDownloadingDocument(documentId: number, employeeId: string): Promise<JSonResult<string>> {
   //this.traceService.sendTrace("createTokenForDownloadingDocument",{id:documentId,EMPLOYEE_ID:employeeId});

    return this.http.post( this.serverUrl('createTokenForDownloadingDocument'), {id:documentId,EMPLOYEE_ID:employeeId}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<string>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  private _downloadContent(url: string ): string {
    const urlComplete = this.sessionService.serverConfiguration.downloadContent.concat(url);
    return urlComplete;
  }


  public async downloadCommitment(commitmentId: number ): Promise<JSonResult<string>> {
    let res =  await this.createTokenForDownloadingCommitmentOLD(commitmentId);
    if (res.success){
      res.data = this._downloadContent('commitment?token=' + res.data + '&inline=true');
    }
    return res;
    // return this.downloadContent('commitment?commitmentId=' + commitmentId + '&inline=true');

  }


  public async downloadCommitmentWithPost(commitmentId: number ): Promise<JSonResult<DownloadInfo>> {
    let res =  await this.createTokenForDownloadingCommitment(commitmentId);
    if (res.success){

     this.http.post( this._downloadContent('commitment'), res.data.token, {headers:this._retrieveHeaders(),responseType:'blob'}).subscribe((response)=>{

        var blob = new Blob([response], { type: res.data.contentType });

        var win = window.open();
        var link = win.document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = res.data.fileName;
        win.document.body.appendChild(link);
        link.click();
        win.document.body.removeChild(link);
        win.document.write('<h1>' + res.data.fileName + ' has been retrieved.</h1>');
        win.close();

      });

    }
    return res;

  }


  public createTokenForDownloadingCommitmentOLD(commitmentId: number): Promise<JSonResult<string>> {
   //this.traceService.sendTrace("createTokenForDownloadingCommitment",{id:commitmentId});

    return this.http.post( this.serverUrl('createTokenForDownloadingCommitment'), {id:commitmentId}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<string>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  public createTokenForDownloadingCommitment(commitmentId: number): Promise<JSonResult<DownloadInfo>> {
   //this.traceService.sendTrace("createTokenForDownloadingCommitment",{id:commitmentId,returnsDownloadInfo:true});

    return this.http.post( this.serverUrl('createTokenForDownloadingCommitment'), {id:commitmentId,returnsDownloadInfo:true}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<DownloadInfo>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  public getWebClientConfigurationAggregation(): Promise<JSonResult<WebClientConfigurationAggregation>> {
   //this.traceService.sendTrace("getWebClientConfigurationAggregation");

    return this.http.post( this.serverUrl('getWebClientConfigurationAggregation'), {}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<WebClientConfigurationAggregation>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }




  private internalChangeAndSendLostPassword(username: string): Promise<JSonResult<string>> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    // const options = new RequestOptions({ headers: headers, withCredentials:true });

    const timeZone = momentTz.tz.guess();




    return this.http.post( this.serverUrl('changeAndSendLostPassword'),
      JSON.stringify({user: username, tz: timeZone }), { headers: headers, withCredentials:true } )
    // JSON.stringify({user: username, pwd: pwd, tz: 'America/Montreal' }), options )
      .toPromise()
      .then((response) => {
          return response as JSonResult<string>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  private _retrieveAndStoreXSRFToken( response: HttpResponse<any>){
    const xsrfToken = response.headers.get('XSRF-TOKEN');
    if (xsrfToken){
      this.sessionService.xsrfToken = xsrfToken;
    }else{

    }
  }

  private internalLogin(username: string, pwd: string): Promise<JSonResult<UserInfo>> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    const timeZone = momentTz.tz.guess();
    //
    //

   //this.traceService.sendTrace('loginClient',null,username);
    /*
    post<T>(url: string, body: any | null, options: {
      headers?: HttpHeaders;
      observe: 'response';
      params?: HttpParams;
      reportProgress?: boolean;
      responseType?: 'json';
      withCredentials?: boolean;
    }): Observable<HttpResponse<T>>;

     */

    return this.http.post<JSonResult<UserInfo>>( this.serverUrl('loginClient'),
      JSON.stringify({user: username, pwd: pwd, tz: timeZone }), { headers: headers,observe:'response', withCredentials:true } )
    // JSON.stringify({user: username, pwd: pwd, tz: 'America/Montreal' }), options )
      .toPromise()
      .then((response: HttpResponse<JSonResult<UserInfo>>) => {
          this._retrieveAndStoreXSRFToken(response);
          //
          return response.body as JSonResult<UserInfo>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  logout(): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("logout");

    // remove user from local storage to log user out
    // const headers = new Headers({ 'Content-Type': 'application/json', 'etag' : this.session.userInfo.etag , 'Accept-Language': this.session.userInfo.locale});
    // const options = new RequestOptions({ headers: headers });
    return this.http.post( this.serverUrl('logoffAction'), {etag:this.sessionService.userInfo.etag}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          this.sessionService.close();
          this.router.navigate(['/']);
          return response as JSonResult<number>;
        },
        (rejected) => {
          this.sessionService.close();
          this.router.navigate(['/']);
          return this._handleRejected(rejected);
        }
      );
  }


  retrievePlannings(): Promise<JSonResult<PlanningAggregation[]>> {
   //this.traceService.sendTrace("accessiblePlanning");
    return this.http.post( this.serverUrl('accessiblePlanning'), {}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          //
          return response as JSonResult<PlanningAggregation[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  retrieveAllPlannings(): Promise<JSonResult<PlanningAggregation[]>> {
   //this.traceService.sendTrace("accessiblePlanning",{includeInactive:true});
    return this.http.post( this.serverUrl('accessiblePlanning'), {includeInactive:true},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          //
          return response as JSonResult<PlanningAggregation[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  retrieveAllGroups(includeHidden:boolean): Promise<JSonResult<EmployeeGroupAggregation[]>> {
   //this.traceService.sendTrace("retrieveAllGroups",{includeHidden:includeHidden});
    return this.http.post( this.serverUrl('retrieveAllGroups'), {includeHidden:includeHidden},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          //
          return response as JSonResult<EmployeeGroupAggregation[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  deleteEmployeeGroupAggregation(bean: EmployeeGroupAggregation): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("deleteEmployeeGroupAggregation",bean);
    const serializer = new JSonSerializer();
    return this.http.post( this.serverUrl('deleteEmployeeGroupAggregation'), serializer.prepareForJson(bean),  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  /*

  */

  /**
   This will load  if they exist : 1)Current Schedules with employees and wages, 2) Jobs Available for those units.
   */

  getInfoForSchedulingPerEmployee(unitIds: string[],employeeIds:string[], start: moment.Moment, end: moment.Moment, sortType: SortOrderType): Promise<JSonResult<InfoForSchedulingPerEmployeeAggregation>> {
   //this.traceService.sendTrace("infoForSchedulingPerEmployee",{unitId: unitIds, employeeIds: employeeIds, fromDt: start, toDt: end, sortOrder:sortType.code});

    return this.http.post( this.serverUrl('infoForSchedulingPerEmployee'), {unitId: unitIds, employeeIds: employeeIds, fromDt: start, toDt: end, sortOrder:sortType.code},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return <JSonResult<InfoForSchedulingPerEmployeeAggregation>> response;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  /**
   This will load  if they exist : 1)Current Schedules with employees and wages, 2) Jobs Available for those units.
   */

  getInfoForSchedulingPerEmployeePerPosition(position: JobAndUnitInfo,employeeIds:string[], start: moment.Moment, end: moment.Moment, sortType: SortOrderType): Promise<JSonResult<InfoForSchedulingPerEmployeeAggregation>> {
   //this.traceService.sendTrace("infoForSchedulingPerEmployeePerPosition",{jobId: position.job.jobId, unitId: position.unit.unitCode, employeeIds: employeeIds, fromDt: start, toDt: end, sortOrder:sortType.code});

    return this.http.post( this.serverUrl('infoForSchedulingPerEmployeePerPosition'), {jobId: position.job.jobId, unitId: position.unit.unitCode, employeeIds: employeeIds, fromDt: start, toDt: end, sortOrder:sortType.code},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return <JSonResult<InfoForSchedulingPerEmployeeAggregation>> response;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  /**
    * Load all the schedules for An Employee (Limited to the units you have access to.)
   */
  getSchedulesForAnEmployeeAndDate(employeeId: string, start: moment.Moment, end: moment.Moment,includeInactivePosition: boolean): Promise<JSonResult<SchedulesForAnEmployee>> {
   //this.traceService.sendTrace("getSchedulesForAnEmployeeAndDate",{EMPLOYEE_ID: employeeId, fromDt: start, toDt: end});

    return this.http.post( this.serverUrl('getSchedulesForAnEmployeeAndDate'), {EMPLOYEE_ID: employeeId, fromDt: start, toDt: end,includeInactivePosition:includeInactivePosition},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          //
          // const res = response as JSonResult<SchedulesForAnEmployee>;
          return <JSonResult<SchedulesForAnEmployee>> response;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  /**
   This will load  if they exist : 1)Current Schedules with employees and wages, 2) Jobs Available for those units, 3) Information about the plan.
   */

  getInfoForScheduling(unitIds: string[], start: moment.Moment, end: moment.Moment, planId: number[]): Promise<JSonResult<SchedulingAggregation>> {
   //this.traceService.sendTrace("infoForScheduling",{unitId: unitIds, fromDt: start, toDt: end, planIds: planId});

    return this.http.post( this.serverUrl('infoForScheduling'), {unitId: unitIds, fromDt: start, toDt: end, planIds: planId},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          //
          const res = response as JSonResult<SchedulingAggregation>;

          if (res.success) {
            // Deserializing elements
            const serializer = new JSonSerializer();
            const jobAnd = serializer.deserializeArray(res.data.jobs, (bean: any) => {
              return new JobAndUnitInfo();
            });

            const availabilites = serializer.deserializeArray(res.data.availabilities, (bean: any) => {
              return new EmployeeAvailabilityAggregation();
            });
            // for (const bean: res.data.)
            res.data.availabilities = availabilites;
            res.data.jobs = jobAnd;
          }
          return res;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  /**
   Returns the employees for a specific job, availabilityRatio and current wage.
   */

  retrieveEmployeesForScheduling(jobId: string, refDates: moment.Moment[],  shiftStart: moment.Moment, shiftEnd: moment.Moment): Promise<JSonResult<EmployeeForScheduling[]>> {
   //this.traceService.sendTrace("employeesForScheduling",{jobId: jobId, refDt: refDates, startShiftDt: shiftStart, endShiftDt: shiftEnd});

    return this.http.post( this.serverUrl('employeesForScheduling'), {jobId: jobId, refDt: refDates, startShiftDt: shiftStart, endShiftDt: shiftEnd},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          //
          // return response as JSonResult<EmployeeForScheduling[]>;
          // const res: JSonResult<EmployeeForScheduling[]> = Object.assign(new JSonResult<EmployeeForScheduling[]>(),response);
          // return res;
          return <JSonResult<EmployeeForScheduling[]>> response;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  retrieveEmployeesForSchedulingOLD(jobId: string, refDate: moment.Moment,  shiftStart: moment.Moment, shiftEnd: moment.Moment): Promise<JSonResult<EmployeeForScheduling[]>> {
   //this.traceService.sendTrace("employeesForScheduling",{jobId: jobId, refDt: refDate, startShiftDt: shiftStart, endShiftDt: shiftEnd});
    return this.http.post( this.serverUrl('employeesForScheduling'), {jobId: jobId, refDt: refDate, startShiftDt: shiftStart, endShiftDt: shiftEnd},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          //
          // return response as JSonResult<EmployeeForScheduling[]>;
          // const res: JSonResult<EmployeeForScheduling[]> = Object.assign(new JSonResult<EmployeeForScheduling[]>(),response);
          // return res;
          return <JSonResult<EmployeeForScheduling[]>> response;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  /**
   * Returns the Timesheets already approved or to approve.
   */

  getApprovedUnApprovedEmployeeTimesheets(unitIds: string[],  start: moment.Moment, end: moment.Moment, enterpriseIds: number[], doNotIncludeApprovedTS: boolean): Promise<JSonResult<EmployeeTimesheetAggregation[]>> {
    //
    // const headers = new Headers({ 'Content-Type': 'application/json', 'ETag' : this.session.userInfo.etag , 'Accept-Language': this.session.userInfo.locale});
    // const options = new RequestOptions({ headers: headers });

   //this.traceService.sendTrace("getApprovedUnApprovedEmployeeTimesheets",{unitId: unitIds, fromDt: start, toDt: end, enterpriseId: enterpriseIds,doNotIncludeApprovedTS:doNotIncludeApprovedTS});

    return this.http.post( this.serverUrl('getApprovedUnApprovedEmployeeTimesheets'), {unitId: unitIds, fromDt: start, toDt: end, enterpriseId: enterpriseIds,doNotIncludeApprovedTS:doNotIncludeApprovedTS},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
           //
          //
          // return response as JSonResult<EmployeeForScheduling[]>;
          // const res: JSonResult<EmployeeForScheduling[]> = Object.assign(new JSonResult<EmployeeForScheduling[]>(),response);
          // return res;
          return <JSonResult<EmployeeTimesheetAggregation[]>> response;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  getEmployeeInfoForTimesheet(employeeId: string): Promise<JSonResult<EmployeeTimesheetAggregation>>{
   //this.traceService.sendTrace("getEmployeeInfoForTimesheet",{employeeId: employeeId});
    return this.http.post( this.serverUrl('getEmployeeInfoForTimesheet'), {employeeId: employeeId},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return <JSonResult<EmployeeTimesheetAggregation>> response;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  /*
  getApprovedUnApprovedTimesheetsPerEmployee(start: moment.Moment, end: moment.Moment, employeeId: string): Promise<JSonResult<EmployeeTimesheetAggregation>> {

    const headers = new Headers({ 'Content-Type': 'application/json', 'ETag' : this.session.userInfo.etag , 'Accept-Language': this.session.userInfo.locale});
    const options = new RequestOptions({ headers: headers });


    return this.http.post( this.serverUrl('getApprovedUnApprovedTimesheetsPerEmployee'), {EMPLOYEE_ID:employeeId, fromDt: start, toDt: end},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return <JSonResult<EmployeeTimesheetAggregation>> response;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }
  */


  getApprovedUnApprovedTimesheetsPerEmployee(start: moment.Moment, end: moment.Moment, employeeIds: string[], doNotIncludeApprovedTS: boolean,includeHidden = false): Promise<JSonResult<EmployeeTimesheetAggregation[]>> {
    //
   //this.traceService.sendTrace("getApprovedUnApprovedTimesheetsPerEmployee",{employeeIds:employeeIds, fromDt: start, toDt: end,doNotIncludeApprovedTS:doNotIncludeApprovedTS,includeHidden:includeHidden});

    return this.http.post( this.serverUrl('getApprovedUnApprovedTimesheetsPerEmployee'), {employeeIds:employeeIds, fromDt: start, toDt: end,doNotIncludeApprovedTS:doNotIncludeApprovedTS,includeHidden:includeHidden},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return <JSonResult<EmployeeTimesheetAggregation[]>> response;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  getEmployeHoraireById(id: number): Promise<JSonResult<EmployeeHoraire>> {
   //this.traceService.sendTrace("getEmployeHoraireById",{id:id});

    //
    // const headers = new Headers({ 'Content-Type': 'application/json', 'ETag' : this.sessionService.userInfo.etag , 'Accept-Language': this.sessionService.userInfo.locale});
    // const options = new RequestOptions({ headers: headers });
    return this.http.post( this.serverUrl('getEmployeHoraireById'), {id:id},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return <JSonResult<EmployeeHoraire>> response;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  getEmployeHoraireAndBankTypeById(id: number): Promise<JSonResult<EmployeeHoraireAndBankType>> {
   //this.traceService.sendTrace("getEmployeHoraireAndBankTypeById",{id:id});

    //
    // const headers = new Headers({ 'Content-Type': 'application/json', 'ETag' : this.sessionService.userInfo.etag , 'Accept-Language': this.sessionService.userInfo.locale});
    // const options = new RequestOptions({ headers: headers });
    return this.http.post( this.serverUrl('getEmployeHoraireAndBankTypeById'), {id:id},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return <JSonResult<EmployeeHoraireAndBankType>> response;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  /**
   * Returns the Timesheets already approved or to approve.
   */

  getTimesheetsToApprove(unitIds: string[],  start: moment.Moment, end: moment.Moment, enterpriseIds: number[]): Promise<JSonResult<EmployeeTimesheetAggregation[]>> {
    //
    // const headers = new Headers({ 'Content-Type': 'application/json', 'ETag' : this.session.userInfo.etag , 'Accept-Language': this.session.userInfo.locale});
    // const options = new RequestOptions({ headers: headers });
   //this.traceService.sendTrace('getTimesheetsToApprove',{unitId: unitIds, fromDt: start, toDt: end, enterpriseId: enterpriseIds});



    return this.http.post( this.serverUrl('getTimesheetsToApprove'), {unitId: unitIds, fromDt: start, toDt: end, enterpriseId: enterpriseIds},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          //
          // return response as JSonResult<EmployeeForScheduling[]>;
          // const res: JSonResult<EmployeeForScheduling[]> = Object.assign(new JSonResult<EmployeeForScheduling[]>(),response);
          // return res;
          return <JSonResult<EmployeeTimesheetAggregation[]>> response;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  /*
      public final static String TimesheetIds = "timesheetIds";
    public final static String EmployeeIds = "employeeIds";

   */

  getMissingInformationForApprovingTimesheets(employeeIds: string[],  timesheetIds: number[]): Promise<JSonResult<EmployeeTimesheetAggregation[]>> {

   //this.traceService.sendTrace("getMissingInformationForApprovingTimesheets",{employeeIds: employeeIds, timesheetIds: timesheetIds});
    return this.http.post( this.serverUrl('getMissingInformationForApprovingTimesheets'), {employeeIds: employeeIds, timesheetIds: timesheetIds},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          //
          // return response as JSonResult<EmployeeForScheduling[]>;
          // const res: JSonResult<EmployeeForScheduling[]> = Object.assign(new JSonResult<EmployeeForScheduling[]>(),response);
          // return res;
          return <JSonResult<EmployeeTimesheetAggregation[]>> response;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  /**
   * not used for now...
   */
  retrieveJobsForScheduling(unitIds: string[]): Promise<JSonResult<JobInfo[]>> {
   //this.traceService.sendTrace("jobsForScheduling",{unitId: unitIds});
    return this.http.post( this.serverUrl('jobsForScheduling'), {unitId: unitIds},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          //
          return response as JSonResult<JobInfo[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  saveEmployeeSchedules(schedulesToSave: EmployeeSchedule[], schedulesToRemove: EmployeeSchedule[], workShiftBonusToSave: WorkShiftBonus[],
                        geoFenceScheduleToSave: GeoFenceSchedule[],geoFenceScheduleToRemove: GeoFenceSchedule[],
                        bankTypeEmployeeHoraireToSave:BankTypeEmployeHoraire[], bankTypeEmployeeHoraireToRemove:BankTypeEmployeHoraire[]): Promise<JSonResult<ResultWithNumberIds>> {

    return this.http.post( this.serverUrl('saveEmployeeSchedules'), {toSave: schedulesToSave, toRemove: schedulesToRemove,
      workShiftBonusToSave: workShiftBonusToSave,geoFenceScheduleToSave:geoFenceScheduleToSave,geoFenceScheduleToRemove:geoFenceScheduleToRemove,
      bankTypeEmployeeHoraireToSave: bankTypeEmployeeHoraireToSave, bankTypeEmployeeHoraireToRemove:bankTypeEmployeeHoraireToRemove},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<ResultWithNumberIds>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  getBankingInformationByEmployeeAndRefDate(employeeId: string, refDt: moment.Moment): Promise<JSonResult<EmployeeTimeBankAggregation>> {
   //this.traceService.sendTrace("getBankingInformationByEmployeeAndRefDate",{'EMPLOYEE_ID': employeeId, refDt: refDt});
    return this.http.post( this.serverUrl('getBankingInformationByEmployeeAndRefDate'), {'EMPLOYEE_ID': employeeId, refDt: refDt},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<EmployeeTimeBankAggregation>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  saveEmployeeTimesheet(eh: EmployeeHoraireAndBankType): Promise<JSonResult<EmployeeHoraire>> {
   //this.traceService.sendTrace("saveEmployeeTimesheet",eh);
    const serial = new JSonSerializer();
    return this.http.post( this.serverUrl('saveEmployeeTimesheet'), serial.prepareForJson(eh),  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<EmployeeHoraire>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  deleteTimesheet(eh: EmployeeHoraire): Promise<JSonResult<ResultWithNumberIds>> {
   //this.traceService.sendTrace("deleteEmployeeTimesheet",eh);
    const serial = new JSonSerializer();
    return this.http.post( this.serverUrl('deleteEmployeeTimesheet'), serial.prepareForJson(eh),  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<ResultWithNumberIds>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  saveEmployeeTimeBank(eh: EmployeeTimeBankAggregation): Promise<JSonResult<ResultWithNumberIds>> {
   //this.traceService.sendTrace("saveEmployeeTimeBank",eh);
    const serial = new JSonSerializer();
    return this.http.post( this.serverUrl('saveEmployeeTimeBank'), serial.prepareForJson(eh),  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<ResultWithNumberIds>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  calculateHoliday(employeeId: string, refDt: moment.Moment, unitId: string ): Promise<JSonResult<HolidayCalculationResult>> {
   //this.traceService.sendTrace("calculateHoliday",{'EMPLOYEE_ID': employeeId, refDt: refDt, unitId: unitId});
    return this.http.post( this.serverUrl('calculateHoliday'), {'EMPLOYEE_ID': employeeId, refDt: refDt, unitId: unitId},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<HolidayCalculationResult>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  calculateCustomBank(scheduleId: number ): Promise<JSonResult<BankTypeCalculationResult>> {
   //this.traceService.sendTrace("calculateCustomBank",{'scheduleId':scheduleId});
    return this.http.post( this.serverUrl('calculateCustomBank'), {'scheduleId':scheduleId},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<BankTypeCalculationResult>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  calculateVacation(employeeId: string, refDt: moment.Moment): Promise<JSonResult<VacationCalculationResult>> {
   //this.traceService.sendTrace("calculateVacation",{EMPLOYEE_ID: employeeId, refDt: refDt});
    return this.http.post( this.serverUrl('calculateVacation'), {EMPLOYEE_ID: employeeId, refDt: refDt},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<VacationCalculationResult>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  calculatePaidFamilyLeave(employeeId: string, refDt: moment.Moment, calculationType: HolidayCalculationType): Promise<JSonResult<PaidFamilyLeaveCalculationResponseBean>> {
   //this.traceService.sendTrace("calculatePaidFamilyLeave",{employeeId: employeeId, refDate: refDt, calculationType: calculationType.code});
    return this.http.post( this.serverUrl('calculatePaidFamilyLeave'), {employeeId: employeeId, refDate: refDt, calculationType: calculationType.code},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<PaidFamilyLeaveCalculationResponseBean>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }




  calculateEmployeeWorkTime(employeeId: string, refDt: moment.Moment, nbWeeksBefore: number ): Promise<JSonResult<EmployeeWorkTimeAndWage[]>> {
   //this.traceService.sendTrace("calculateEmployeeWorkTime",{'EMPLOYEE_ID': employeeId, refDt: refDt, nbWeek: nbWeeksBefore});
    return this.http.post( this.serverUrl('calculateEmployeeWorkTime'), {'EMPLOYEE_ID': employeeId, refDt: refDt, nbWeek: nbWeeksBefore},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<EmployeeWorkTimeAndWage[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  searchForEmployee(lastNameFirstName: string, includeHiddenEmployee: boolean, includeInactiveEmployee: boolean, divisionCode: string): Promise<JSonResult<SearchResultEmployeeAggregation[]>> {
   //this.traceService.sendTrace("searchForEmployee",{toSearch: lastNameFirstName, includeHidden: includeHiddenEmployee, includeInactive: includeInactiveEmployee, unitId: divisionCode});
    return this.http.post( this.serverUrl('searchForEmployee'), {toSearch: lastNameFirstName, includeHidden: includeHiddenEmployee,includeInactive: includeInactiveEmployee, unitId: divisionCode},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          //
          return response as JSonResult<SearchResultEmployeeAggregation[]>;
        },
        (rejected) => {
          return this._handleRejected(rejected);
          //return this._handleRejected(rejected);
        }

      );
  }




  searchForAnyEmployee(lastNameFirstName: string, includeHiddenEmployee: boolean,includeInactiveEmployee:boolean): Promise<JSonResult<SearchResultEmployeeAggregation[]>> {
   //this.traceService.sendTrace("searchForAnyEmployee",{toSearch: lastNameFirstName, includeHidden: includeHiddenEmployee,includeInactive:includeInactiveEmployee});
    return this.http.post( this.serverUrl('searchForAnyEmployee'), {toSearch: lastNameFirstName, includeHidden: includeHiddenEmployee,includeInactive:includeInactiveEmployee},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          //
          return response as JSonResult<SearchResultEmployeeAggregation[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  getTerminatedAndVisible(): Promise<JSonResult<SearchResultEmployeeAggregation[]>> {
   //this.traceService.sendTrace("getTerminatedAndVisible");

    return this.http.post( this.serverUrl('getTerminatedAndVisible'), {},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          //
          return response as JSonResult<SearchResultEmployeeAggregation[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  getEmployeeAggregation(employeeId: string): Promise<JSonResult<DashboardEmployeeAggregation>> {
   //this.traceService.sendTrace("getEmployeeAggregation",{EMPLOYEE_ID: employeeId});
    return this.http.post( this.serverUrl('getEmployeeAggregation'), {EMPLOYEE_ID: employeeId},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<DashboardEmployeeAggregation>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  saveEmployeeAndPrefs(employee: Employee, prefs: EmployeePrefAppel): Promise<JSonResult<string>> {
    const serializer = new JSonSerializer();
   //this.traceService.sendTrace("saveEmployeeAndPrefs",{employee: serializer.prepareForJson(employee), prefs: serializer.prepareForJson(prefs) });
    return this.http.post( this.serverUrl('saveEmployeeAndPrefs'), {employee: serializer.prepareForJson(employee), prefs: serializer.prepareForJson(prefs) },  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          //
          return response as JSonResult<string>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  saveEmployeeOnly(employee: Employee): Promise<JSonResult<string>> {
   //this.traceService.sendTrace("saveEmployeeOnly",employee);
    const serializer = new JSonSerializer();
    return this.http.post( this.serverUrl('saveEmployeeOnly'), serializer.prepareForJson(employee),  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          //
          return response as JSonResult<string>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  saveEmployeeEmailOnly(employeeId: string, email: string): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("saveEmployeeEmailOnly",{EMPLOYEE_ID:employeeId,email: email});
    return this.http.post( this.serverUrl('saveEmployeeEmailOnly'), {EMPLOYEE_ID:employeeId,email: email},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  getRemunerationAndBonus(employeeId: string): Promise<JSonResult<RemunerationAndBonusAggregation>> {
   //this.traceService.sendTrace("getRemunerationAndBonus",{EMPLOYEE_ID: employeeId});
    return this.http.post( this.serverUrl('getRemunerationAndBonus'), {EMPLOYEE_ID: employeeId},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<RemunerationAndBonusAggregation>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  saveRemunerationAndBonus(bean: RemunerationAndBonusAggregation): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("saveRemunerationAndBonus",bean);
    const serializer = new JSonSerializer();
    return this.http.post( this.serverUrl('saveRemunerationAndBonus'), serializer.prepareForJson(bean),  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          //
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }




  saveRemunerationDetail(bean: RemunerationDetail): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("saveRemunerationDetail",bean);

    const serializer = new JSonSerializer();
    return this.http.post( this.serverUrl('saveRemunerationDetail'), serializer.prepareForJson(bean),  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  deleteRemunerationDetail(bean: RemunerationDetail): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("deleteRemunerationDetail",bean);
    const serializer = new JSonSerializer();
    return this.http.post( this.serverUrl('deleteRemunerationDetail'), serializer.prepareForJson(bean),  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  getHiringAggregation(employeeId: string): Promise<JSonResult<HiringAggregation>> {
   //this.traceService.sendTrace("getHiringAggregation",{EMPLOYEE_ID: employeeId});
    return this.http.post( this.serverUrl('getHiringAggregation'), {EMPLOYEE_ID: employeeId},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<HiringAggregation>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }






  saveHiringAggregation(bean: HiringAggregation): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("saveHiringAggregation",bean);
    const serializer = new JSonSerializer();
    return this.http.post( this.serverUrl('saveHiringAggregation'), serializer.prepareForJson(bean),  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }




  saveHiringDetail(bean: HiringDetail): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("saveHiringDetail",bean);
    const serializer = new JSonSerializer();
    return this.http.post( this.serverUrl('saveHiringDetail'), serializer.prepareForJson(bean),  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  deleteHiringDetail(bean: HiringDetail): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("deleteHiringDetail",bean);

    const serializer = new JSonSerializer();
    return this.http.post( this.serverUrl('deleteHiringDetail'), serializer.prepareForJson(bean),  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }




  getAbsencesAggregation(employeeId: string): Promise<JSonResult<AbsencesAggregation>> {
   //this.traceService.sendTrace("getAbsencesAggregation",{EMPLOYEE_ID: employeeId});

    return this.http.post( this.serverUrl('getAbsencesAggregation'), {EMPLOYEE_ID: employeeId},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<AbsencesAggregation>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  getAssociatedWorkCode(employeeId: string, refDate: Date, seniorityDate: Date = null, countryCode: string = null, provinceCode: string = null): Promise<JSonResult<WorkCodeData>>  {
    const obj = new WorkCodeParameter();
    obj.EMPLOYEE_ID = employeeId;
    obj.refDt = refDate;
    if (seniorityDate) {
      obj.seniorityDt = seniorityDate;
    }
    if (countryCode) {
      obj.countryCode = countryCode;
    }
    if (provinceCode) {
      obj.provinceCode = provinceCode;
    }
   //this.traceService.sendTrace("getAssociatedWorkCode",obj);

    return this.http.post( this.serverUrl('getAssociatedWorkCode'), obj,  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<WorkCodeData>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  saveEmployeeSickDays(bean: EmployeeSickDays): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("saveSickDay",bean);
    const serializer = new JSonSerializer();
    return this.http.post( this.serverUrl('saveSickDay'), serializer.prepareForJson(bean),  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  deleteEmployeeSickDays(bean: EmployeeSickDays): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("deleteSickDay",bean);
    const serializer = new JSonSerializer();
    return this.http.post( this.serverUrl('deleteSickDay'), serializer.prepareForJson(bean),  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  saveEmployeeVacation(bean: EmployeeVacation): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("saveVacation",bean);
    const serializer = new JSonSerializer();
    return this.http.post( this.serverUrl('saveVacation'), serializer.prepareForJson(bean),  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  deleteEmployeeVacation(bean: EmployeeVacation): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("deleteVacation",bean);

    const serializer = new JSonSerializer();
    return this.http.post( this.serverUrl('deleteVacation'), serializer.prepareForJson(bean),  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  getPunchAndPortalParameters(employeeId: string): Promise<JSonResult<PunchAndPortalParameters>> {
   //this.traceService.sendTrace("getPunchAndPortalParameters",{EMPLOYEE_ID: employeeId});

    return this.http.post( this.serverUrl('getPunchAndPortalParameters'), {EMPLOYEE_ID: employeeId},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<PunchAndPortalParameters>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  savePunchAndPortalParameters(bean: PunchAndPortalParameters): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("savePunchAndPortalParameters",bean);
    const serializer = new JSonSerializer();
    return this.http.post( this.serverUrl('savePunchAndPortalParameters'), serializer.prepareForJson(bean),  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  saveEmployeeContact(bean: EmployeeContact): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("saveEmployeContact",bean);

    const serializer = new JSonSerializer();
    return this.http.post( this.serverUrl('saveEmployeContact'), serializer.prepareForJson(bean),  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  deleteEmployeeContact(bean: EmployeeContact): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("deleteEmployeContact",bean);

    const serializer = new JSonSerializer();
    return this.http.post( this.serverUrl('deleteEmployeContact'), serializer.prepareForJson(bean),  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {

          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }




  getEmployeeJobAggregation(employeeId: string): Promise<JSonResult<EmployeeJobAggregation>> {
   //this.traceService.sendTrace("getEmployeeJobAggregation",{EMPLOYEE_ID: employeeId});

    return this.http.post( this.serverUrl('getEmployeeJobAggregation'), {EMPLOYEE_ID: employeeId},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<EmployeeJobAggregation>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  getEmployeeJobAggregationsByHRConfig(includeHidden:boolean, includeInactive: boolean): Promise<JSonResult<EmployeeJobAggregation[]>> {
    //this.traceService.sendTrace("getEmployeeJobAggregation",{EMPLOYEE_ID: employeeId});

    return this.http.post( this.serverUrl('getEmployeeJobAggregationsByHRConfig'), {includeHidden:includeHidden,includeInactive:includeInactive},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<EmployeeJobAggregation[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  saveEmployeeJob(bean: EmployeeJob): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("saveEmployeeJob",bean);
    const serializer = new JSonSerializer();
    return this.http.post( this.serverUrl('saveEmployeeJob'), serializer.prepareForJson(bean),  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {

          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  removeUnapprovedSchedules(jobId: string, unitId: string, employeeId: string): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("removeUnapprovedSchedules",{jobId: jobId, unitId: unitId,'EMPLOYEE_ID':employeeId});
    return this.http.post( this.serverUrl('removeUnapprovedSchedules'),  {jobId: jobId, unitId: unitId,'EMPLOYEE_ID':employeeId},  this._retrieveJSonRequestOptions())
    .toPromise()
    .then((response) => {
        return response as JSonResult<number>;
      },
      (rejected) => { return this._handleRejected(rejected); }
    );
  }

  deleteEmployeeJob(bean: EmployeeJob): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("deleteEmployeeJob",{'EMPLOYEE_ID':bean.employeeId,jobId: bean.jobId, unitId: bean.unitId});
    const serializer = new JSonSerializer();
    return this.http.post( this.serverUrl('deleteEmployeeJob'),  {'EMPLOYEE_ID':bean.employeeId,jobId: bean.jobId, unitId: bean.unitId},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {

          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  /*
  deleteEmployeeJobMultipleIds(employeeId: string, jobId: string, unitId: string): Promise<JSonResult<number>> {
    const headers = new Headers({ 'Content-Type': 'application/json', 'etag' : this.session.userInfo.etag , 'Accept-Language': this.session.userInfo.locale});
    const options = new RequestOptions({ headers: headers });
    return this.http.post( this.serverUrl('deleteEmployeeJob'), {'EMPLOYEE_ID':employeeId,jobId: jobId, unitId: unitId}, options)
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }
  */



  getAllActiveEmployeePositionWithJobAndUnit(jobId: string, unitId: string): Promise<JSonResult<EmployeePositionAggregation>> {
   //this.traceService.sendTrace("getAllActiveEmployeePositionWithJobAndUnit",{jobId:jobId, unitId: unitId});
    return this.http.post( this.serverUrl('getAllActiveEmployeePositionWithJobAndUnit'), {jobId:jobId, unitId: unitId}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          //
          return response as JSonResult<EmployeePositionAggregation>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  getEmployeeWithJobAndUnit(jobId: string, unitId: string): Promise<JSonResult<EmployeeJobForAdminAggregation[]>> {
   //this.traceService.sendTrace("getEmployeeWithJobAndUnit",{jobId:jobId, unitId: unitId});
    return this.http.post( this.serverUrl('getEmployeeWithJobAndUnit'), {jobId:jobId, unitId: unitId}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<EmployeeJobForAdminAggregation[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  getEmployeePaidByEnterprise(enterpriseId: number): Promise<JSonResult<EmployeeJobForAdminAggregation[]>> {
   //this.traceService.sendTrace("getEmployeePaidByEnterprise",{id:enterpriseId});
    return this.http.post( this.serverUrl('getEmployeePaidByEnterprise'), {id:enterpriseId}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          //
          return response as JSonResult<EmployeeJobForAdminAggregation[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  removeExternalIDOnEmployee(employeeId: string): Promise<JSonResult<EmployeeJobForAdminAggregation[]>> {
   //this.traceService.sendTrace("removeExternalIDOnEmployee",{'EMPLOYEE_ID':employeeId});
    return this.http.post( this.serverUrl('removeExternalIDOnEmployee'), {'EMPLOYEE_ID':employeeId}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<EmployeeJobForAdminAggregation[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  deleteNamedWorkShiftUser(bean: NamedWorkShiftUser): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("deleteNamedWorkShiftUser",bean);

    const serializer = new JSonSerializer();
    return this.http.post( this.serverUrl('deleteNamedWorkShiftUser'), serializer.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  deleteNamedWorkShiftAggregation(bean: NamedWorkShiftAggregation): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("deleteNamedWorkShiftAggregation",bean);

    const serializer = new JSonSerializer();
    return this.http.post( this.serverUrl('deleteNamedWorkShiftAggregation'), serializer.prepareForJson(bean),  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }
  // SaveNamedWorkShiftAggregationAction


  saveNamedWorkShiftAggregation(bean: NamedWorkShiftAggregation): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("saveNamedWorkShiftAggregation",bean);

    const serializer = new JSonSerializer();
    return this.http.post( this.serverUrl('saveNamedWorkShiftAggregation'), serializer.prepareForJson(bean),  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  getAccessibleNamedWorkShift(includeInactive: boolean): Promise<JSonResult<NamedWorkShiftAggregation[]>> {
   //this.traceService.sendTrace("getAccessibleNamedWorkShift",{includeInactive:includeInactive});
    return this.http.post( this.serverUrl('getAccessibleNamedWorkShift'), {includeInactive:includeInactive},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<NamedWorkShiftAggregation[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  getActiveNamedWorkShift(bean: UnitIdJobId[]): Promise<JSonResult<NamedWorkShiftAggregation[]>> {
   //this.traceService.sendTrace("getActiveNamedWorkShift",bean);
    const serializer = new JSonSerializer();
    return this.http.post( this.serverUrl('getActiveNamedWorkShift'), serializer.prepareForJson(bean),  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<NamedWorkShiftAggregation[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  getAvailableJobAggregation(): Promise<JSonResult<AvailableJobAggregation>> {
   //this.traceService.sendTrace("getAvailableJobAggregation");
    return this.http.post( this.serverUrl('getAvailableJobAggregation'), {},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<AvailableJobAggregation>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  getAvailableJobAggregationByUnit(unitIds: string[]): Promise<JSonResult<AvailableJobAggregation>> {
   //this.traceService.sendTrace("getAvailableJobAggregationByUnit",{unitId:unitIds});
    return this.http.post( this.serverUrl('getAvailableJobAggregationByUnit'), {unitId:unitIds},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          //
          return response as JSonResult<AvailableJobAggregation>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }




  getUserAggregationByUnit( roles: UsagerRole[]): Promise<JSonResult<AvailableUserAggregation>> {
     const serializer = new JSonSerializer();
   //this.traceService.sendTrace("getUserAggregationByUnit",{UsagerRole: serializer.prepareForJson(roles)});
    return this.http.post( this.serverUrl('getUserAggregationByUnit'), {UsagerRole: serializer.prepareForJson(roles)},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<AvailableUserAggregation>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }




  deletePlanningAggregation(bean: PlanningAggregation): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("deletePlanningAggregation",bean);
    const serializer = new JSonSerializer();
    return this.http.post( this.serverUrl('deletePlanningAggregation'), serializer.prepareForJson(bean),  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  deletePlanningDetail(bean: PlanningDetail): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("deletePlanningDetail",bean);
    const serializer = new JSonSerializer();
    return this.http.post( this.serverUrl('deletePlanningDetail'), serializer.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  deletePlanningUser(bean: PlanningUser): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("deletePlanningUser",bean);
    const serializer = new JSonSerializer();
    return this.http.post( this.serverUrl('deletePlanningUser'), serializer.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  savePlanningAggregation(bean: PlanningAggregation): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("savePlanningAggregation",bean);
    const serial = new JSonSerializer();
    return this.http.post( this.serverUrl('savePlanningAggregation'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  getEmployeePayParamsAggregation(employeeId: string): Promise<JSonResult<EmployeePayParamsAggregation>> {
   //this.traceService.sendTrace("getEmployeePayParamsAggregation",{EMPLOYEE_ID: employeeId});
    return this.http.post( this.serverUrl('getEmployeePayParamsAggregation'), {EMPLOYEE_ID: employeeId}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<EmployeePayParamsAggregation>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  saveEmployeePayParamsAggregation(batch: EmployeePayParamsAggregation): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace("saveEmployeePayParamsAggregation",batch);
    return this.http.post( this.serverUrl('saveEmployeePayParamsAggregation'), serial.prepareForJson(batch), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  saveEmployeeSortOrder(employeeId: string, sortOrder: number): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("saveEmployeeSortOrder",{EMPLOYEE_ID: employeeId, sortOrder: +sortOrder});
    return this.http.post( this.serverUrl('saveEmployeeSortOrder'), {EMPLOYEE_ID: employeeId, sortOrder: +sortOrder}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }




  saveBatch(batch: BatchItemVerification): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("saveBatch",batch);
    const serial = new JSonSerializer();
    return this.http.post( this.serverUrl('saveBatch'), serial.prepareForJson(batch), this._retrieveJSonRequestOptions() )
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  getEmployeeAvailabilityAggregation(employeeId: string): Promise<JSonResult<EmployeeAvailabilityAggregation>> {
   //this.traceService.sendTrace("getEmployeeAvailabilityAggregation",{EMPLOYEE_ID: employeeId});
    return this.http.post( this.serverUrl('getEmployeeAvailabilityAggregation'), {EMPLOYEE_ID: employeeId}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<EmployeeAvailabilityAggregation>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  saveEmployeeAvailabilityAndDetails(bean: EmployeeAvailabilityAndDetails): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace("saveEmployeeAvailabilityAndDetails",bean);
    return this.http.post( this.serverUrl('saveEmployeeAvailabilityAndDetails'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  deleteEmployeeAvailabilityDetails(beans: EmployeeAvailabilityDetail[]): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace("deleteEmployeAvailabilityDetails",beans);
    return this.http.post( this.serverUrl('deleteEmployeAvailabilityDetails'), serial.prepareForJson(beans), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  deleteEmployeeAvailabilitiesAndDetails(bean: EmployeeAvailabilityAndDetails): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace("deleteEmployeeAvailabilitiesAndDetails",bean);
    return this.http.post( this.serverUrl('deleteEmployeAvailabilityAndDetails'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  deleteEmployeeAvailabilitySpecial(bean: EmployeeAvailabilitySpecial): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace("deleteEmployeeAvailabilitySpecial",bean);
    return this.http.post( this.serverUrl('deleteEmployeeAvailabilitySpecial'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  saveEmployeeAvailabilitySpecial(bean: EmployeeAvailabilitySpecial): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace("saveEmployeeAvailabilitySpecial",bean);
    return this.http.post( this.serverUrl('saveEmployeeAvailabilitySpecial'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  getEmployeeDocuments(employeeId: string): Promise<JSonResult<EmployeeDocument[]>> {
    return this.http.post( this.serverUrl('getEmployeeDocuments'), {EMPLOYEE_ID: employeeId}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<EmployeeDocument[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  getEmployeeDocumentsByHRConfig(): Promise<JSonResult<EmployeeDocument[]>> {
    return this.http.post( this.serverUrl('getEmployeeDocumentsByHRConfig'), {includeHidden: false,includeInactive: true}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<EmployeeDocument[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  getEmployeeNotesByHRConfig(includeHidden:boolean, includeInactive: boolean): Promise<JSonResult<EmployeeNote[]>> {
    return this.http.post( this.serverUrl('getEmployeeNotesByHRConfig'), {includeHidden: includeHidden,includeInactive: includeInactive}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<EmployeeNote[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  getEmployeeDocumentAggregations(employeeId: string): Promise<JSonResult<EmployeeDocumentAggregation>> {
   //this.traceService.sendTrace("getEmployeeDocumentAggregations",{EMPLOYEE_ID: employeeId});
      return lastValueFrom<JSonResult<EmployeeDocumentAggregation>>(
          this.http.post<JSonResult<EmployeeDocumentAggregation>>( this.serverUrl('getEmployeeDocumentAggregations'), {EMPLOYEE_ID: employeeId}, this._retrieveJSonRequestOptions())
      );
    /*
    return this.http.post( this.serverUrl('getEmployeeDocumentAggregations'), {EMPLOYEE_ID: employeeId}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<EmployeeDocumentAggregation>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
      
     */
  }


  deleteEmployeeDocument(docId: number): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("deleteEmployeeDocument",{id: docId});
    return this.http.post( this.serverUrl('deleteEmployeeDocument'), {id: docId}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  saveEmployeeDocument(bean: EmployeeDocument): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace("saveEmployeeDocument",bean);
    return this.http.post( this.serverUrl('saveEmployeeDocument'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  getEmployeeSchedulePerUnitAndDate(unitIds: string[], start: moment.Moment, end: moment.Moment): Promise<JSonResult<EmployeeSchedule[]>> {
   //this.traceService.sendTrace("getEmployeeSchedulePerUnitAndDate",{unitId: unitIds, fromDt: start, toDt: end});

    return this.http.post( this.serverUrl('getEmployeeSchedulePerUnitAndDate'), {unitId: unitIds, fromDt: start, toDt: end}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<EmployeeSchedule[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  runEmployeeBasedValidationPerUnitAndWeekAction(unitIds: string[], nbOfWeek: number, validateOvertime: boolean): Promise<JSonResult<ValidationAggregation>> {
   //this.traceService.sendTrace("runEmployeeBasedValidationPerUnitAndWeekAction",{unitId: unitIds, nbWeek: nbOfWeek});
    return this.http.post( this.serverUrl('runEmployeeBasedValidationPerUnitAndWeekAction'), {unitId: unitIds, nbWeek: nbOfWeek, validateOvertime: validateOvertime}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          //
          return response as JSonResult<ValidationAggregation>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  runPlanningBasedValidationPerUnitAndWeekAction(unitIds: string[], nbOfWeek: number): Promise<JSonResult<PlanningValidationAggregation[]>> {
   //this.traceService.sendTrace("runPlanningBasedValidationPerUnitAndWeekAction",{unitId: unitIds, nbWeek: nbOfWeek});
    return this.http.post( this.serverUrl('runPlanningBasedValidationPerUnitAndWeekAction'), {unitId: unitIds, nbWeek: nbOfWeek}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<PlanningValidationAggregation[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  runEmployeHoraireToFillValidationPerUnitAndWeek(unitIds: string[], nbOfWeek: number, validateOvertime: boolean): Promise<JSonResult<CustomValidation<EmployeHoraireToFillInformation>[]>> {
   //this.traceService.sendTrace("runEmployeHoraireToFillValidationPerUnitAndWeek",{unitId: unitIds, nbWeek: nbOfWeek});
    return this.http.post( this.serverUrl('runEmployeHoraireToFillValidationPerUnitAndWeek'), {unitId: unitIds, nbWeek: nbOfWeek, validateOvertime: validateOvertime}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          //
          return response as JSonResult<CustomValidation<EmployeHoraireToFillInformation>[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  runEmployeHoraireToFillValidationPerUnitAndWeek__(unitIds: string[], nbOfWeek: number, validateOvertime: boolean): Promise<JSonResult<EmployeHoraireToFillInformation[]>> {
   //this.traceService.sendTrace("runEmployeHoraireToFillValidationPerUnitAndWeek",{unitId: unitIds, nbWeek: nbOfWeek});
    return this.http.post( this.serverUrl('runEmployeHoraireToFillValidationPerUnitAndWeek'), {unitId: unitIds, nbWeek: nbOfWeek, validateOvertime: validateOvertime}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          //
          return response as JSonResult<EmployeHoraireToFillInformation[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  getLateEmployee(late: number, farTooLate: number): Promise<JSonResult<LateEmployee[]>> {
   //this.traceService.sendTrace("getLateEmployee",{fromMin: late, toMin: farTooLate});
    return this.http.post( this.serverUrl('getLateEmployee'), {fromMin: late, toMin: farTooLate}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<LateEmployee[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  getSchedulesForAUnitAndJobAndDate(unitId: string, jobId: string, start: moment.Moment, end: moment.Moment): Promise<JSonResult<SchedulesForUnitAndJob>> {
   //this.traceService.sendTrace("getSchedulesForAUnitAndJobAndDate",{unitId: unitId, jobId: jobId, fromDt: start, toDt: end});

    return this.http.post( this.serverUrl('getSchedulesForAUnitAndJobAndDate'), {unitId: unitId, jobId: jobId, fromDt: start, toDt: end}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          //
          // const res = response as JSonResult<SchedulesForAnEmployee>;
          return <JSonResult<SchedulesForUnitAndJob>> response;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  getAllMemos(): Promise<JSonResult<MemoPacket[]>> {
   //this.traceService.sendTrace("getAllMemos");
    return this.http.post( this.serverUrl('getAllMemos'), {}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          //
          // const res = response as JSonResult<SchedulesForAnEmployee>;
          return <JSonResult<MemoPacket[]>> response;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


//   PAGING_FOR_RECEIVED_MEMOS)){
//   pagingForReceivedMemos = getGson(getUserTimeZone(req),isDateISO(req)).fromJson((String)objectMap.get(IContentCode.PAGING_FOR_RECEIVED_MEMOS),
//   new TypeToken<EmprezPaging<Long>>(){}.getType());
//
// }
//
// if (objectMap.containsKey(IContentCode.PAGING_FOR_SENT_MEMOS)){


  getActiveMemosForClient(pagingForReceivedMemos?: EmprezPaging, pagingForSentMemos?: EmprezPaging): Promise<JSonResult<MemoPacket[]>> {
   //this.traceService.sendTrace("getActiveMemosForClient");
    return this.http.post( this.serverUrl('getActiveMemosForClient'), {'pagingForReceivedMemos':pagingForReceivedMemos,'pagingForSentMemos': pagingForSentMemos }, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          //
          // const res = response as JSonResult<SchedulesForAnEmployee>;
          return <JSonResult<MemoPacket[]>> response;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  getNbUnreadMemos(): Promise<JSonResult<number>> {
    // this.traceService.sendTrace("getNbUnReadMemos");
    return this.http.post( this.serverUrl('getNbUnReadMemos'), {}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          //
          // const res = response as JSonResult<SchedulesForAnEmployee>;
          return <JSonResult<number>> response;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  saveMemo(bean: MemoAggregation): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("saveMemo",bean);
    const serial = new JSonSerializer();
    return this.http.post( this.serverUrl('saveMemo'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  saveMemoStatus(beans: MemoEmployeeStatus[]): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
    const toSave = new Array<MemoEmployeeStatus>();
    for (const bean of beans){
      toSave.push(serial.prepareForJson(bean));
    }
   //this.traceService.sendTrace("saveMemoStatus",toSave);

    return this.http.post( this.serverUrl('saveMemoStatus'), serial.prepareForJson(toSave), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  getMemoAttachment(memoId: number): Promise<JSonResult<any>> {
   //this.traceService.sendTrace("getMemoAttachment",{id: memoId});

    return this.http.post( this.serverUrl('getMemoAttachment'), {id: memoId}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<any>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }




  deactivateMemo(memoId: number): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("deactivateMemo",{id:memoId});

    return this.http.post( this.serverUrl('deactivateMemo'), {id:memoId}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  activateMemo(memoId: number): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("activateMemo",{id:memoId});
    return this.http.post( this.serverUrl('activateMemo'), {id:memoId}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  /**
   * Workshift Request Related
   */


  sendWorkShiftRequest (bean: CustomMemoAggregation<MemoContentWorkShift>): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("sendWorkShiftRequest",bean);
    const serial = new JSonSerializer();
    return this.http.post( this.serverUrl('sendWorkShiftRequest'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  refuseAnApplicationToAWorkShiftRequest (bean: CustomMemoAggregation<MemoContentWorkShift>): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("refuseAnApplicationToAWorkShiftRequest",bean);
    const serial = new JSonSerializer();
    return this.http.post( this.serverUrl('refuseAnApplicationToAWorkShiftRequest'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  acceptAnApplicationToAWorkShiftRequest (bean: CustomMemoAggregation<MemoContentWorkShift>): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("acceptAnApplicationToAWorkShiftRequest",bean);

    const serial = new JSonSerializer();
    return this.http.post( this.serverUrl('acceptAnApplicationToAWorkShiftRequest'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  refuseShiftExchange(bean: CustomMemoAggregation<MemoContentWorkShift>): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("refuseShiftExchange",bean);
    const serial = new JSonSerializer();
    return this.http.post( this.serverUrl('refuseShiftExchange'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
        .toPromise()
        .then((response) => {
             //
            return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
    );
  }

  approveShiftExchange(bean: CustomMemoAggregation<MemoContentWorkShift>): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("approveShiftExchange",bean);
    const serial = new JSonSerializer();
    return this.http.post( this.serverUrl('approveShiftExchange'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
        .toPromise()
        .then((response) => {
            //
            return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
    );
  }


applyForShiftExchange(bean: CustomMemoAggregation<MemoContentWorkShift>): Promise<JSonResult<number>> {
 //this.traceService.sendTrace("applyForShiftExchange",bean);
    const serial = new JSonSerializer();
    return this.http.post( this.serverUrl('applyForShiftExchange'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
        .toPromise()
        .then((response) => {
            //
            return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
    );
}



  refuseVacationRequest (bean: CustomMemoAggregation<MemoContentRequestVacation>): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("refuseVacationRequest",bean);

    const serial = new JSonSerializer();
    return this.http.post( this.serverUrl('refuseVacationRequest'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  acceptVacationRequest (bean: CustomMemoAggregation<MemoContentRequestVacation>): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("acceptVacationRequest",bean);
    const serial = new JSonSerializer();
    return this.http.post( this.serverUrl('acceptVacationRequest'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  refuseBankTypeRequest (bean: CustomMemoAggregation<MemoContentRequestBankType>): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("refuseBankTypeRequest",bean);

    const serial = new JSonSerializer();
    return this.http.post( this.serverUrl('refuseBankTypeRequest'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  acceptBankTypeRequest (bean: CustomMemoAggregation<MemoContentRequestBankType>): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("acceptBankTypeRequest",bean);
    const serial = new JSonSerializer();
    return this.http.post( this.serverUrl('acceptBankTypeRequest'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  refuseFamilyDayRequest (bean: CustomMemoAggregation<MemoContentRequestFamilyDay>): Promise<JSonResult<number>> {
    //this.traceService.sendTrace("refuseBankTypeRequest",bean);

    const serial = new JSonSerializer();
    return this.http.post( this.serverUrl('refuseFamilyDayRequest'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
        .toPromise()
        .then((response) => {
              //
              return response as JSonResult<number>;
            },
            (rejected) => { return this._handleRejected(rejected); }
        );
  }

  acceptFamilyDayRequest (bean: CustomMemoAggregation<MemoContentRequestFamilyDay>): Promise<JSonResult<number>> {
    //this.traceService.sendTrace("acceptBankTypeRequest",bean);
    const serial = new JSonSerializer();
    return this.http.post( this.serverUrl('acceptFamilyDayRequest'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
        .toPromise()
        .then((response) => {
              //
              return response as JSonResult<number>;
            },
            (rejected) => { return this._handleRejected(rejected); }
        );
  }



  acceptPeriodicAvailabilitiesRequest (bean: CustomMemoAggregation<EmployeeAvailabilityAndDetails>): Promise<JSonResult<number>> {
   //this.traceService.sendTrace('acceptApprovalRequest' + '/' + TypeOfApproval.AVAILABILITIES_PERIODIC.code,bean);
    const serial = new JSonSerializer();
    return this.http.post( this.serverUrl('acceptApprovalRequest' + '/' + TypeOfApproval.AVAILABILITIES_PERIODIC.code), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  rejectPeriodicAvailabilitiesRequest (bean: CustomMemoAggregation<EmployeeAvailabilityAndDetails>): Promise<JSonResult<number>> {
   //this.traceService.sendTrace('rejectApprovalRequest' + '/' + TypeOfApproval.AVAILABILITIES_PERIODIC.code,bean);
    const serial = new JSonSerializer();
    return this.http.post( this.serverUrl('rejectApprovalRequest'+ '/' + TypeOfApproval.AVAILABILITIES_PERIODIC.code), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  acceptSpecialAvailabilitiesRequest (bean: CustomMemoAggregation<EmployeeAvailabilitySpecial>): Promise<JSonResult<number>> {
   //this.traceService.sendTrace('acceptApprovalRequest' + '/' + TypeOfApproval.AVAILABILITIES_SE.code,bean);
    const serial = new JSonSerializer();

    return this.http.post( this.serverUrl('acceptApprovalRequest' + '/' + TypeOfApproval.AVAILABILITIES_SE.code), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  rejectSpecialAvailabilitiesRequest (bean: CustomMemoAggregation<EmployeeAvailabilitySpecial>): Promise<JSonResult<number>> {
   //this.traceService.sendTrace('rejectApprovalRequest' + '/' + TypeOfApproval.AVAILABILITIES_SE.code,bean);
    const serial = new JSonSerializer();

    return this.http.post( this.serverUrl('rejectApprovalRequest'+ '/' + TypeOfApproval.AVAILABILITIES_SE.code), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  getAllActiveEmployee(): Promise<JSonResult<EmployeeInfo[]>> {
   //this.traceService.sendTrace('getAllActiveEmployee');
    return this.http.post( this.serverUrl('getAllActiveEmployee'), {}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<EmployeeInfo[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  getEmployeeByHRConfig(includeHidden:boolean, includeInactive: boolean,includeWages? :boolean): Promise<JSonResult<EmployeeInfo[]>> {
    //this.traceService.sendTrace('getAllActiveEmployeesWithActivePositions',{refDt: refDt});
    return this.http.post( this.serverUrl('getEmployeeByHRConfig'), {includeHidden:includeHidden,includeInactive:includeInactive,includeWages: includeWages}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<EmployeeInfo[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  getAllActiveEmployeesWithActivePositions(refDt: moment.Moment): Promise<JSonResult<EmployeeInfo[]>> {
   //this.traceService.sendTrace('getAllActiveEmployeesWithActivePositions',{refDt: refDt});
    return this.http.post( this.serverUrl('getAllActiveEmployeesWithActivePositions'), {refDt: refDt}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<EmployeeInfo[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  getAllActiveEmployeePerUnitAction(unitIds: string[],includeUserSameLevel:boolean,includeInactivePosition:boolean=true,includeInactiveEmployee:boolean=false): Promise<JSonResult<EmployeeInfo[]>> {
   //this.traceService.sendTrace('getAllActiveEmployeePerUnit',{unitId:unitIds,includeUserSameLevel:includeUserSameLevel,includeInactivePosition:includeInactivePosition,includeInactiveEmployee:includeInactiveEmployee});

    return this.http.post( this.serverUrl('getAllActiveEmployeePerUnit'), {unitId:unitIds,includeUserSameLevel:includeUserSameLevel,includeInactivePosition:includeInactivePosition,includeInactiveEmployee:includeInactiveEmployee}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<EmployeeInfo[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  saveEmployeeGroupAggregation(bean: EmployeeGroupAggregation): Promise<JSonResult<number>> {
   //this.traceService.sendTrace('saveEmployeeGroupAggregation',bean);
    const serializer = new JSonSerializer();
    return this.http.post( this.serverUrl('saveEmployeeGroupAggregation'), serializer.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          //
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  getAllActiveEmployeeWithJobAndUnit(jobIds: string[], unitIds: string[], includeUserSameLevel: boolean,includeInactivePosition:boolean=true): Promise<JSonResult<EmployeeInfo[]>> {
   //this.traceService.sendTrace('getAllActiveEmployeeWithJobAndUnit',{jobId: jobIds, unitId:unitIds,includeUserSameLevel:includeUserSameLevel,includeInactivePosition:includeInactivePosition});
    return this.http.post( this.serverUrl('getAllActiveEmployeeWithJobAndUnit'), {jobId: jobIds, unitId:unitIds,includeUserSameLevel:includeUserSameLevel,includeInactivePosition:includeInactivePosition}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<EmployeeInfo[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }




  downloadEmployeeDocument(bean: EmployeeDocument){
    window.open(this.serverUrl('doc?id=' + bean.id),'_blank');
  }


  getAvailableEnterprises(): Promise<JSonResult<Enterprise[]>> {
   //this.traceService.sendTrace('getAvailableEnterprises');
    return this.http.post( this.serverUrl('getAvailableEnterprises'), {}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<Enterprise[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  saveNewEmployee(bean: CreateNewEmployee): Promise<JSonResult<string>> {
   //this.traceService.sendTrace('saveNewEmployee',bean);
    const serializer = new JSonSerializer();
    return this.http.post( this.serverUrl('saveNewEmployee'), serializer.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          //
          return response as JSonResult<string>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  retrieveWebReportParameters(reportCode: string, reportLabel: string): Promise<JSonResult<WebReportParam>> {
   //this.traceService.sendTrace('retrieveWebReportParameters',{reportCode: reportCode, reportLabel: reportLabel});
    const serializer = new JSonSerializer();
    return this.http.post( this.serverUrl('retrieveWebReportParameters'), {reportCode: reportCode, reportLabel: reportLabel}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<WebReportParam>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  createWebReport(bean: WebReportRequest): Promise<JSonResult<string>> {
   //this.traceService.sendTrace('createWebReport',bean);
    const serializer = new JSonSerializer();
    return this.http.post( this.serverUrl('createWebReport'), serializer.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<string>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  printSelectedSchedules(unitId: string, jobId: string, schedules: number[], start: moment.Moment, end: moment.Moment): Promise<JSonResult<string>> {
   //this.traceService.sendTrace('printSelectedSchedules',{unitId:unitId, jobId:jobId, ids:schedules, fromDt: start, toDt: end});

  const serializer = new JSonSerializer();
  return this.http.post( this.serverUrl('printSelectedSchedules'), {unitId:unitId, jobId:jobId, ids:schedules, fromDt: start, toDt: end}, this._retrieveJSonRequestOptions())
    .toPromise()
    .then((response) => {
        return response as JSonResult<string>;
      },
      (rejected) => { return this._handleRejected(rejected); }
    );
  }

  getPunchPictures(punchesIds:number[]): Promise<JSonResult<PunchData[]>> {
   //this.traceService.sendTrace('getPunchPictures',{ids:punchesIds});

    const serializer = new JSonSerializer();
  return this.http.post( this.serverUrl('getPunchPictures'), {ids:punchesIds}, this._retrieveJSonRequestOptions())
    .toPromise()
    .then((response) => {
        return response as JSonResult<PunchData[]>;
      },
      (rejected) => { return this._handleRejected(rejected); }
    );
  }



  getTemplateForEmployee(employeeId:string): Promise<JSonResult<EmployeeTemplateAggregation>> {
   //this.traceService.sendTrace('getTemplateForEmployee',{EMPLOYEE_ID:employeeId});

    return this.http.post( this.serverUrl('getTemplateForEmployee'), {EMPLOYEE_ID:employeeId}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<EmployeeTemplateAggregation>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  getTemplateForMultipleEmployee(employeeIds:string[]): Promise<JSonResult<EmployeeTemplateAggregation[]>> {
   //this.traceService.sendTrace('getTemplateForMultipleEmployee',{employeeIds:employeeIds});

    return this.http.post( this.serverUrl('getTemplateForMultipleEmployee'), {employeeIds:employeeIds}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          //
          return response as JSonResult<EmployeeTemplateAggregation[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  getTemplateForEmployeeJobAndUnit(employeeId:string,jobId: string, unitCode: string): Promise<JSonResult<EmployeeTemplateAggregation>> {
   //this.traceService.sendTrace('getTemplateForEmployeeJobAndUnit',{EMPLOYEE_ID:employeeId, jobId: jobId, unitId: unitCode});
    return this.http.post( this.serverUrl('getTemplateForEmployeeJobAndUnit'), {EMPLOYEE_ID:employeeId, jobId: jobId, unitId: unitCode}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<EmployeeTemplateAggregation>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  getTemplateForMultipleEmployeeJobAndUnit(employeeIds:string[],jobId: string, unitCode: string): Promise<JSonResult<EmployeeTemplateAggregation[]>> {
   //this.traceService.sendTrace('getTemplateForMultipleEmployeeJobAndUnit',{employeeIds:employeeIds, jobId: jobId, unitId: unitCode});
    return this.http.post( this.serverUrl('getTemplateForMultipleEmployeeJobAndUnit'), {employeeIds:employeeIds, jobId: jobId, unitId: unitCode}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          //
          return response as JSonResult<EmployeeTemplateAggregation[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  // getTemplateForUnitsOrForEmployeesPerWeek(this.selectedUnitIds,selectedEmployeeIds,this.weekNumber)
  getTemplateForUnitsOrForEmployeesPerWeek(unitCodes: string[],employeeIds: string[], weekNumber: number): Promise<JSonResult<EmployeeTemplateAggregation[]>> {
    return this.http.post( this.serverUrl('getTemplateForUnitsOrForEmployeesPerWeek'), {unitIds:unitCodes,employeeIds:employeeIds, week: weekNumber}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<EmployeeTemplateAggregation[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }
  getTemplateForUnitsOrForEmployeesMultipleWeek(unitCodes: string[],employeeIds: string[], startWeekNumber: number, numberOfWeek: number, sortOrder: SortOrderType): Promise<JSonResult<EmployeeTemplateAggregation[]>> {

    return this.http.post( this.serverUrl('getTemplateForUnitsOrForEmployeesMultipleWeek'), {unitIds:unitCodes,employeeIds:employeeIds, startWeekNumber: startWeekNumber,
    numberOfWeek: numberOfWeek, sortOrder: sortOrder.code}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          //
          return response as JSonResult<EmployeeTemplateAggregation[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  saveDateOfEmployeeTemplateAggregation(aggregation: EmployeeTemplateAggregation): Promise<JSonResult<number>> {
   //this.traceService.sendTrace('saveDateOfEmployeeTemplateAggregation',aggregation);

    const serializer = new JSonSerializer();
    return this.http.post( this.serverUrl('saveDateOfEmployeeTemplateAggregation'), serializer.prepareForJson(aggregation), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }
  /*

  saveTemplateForEmployee(bean: EmployeeTemplate): Promise<JSonResult<number>> {
    const headers = new Headers({ 'Content-Type': 'application/json', 'etag' : this.session.userInfo.etag , 'Accept-Language': this.session.userInfo.locale});
    const options = new RequestOptions({ headers: headers });
    const serializer = new JSonSerializer();
    return this.http.post( this.serverUrl('saveTemplateForEmployee'), serializer.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //

          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  */


  deleteTemplateForEmployee(employeeId: string, weekId: number): Promise<JSonResult<number>> {
   //this.traceService.sendTrace('deleteTemplateForEmployee',{EMPLOYEE_ID:employeeId, weekId: weekId});
    return this.http.post( this.serverUrl('deleteTemplateForEmployee'), {EMPLOYEE_ID:employeeId, weekId: weekId} , this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {

          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  deleteAllTemplateForEmployee(employeeId: string): Promise<JSonResult<number>> {
   //this.traceService.sendTrace('deleteAllTemplateForEmployee',{EMPLOYEE_ID:employeeId});
    return this.http.post( this.serverUrl('deleteAllTemplateForEmployee'), {EMPLOYEE_ID:employeeId} , this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  getEmployeeVacationLeft(employeeId:string,refDt: moment.Moment): Promise<JSonResult<EmployeeVacationLeft>> {
   //this.traceService.sendTrace('getEmployeeVacationLeft',{EMPLOYEE_ID:employeeId, refDt: refDt});
    return this.http.post( this.serverUrl('getEmployeeVacationLeft'), {EMPLOYEE_ID:employeeId, refDt: refDt}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<EmployeeVacationLeft>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  getSickDaysUsedPerEmployeeAndDate(employeeId:string,refDt: moment.Moment): Promise<JSonResult<EmployeeSickDaysLeft>> {
   //this.traceService.sendTrace('getSickDaysUsedPerEmployeeAndDate',{EMPLOYEE_ID:employeeId, refDt: refDt});
    return this.http.post( this.serverUrl('getSickDaysUsedPerEmployeeAndDate'), {EMPLOYEE_ID:employeeId, refDt: refDt}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<EmployeeSickDaysLeft>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  getFamilyDaysUsedPerEmployeeAndDate(employeeId:string,refDt: moment.Moment): Promise<JSonResult<EmployeeFamilyDaysLeft>> {
   //this.traceService.sendTrace('getFamilyDaysUsedPerEmployeeAndDate',{EMPLOYEE_ID:employeeId, refDt: refDt});
    return this.http.post( this.serverUrl('getFamilyDaysUsedPerEmployeeAndDate'), {EMPLOYEE_ID:employeeId, refDt: refDt}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<EmployeeFamilyDaysLeft>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }




  saveEmployeeNote(eh: EmployeeNote): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('saveEmployeeNote',eh);
    return this.http.post( this.serverUrl('saveEmployeeNote'), serial.prepareForJson(eh), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  deleteEmployeeNote(eh: EmployeeNote): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('deleteEmployeeNote',eh);
    return this.http.post( this.serverUrl('deleteEmployeeNote'), serial.prepareForJson(eh), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  getEmployeeNotes(employeeId:string): Promise<JSonResult<EmployeeNote[]>> {
   //this.traceService.sendTrace('getEmployeeNotes',{EMPLOYEE_ID:employeeId});

    return this.http.post( this.serverUrl('getEmployeeNotes'), {EMPLOYEE_ID:employeeId}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<EmployeeNote[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  notifyEmployees(aggregation: EmployeeToNotifyAggregation): Promise<JSonResult<number>> {
   //this.traceService.sendTrace('notifyEmployees',aggregation);
     return this.http.post( this.serverUrl('notifyEmployees'),aggregation, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }




  saveUserPreferencesAction(prefs: UserPreference[]): Promise<JSonResult<number>> {
   //this.traceService.sendTrace('saveUserPreferences',prefs);
    const serial = new JSonSerializer();
    return this.http.post( this.serverUrl('saveUserPreferences'), serial.prepareForJson(prefs), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }




  getEnterprisesAccessible(): Promise<JSonResult<EnterpriseAggregation>> {
   //this.traceService.sendTrace('getEnterprisesAccessibleForCurrentUser');
    return this.http.post( this.serverUrl('getEnterprisesAccessibleForCurrentUser'), {}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<EnterpriseAggregation>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  /**
   * Use the NO DB Action...
   */
  createPayFileAction(bean: WebPayRequest): Promise<JSonResult<string>> {
     const serial = new JSonSerializer();
   //this.traceService.sendTrace('createPayFile',bean);
    return this.http.post( this.serverUrl('createPayFile'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<string>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  createAndTransmitNethrisPayFile(bean: WebPayRequest): Promise<JSonResult<string>> {
   const serial = new JSonSerializer();
   //this.traceService.sendTrace('createAndTransmitNethrisPayFile',bean);
    return this.http.post( this.serverUrl('createAndTransmitNethrisPayFile'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<string>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  createAndSendSagesPayFile(bean: WebPayRequest): Promise<JSonResult<SagesResponse>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('createAndSendSagesPayFile',bean);
    return this.http.post( this.serverUrl('createAndSendSagesPayFile'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<SagesResponse>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }




  saveEnterprise(bean: Enterprise): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('saveEnterprise',bean);
    return this.http.post( this.serverUrl('saveEnterprise'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  createExportEmployeeFile(bean: WebExportEmployeeRequest): Promise<JSonResult<string>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('createExportEmployeeFile',bean);
    return this.http.post( this.serverUrl('createExportEmployeeFile'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<string>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }




  createAndSendExportEmployeeFile(bean: WebExportEmployeeRequest): Promise<JSonResult<string>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('createAndSendExportEmployeeFile',bean);
    return this.http.post( this.serverUrl('createAndSendExportEmployeeFile'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<string>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  createPaySummaryFile(bean: WebPayRequest): Promise<JSonResult<string>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('createPaySummaryFile',bean);

    return this.http.post( this.serverUrl('createPaySummaryFile'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<string>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  getEmployeeRightsAggregation(employeeId: string): Promise<JSonResult<EmployeeRightsAggregation>> {
   //this.traceService.sendTrace('getEmployeeRightsAggregation',{'EMPLOYEE_ID':employeeId});
    return this.http.post( this.serverUrl('getEmployeeRightsAggregation'), {'EMPLOYEE_ID':employeeId}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<EmployeeRightsAggregation>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  saveEmployeeRightsAggregation(bean: EmployeeRightsAggregation): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('saveEmployeeRightsAggregation',bean);
    return this.http.post( this.serverUrl('saveEmployeeRightsAggregation'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  getRawPayInformationPerEmployee(payPeriodStart: Date, employeeId: string): Promise<JSonResult<EmployeeRawPayInformation>> {
   //this.traceService.sendTrace('getRawPayInformationPerEmployee',{'EMPLOYEE_ID':employeeId, payPeriodStart: payPeriodStart});
    return this.http.post( this.serverUrl('getRawPayInformationPerEmployee'), {'EMPLOYEE_ID':employeeId, payPeriodStart: payPeriodStart}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<EmployeeRawPayInformation>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }




  saveCumulativeBonus(eh: CumulativeBonusAndUnitJobs): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('saveCumulativeBonus',eh);
    return this.http.post( this.serverUrl('saveCumulativeBonus'), serial.prepareForJson(eh), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  deleteCumulativeBonus(id: number): Promise<JSonResult<number>> {
   //this.traceService.sendTrace('deleteCumulativeBonus',{id:id});
    return this.http.post( this.serverUrl('deleteCumulativeBonus'), {id:id}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  saveJobBonus(eh: JobBonus): Promise<JSonResult<number>> {
     const serial = new JSonSerializer();
   //this.traceService.sendTrace('saveJobBonus',eh);
    return this.http.post( this.serverUrl('saveJobBonus'), serial.prepareForJson(eh), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  deleteJobBonus(id: number): Promise<JSonResult<number>> {
   //this.traceService.sendTrace('deleteJobBonus',{id:id});
    return this.http.post( this.serverUrl('deleteJobBonus'), {id:id}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  getAvailableBonus(): Promise<JSonResult<BonusAggregation>> {
   //this.traceService.sendTrace('getAvailableBonus');
    return this.http.post( this.serverUrl('getAvailableBonus'), {}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<BonusAggregation>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }




  getAccessibleDivisions(): Promise<JSonResult<Unit[]>> {
   //this.traceService.sendTrace('getAccessibleDivisions');
    return this.http.post( this.serverUrl('getAccessibleDivisions'), {}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<Unit[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  getFormatForEmployeeFormat1Import(): Promise<JSonResult<FormatDescription[]>> {
   //this.traceService.sendTrace('getFormatForEmployeeFormat1Import');
    return this.http.post( this.serverUrl('getFormatForEmployeeFormat1Import'), {}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<FormatDescription[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }




  getEmployeeFromNethris(bean:SearchEmployeeRequest): Promise<JSonResult<CreateNewEmployee[]>> {
   const serial = new JSonSerializer();
   //this.traceService.sendTrace('getEmployeeFromNethris',bean);
   return this.http.post( this.serverUrl('getEmployeeFromNethris'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<CreateNewEmployee[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }




  getMatchingEmployeeByMatriculeFromNethris(bean:SearchEmployeeRequest): Promise<JSonResult<MatchingEmployeeResult>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('getMatchingEmployeeByMatriculeFromNethris',bean);
    return this.http.post( this.serverUrl('getMatchingEmployeeByMatriculeFromNethris'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<MatchingEmployeeResult>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  importEmployeeFormat1(divisionCode: string, dataAsCSV: string): Promise<JSonResult<Unit[]>> {
   //this.traceService.sendTrace('importEmployeeFormat1');

    return this.http.post( this.serverUrl('importEmployeeFormat1'), {dataCSV: dataAsCSV,unitId: divisionCode}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<Unit[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  getExcelSampleForEmployeeFormat1(): Promise<JSonResult<string>> {
   //this.traceService.sendTrace('getExcelSampleForEmployeeFormat1');

    return this.http.post( this.serverUrl('getExcelSampleForEmployeeFormat1'),{}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<string>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  exportEmployeeSchedulesToExcel(bean:ExportEmployeeScheduleBean): Promise<JSonResult<string>> {
  const serial = new JSonSerializer();
   //this.traceService.sendTrace('exportEmployeeSchedulesToExcel',bean);

    return this.http.post( this.serverUrl('exportEmployeeSchedulesToExcel'),serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
     .toPromise()
     .then((response) => {
        return response as JSonResult<string>;
      },
    (rejected) => { return this._handleRejected(rejected); }
  );
}

  printTimesheets(bean: TimesheetEmployeeHoraireBean): Promise<JSonResult<string>> {
    const serial = new JSonSerializer();
    // const tmp = new Array<EmployeeHoraire>();
    // for (const b of beans){
    //   tmp.push(serial.prepareForJson(b));
    // }
   //this.traceService.sendTrace('printTimesheets',bean);

    return this.http.post( this.serverUrl('printTimesheets'),serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<string>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  printPlanning(bean:ExportPlanningBean): Promise<JSonResult<string>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('printPlanning',bean);

    return this.http.post( this.serverUrl('printPlanning'),serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<string>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  //this.clientService.printTimesheets(employeeHoraires).then(


  getSchedulePrintConfig(): Promise<JSonResult<SchedulePrintConfig>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('getSchedulePrintConfig');

    return this.http.post( this.serverUrl('getSchedulePrintConfig'), {}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<SchedulePrintConfig>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  loginNoServerCheck(username: string, password: string): Promise<JSonResult<UserInfo>> {


    return this.loadConfiguration().then(
      (serverConfig) => {
        this.sessionService.serverConfiguration = serverConfig;
        return this.internalLogin(username, password);
      }
    );

  }


  getMoreInfoEmployeeFromNethris(bean:StandardEmployeeRequest): Promise<JSonResult<CreateNewEmployee>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('getMoreInfoEmployeeFromNethris',bean);
    return this.http.post( this.serverUrl('getMoreInfoEmployeeFromNethris'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<CreateNewEmployee>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  getEmployeeBanksFromNethris(bean:EmployeeBanksRequest): Promise<JSonResult<EntityEmployeeBanks[]>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('getEmployeeBanksFromNethris',bean);
    return this.http.post( this.serverUrl('getEmployeeBanksFromNethris'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<EntityEmployeeBanks[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  updateSomeInfoToNethris(bean:UpdateSomeInfoRequest): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('updateSomeInfoToNethris',bean);
    return this.http.post( this.serverUrl('updateSomeInfoToNethris'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  exportStructureToExcel(unitId: string,includeUniqueIds=false): Promise<JSonResult<string>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('exportStructureToExcel',{unitId: unitId});
    return this.http.post( this.serverUrl('exportStructureToExcel'),{unitId: unitId,includeUniqueIds:includeUniqueIds}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<string>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  saveMessageOnPunch(bean: MessageForPunch): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('saveMessageOnPunch',bean);
    return this.http.post( this.serverUrl('saveMessageOnPunch'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  deleteMessageOnPunch(messageId: number): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('deleteMessageOnPunch',{ids:[messageId]});

    return this.http.post( this.serverUrl('deleteMessageOnPunch'), {ids:[messageId]}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  getMessagesOnPunchForDivisions(divisionsId:string[]): Promise<JSonResult<MessageForPunch[]>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('getMessagesOnPunchForDivisions',{ids:divisionsId});
    return this.http.post( this.serverUrl('getMessagesOnPunchForDivisions'), {ids:divisionsId}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<MessageForPunch[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  getVacationRecord(bean:CreateVacationRecordRequest): Promise<JSonResult<CreateVacationRecordAggregation[]>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('getVacationRecord',bean);

    return this.http.post( this.serverUrl('getVacationRecord'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<CreateVacationRecordAggregation[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  saveVacationRecord(bean:CreateVacationRecordAggregation): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('saveVacationRecord',bean);

    return this.http.post( this.serverUrl('saveVacationRecord'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


    deleteVacationRecord(bean:DeleteVacationRecordAggregation): Promise<JSonResult<number>> {
        const serial = new JSonSerializer();
       //this.traceService.sendTrace('deleteVacationRecord',bean);

        return this.http.post( this.serverUrl('deleteVacationRecord'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
            .toPromise()
            .then((response) => {
                    return response as JSonResult<number>;
                },
                (rejected) => { return this._handleRejected(rejected); }
            );
    }





    getSickDaysRecord(bean:CreateSickDaysRequest): Promise<JSonResult<CreateSickDaysAggregation[]>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('getSickDaysRecord',bean);

    return this.http.post( this.serverUrl('getSickDaysRecord'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<CreateSickDaysAggregation[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  saveSickDaysRecord(bean:CreateSickDaysAggregation): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('saveSickDaysRecord',bean);
    return this.http.post( this.serverUrl('saveSickDaysRecord'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


    deleteSickDaysRecord(bean:DeleteSickDaysAggregation): Promise<JSonResult<number>> {
        const serial = new JSonSerializer();
       //this.traceService.sendTrace('deleteSickDaysRecord',bean);
        return this.http.post( this.serverUrl('deleteSickDaysRecord'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
            .toPromise()
            .then((response) => {
                    return response as JSonResult<number>;
                },
                (rejected) => { return this._handleRejected(rejected); }
            );
    }




    getSalaryAdjustmentRecord(bean:CreateSalaryAdjustmentRequest): Promise<JSonResult<CreateSalaryAdjustmentAggregation[]>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('getSalaryAdjustmentRecord',bean);
    return this.http.post( this.serverUrl('getSalaryAdjustmentRecord'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<CreateSalaryAdjustmentAggregation[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  saveSalaryAdjustmentRecord(bean:CreateSalaryAdjustmentAggregation): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('saveSalaryAdjustmentRecord',bean);
    return this.http.post( this.serverUrl('saveSalaryAdjustmentRecord'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  sendEmployeeCredentialsByEmail(employeeId: string,credentialsFormat: string): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('sendEmployeeCredentialsByEmail',{EMPLOYEE_ID:employeeId,credentialsFormat:credentialsFormat});
    return this.http.post( this.serverUrl('sendEmployeeCredentialsByEmail'), {EMPLOYEE_ID:employeeId,credentialsFormat:credentialsFormat}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  printEmployeeCredentialsPDF(model: WelcomeEmployeeRequest[]): Promise<JSonResult<string>> {
    const serial = new JSonSerializer();
    return this.http.post( this.serverUrl('printEmployeeCredentialsPDF'), serial.prepareForJson(model), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<string>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  sendEmployeeCredentialsByEmailMore(employeeId: string, email: string, forceNewPasswordNextLogin: boolean, credentialsFormat: string): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("sendEmployeeCredentialsByEmail",{EMPLOYEE_ID: employeeId, forceNewPasswordAtNextLogin: forceNewPasswordNextLogin, email: email, credentialsFormat: credentialsFormat});
    return this.http.post( this.serverUrl('sendEmployeeCredentialsByEmail'), {EMPLOYEE_ID: employeeId, forceNewPasswordAtNextLogin: forceNewPasswordNextLogin, email: email, credentialsFormat: credentialsFormat}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  sendUrlForCalendar(employeeId: string): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('sendUrlForCalendar',{EMPLOYEE_ID:employeeId});
    return this.http.post( this.serverUrl('sendUrlForCalendar'), {EMPLOYEE_ID:employeeId}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  retrieveUrlForCalendar(employeeId: string): Promise<JSonResult<string>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('retrieveUrlForCalendar');
    return this.http.post( this.serverUrl('retrieveUrlForCalendar'), {EMPLOYEE_ID:employeeId}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<string>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  getExportableEmployee(bean: WebExportEmployeeRequest): Promise<JSonResult<ExportableEmployee[]>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('getExportableEmployee',bean);
    return this.http.post( this.serverUrl('getExportableEmployee'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<ExportableEmployee[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  getEmployeeWithExternalId(): Promise<JSonResult<Employee[]>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('getEmployeeWithExternalId');
    return this.http.post( this.serverUrl('getEmployeeWithExternalId'), {}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<Employee[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  getEmployeeWithExternalIdForSameEnterprise(bean: StandardEmployeeRequest): Promise<JSonResult<Employee[]>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('getEmployeeWithExternalIdForSameEnterprise',bean);

    return this.http.post( this.serverUrl('getEmployeeWithExternalIdForSameEnterprise'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<Employee[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  getEmployeeWithExternalIdForMultipleEnterprises(enterprises: Enterprise[]): Promise<JSonResult<Employee[]>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('getEmployeeWithExternalIdForMultipleEnterprises',enterprises);

    return this.http.post( this.serverUrl('getEmployeeWithExternalIdForMultipleEnterprises'), serial.prepareForJson(enterprises), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<Employee[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  getEmployeeWithExternalId2ForSameEnterprise(bean: StandardEmployeeRequest): Promise<JSonResult<Employee[]>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('getEmployeeWithExternalId2ForSameEnterprise',bean);

    return this.http.post( this.serverUrl('getEmployeeWithExternalId2ForSameEnterprise'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<Employee[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  getEmployeeWithExternalId2ForMultipleEnterprises(enterprises: Enterprise[]): Promise<JSonResult<Employee[]>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('getEmployeeWithExternalId2ForMultipleEnterprises',enterprises);

    return this.http.post( this.serverUrl('getEmployeeWithExternalId2ForMultipleEnterprises'), serial.prepareForJson(enterprises), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<Employee[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  retrieveAndUpdateEmployeeWithNethrisInformation(bean: UpdateMultipleEmployeeWithOptionsToUpdateFromCGIRequest[]): Promise<JSonResult<JSonResult<string>[]>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('retrieveAndUpdateEmployeeWithNethrisInformation',bean);
    return this.http.post( this.serverUrl('retrieveAndUpdateEmployeeWithNethrisInformation'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<JSonResult<string>[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  retrieveAndUpdateEmployeeWithFolksInformation(bean: UpdateMultipleEmployeeWithOptionsToUpdateFromFolksRequest[]): Promise<JSonResult<JSonResult<string>[]>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('retrieveAndUpdateEmployeeWithFolksInformation',bean);
    return this.http.post( this.serverUrl('retrieveAndUpdateEmployeeWithFolksInformation'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<JSonResult<string>[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  /*

    retrieveAndUpdateEmployeeWithNethrisInformation(bean: StandardMutlipleEmployeeRequest): Promise<JSonResult<JSonResult<string>[]>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('retrieveAndUpdateEmployeeWithNethrisInformation',bean);
    return this.http.post( this.serverUrl('retrieveAndUpdateEmployeeWithNethrisInformation'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<JSonResult<string>[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


   */

  getEmployeeVacationAggregation(employeeId: string, refDt:moment.Moment): Promise<JSonResult<EmployeeVacationAggregation>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('getEmployeeVacationAggregation',{EMPLOYEE_ID:employeeId,refDt: refDt});
    return this.http.post( this.serverUrl('getEmployeeVacationAggregation'), {EMPLOYEE_ID:employeeId,refDt: refDt}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<EmployeeVacationAggregation>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  addEmployeeVacation(bean: EmployeeVacationRange) : Promise<JSonResult<JSonResult<number>>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('addEmployeeVacation',bean);

    return this.http.post( this.serverUrl('addEmployeeVacation'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<JSonResult<number>>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  deleteEmployeeVacationRange(eh: EmployeeHoraire): Promise<JSonResult<ResultWithNumberIds>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('deleteEmployeeVacation',eh);

    return this.http.post( this.serverUrl('deleteEmployeeVacation'), serial.prepareForJson(eh),  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<ResultWithNumberIds>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  /*
  deleteEmployeeVacation() : Promise<JSonResult<JSonResult<number>>> {
    const serial = new JSonSerializer();
    return this.http.post( this.serverUrl('deleteEmployeeVacation'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<JSonResult<number>>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }
  */


  getEmployeeSkills(employeeId: string): Promise<JSonResult<EmployeeSkill[]>> {
   //this.traceService.sendTrace('getEmployeeSkills',{EMPLOYEE_ID: employeeId});
    return this.http.post( this.serverUrl('getEmployeeSkills'), {EMPLOYEE_ID: employeeId},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<EmployeeSkill[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  deleteEmployeeSkill(eh: EmployeeSkill): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('deleteEmployeeSkill',eh);

    return this.http.post( this.serverUrl('deleteEmployeeSkill'), serial.prepareForJson(eh),  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  saveEmployeeSkill (eh: EmployeeSkill): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('saveEmployeeSkill',eh);
    return this.http.post( this.serverUrl('saveEmployeeSkill'), serial.prepareForJson(eh),  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {

          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  updateMatchedEmployeeWithNethrisInformation(bean: UpdateMatchingEmployeeWithMatriculeRequest): Promise<JSonResult<JSonResult<string>[]>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('updateMatchedEmployeeWithNethrisInformation',bean);
    return this.http.post( this.serverUrl('updateMatchedEmployeeWithNethrisInformation'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<JSonResult<string>[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  changeTimeZoneInSession(tz: string): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('changeTimeZoneInSession',{tz:tz});
    return this.http.post( this.serverUrl('changeTimeZoneInSession'), {tz:tz}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  getAllActiveCustomReport(): Promise<JSonResult<CustomReport[]>> {
   //this.traceService.sendTrace('getAllActiveCustomReport');
    return this.http.post( this.serverUrl('getAllActiveCustomReport'), {},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          //
          return response as JSonResult<CustomReport[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  getUnitsAssociatedWithAnEmployeAndHisManagers(employeeId: string): Promise<JSonResult<Unit[]>> {
   //this.traceService.sendTrace('getUnitsAssociatedWithAnEmployeAndHisManagers',{'EMPLOYEE_ID':employeeId});
    return this.http.post( this.serverUrl('getUnitsAssociatedWithAnEmployeAndHisManagers'), {'EMPLOYEE_ID':employeeId},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<Unit[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  getUnitsThatCanContainJobs(employeeId: string): Promise<JSonResult<Unit[]>> {
   //this.traceService.sendTrace('getUnitsThatCanContainJobs',{'EMPLOYEE_ID':employeeId});
    return this.http.post( this.serverUrl('getUnitsThatCanContainJobs'), {'EMPLOYEE_ID':employeeId},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<Unit[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  login(username: string, password: string): Promise<JSonResult<UserInfo>> {

        return this.findServerUrlForUsername(username).then((serverConfigurationForUser)=>{

            return this.internalLogin(username, password);
            /*
            return this.loadConfiguration().then(
              (serverConfig) => {
                this.session.serverConfiguration = serverConfig;

                return this.internalLogin(username, password);
              }
            );
            */
        },
          (rejected)=>{return {success:false, description: rejected + ''}}
        );

    }




  remoteLoginClient(token: string) :  Promise<JSonResult<UserInfo>> {
   //this.traceService.sendTrace('remoteLoginClient',{token:token});
    return this.loadConfiguration().then(
      (serverConfig) => {
        this.sessionService.serverConfiguration = serverConfig;

        return this.internalRemoteLoginClient(token);
      },
      (rejected)=>{return {success:false, description: rejected + ''}}
    );
    /*
    return this.findServerUrlForUsername(username).then((serverConfigurationForUser)=>{

        return this.internalLogin(username, password);
      },
      (rejected)=>{return {success:false, description: rejected + ''}}
    );
    */

  }


  private internalRemoteLoginClient(token: string): Promise<JSonResult<UserInfo>> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    // const options = new RequestOptions({ headers: headers, withCredentials:true });

    const timeZone = momentTz.tz.guess();


    /*
    return this.http.post<JSonResult<UserInfo>>( this.serverUrl('loginClient'),
      JSON.stringify({user: username, pwd: pwd, tz: timeZone }), { headers: headers,observe:'response', withCredentials:true } )
      // JSON.stringify({user: username, pwd: pwd, tz: 'America/Montreal' }), options )
      .toPromise()
      .then((response: HttpResponse<JSonResult<UserInfo>>) => {
          this._retrieveAndStoreXSRFToken(response);
          //
          return response.body as JSonResult<UserInfo>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );

     */

    return this.http.post<JSonResult<UserInfo>>( this.serverUrl('remoteLoginClient'),
      JSON.stringify({RemoteLoginToken: token, tz: timeZone }), { headers: headers,observe:'response', withCredentials:true } )
      .toPromise()
      .then((response: HttpResponse<JSonResult<UserInfo>>) => {
          this._retrieveAndStoreXSRFToken(response);

          return response.body as JSonResult<UserInfo>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  changeAndSendLostPassword(username: string): Promise<JSonResult<string>> {
    return this.findServerUrlForUsername(username).then((serverConfigurationForUser)=>{

        // this.traceService.sendTrace('changeAndSendLostPassword',null,username);
        return this.internalChangeAndSendLostPassword(username);
      },
      (rejected)=>{return {success:false, description: rejected + ''}}
    );

  }

  findServerUrlForUsername(username: string): Promise<JSonResult<ServerConfigurationForUser>>{


    return this.loadConfiguration().then(
      (serverConfig) => {
        this.sessionService.serverConfiguration = serverConfig;

        //
        const headers = new HttpHeaders({ 'Content-Type': 'application/json','Access-Control-Allow-Origin':'*'});
        // const options = new RequestOptions({ headers: headers });
        const serializer = new JSonSerializer();
        return this.http.post<JSonResult<ServerConfigurationForUser>>( this.serverUrl('findServerUrlForUsername'), {user:username} , { headers: headers } )
          .toPromise()
          .then((response) => {
              // this.traceService.sendTrace('findServerUrlForUsername',null,username);
              //
              return response;
            },
            (rejected) => { return this._handleRejected(rejected); }
          );

      }
    );

  }



  createNewUser(employeeId: string): Promise<JSonResult<User>> {
   //this.traceService.sendTrace('createNewUser',{'EMPLOYEE_ID':employeeId});
    return this.http.post( this.serverUrl('createNewUser'), {'EMPLOYEE_ID':employeeId},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          //
          return response as JSonResult<User>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  getEmployeesByEnterpriseOrNameOrUnit(bean:AddJobRequest): Promise<JSonResult<CreateSalaryAdjustmentAggregation[]>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('getEmployeesByEnterpriseOrNameOrUnit',bean);
    return this.http.post( this.serverUrl('getEmployeesByEnterpriseOrNameOrUnit'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<CreateSalaryAdjustmentAggregation[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }
  //bean.data.data.id,this.jobToAdd.job.jobId,this.jobToAdd.unit.unitCode


  // getEmployeesPaidByEnterpriseAndWithJobActive(bean:AddOrModifyBonusRequest): Promise<JSonResult<CreateSalaryAdjustmentAggregation[]>> {
  getEmployeesPaidByEnterpriseAndWithJobActive(bean:AddOrModifyBonusRequest): Promise<JSonResult<EmployeePositionAggregation>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('getEmployeesPaidByEnterpriseAndWithJobActive',bean);
    return this.http.post( this.serverUrl('getEmployeesPaidByEnterpriseAndWithJobActive'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<EmployeePositionAggregation>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }
  //bean.data.data.id,this.jobToAdd.job.jobId,this.jobToAdd.unit.unitCode


  saveNewJob(employeeId: string, jobId: string, unitId: string, defaultJob: boolean, bonus1:number, bonus2:number, bonus3:number, bonus4:number, bonus5:number,
             bonus6:number, bonus7:number, bonus8:number, bonus9:number, bonus10:number,
             bonus11:number, bonus12:number, bonus13:number, bonus14:number, bonus15:number,
             bonus16:number, bonus17:number, bonus18:number, bonus19:number, bonus20:number,
             jobBonus: number,modifyExportPayCodes = true): Promise<JSonResult<number>> {
    return this.http.post( this.serverUrl('saveNewJob'), {'EMPLOYEE_ID':employeeId,jobId: jobId, unitId: unitId,defaultJob: defaultJob,
      bonus1:bonus1,bonus2:bonus2,bonus3:bonus3,bonus4:bonus4,
      bonus5:bonus5,bonus6:bonus6,bonus7:bonus7,bonus8:bonus8,bonus9:bonus9,bonus10:bonus10,
      bonus11:bonus11,bonus12:bonus12,bonus13:bonus13,bonus14:bonus14,
      bonus15:bonus15,bonus16:bonus16,bonus17:bonus17,bonus18:bonus18,bonus19:bonus19,bonus20:bonus20,
      jobBonus:jobBonus,modifyExportPayCodes:modifyExportPayCodes},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {

          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  /*
  addCumulativeBonusIfNecessary(employeeId: string, bonus1:number, bonus2:number, bonus3:number, bonus4:number, bonus5:number, bonus6:number, bonus7:number, bonus8:number,bonus9:number,bonus10:number,customPremiums:CustomPremiumConfigurationForEmployee[]): Promise<JSonResult<number>> {
   //this.traceService.sendTrace('addCumulativeBonusIfNecessary',{'EMPLOYEE_ID':employeeId, bonus1:bonus1,bonus2:bonus2,bonus3:bonus3,bonus4:bonus4,bonus5:bonus5,bonus6:bonus6,bonus7:bonus7,bonus8:bonus8,bonus9:bonus9,bonus10:bonus10,customPremiums});
    return this.http.post( this.serverUrl('addCumulativeBonusIfNecessary'), {'EMPLOYEE_ID':employeeId, bonus1:bonus1,bonus2:bonus2,bonus3:bonus3,bonus4:bonus4,bonus5:bonus5,
      bonus6:bonus6,bonus7:bonus7,bonus8:bonus8,bonus9:bonus9,bonus10:bonus10,customPremiums:customPremiums},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {

          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

   */

  addCumulativeBonusIfNecessary(bean: CumulativeBonusToAdd): Promise<JSonResult<number>> {
    return this.http.post( this.serverUrl('addCumulativeBonusIfNecessary'), bean,  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {

          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  removeCumulativeBonusIfNecessary(employeeId: string, bonus1:number, bonus2:number, bonus3:number, bonus4:number,bonus5:number, bonus6:number, bonus7:number, bonus8:number,bonus9:number,bonus10:number): Promise<JSonResult<number>> {
   //this.traceService.sendTrace('removeCumulativeBonusIfNecessary',{'EMPLOYEE_ID':employeeId, bonus1:bonus1,bonus2:bonus2,bonus3:bonus3,bonus4:bonus4,bonus5:bonus5,bonus6:bonus6,bonus7:bonus7,bonus8:bonus8,bonus9:bonus9,bonus10:bonus10});
    return this.http.post( this.serverUrl('removeCumulativeBonusIfNecessary'), {'EMPLOYEE_ID':employeeId, bonus1:bonus1,bonus2:bonus2,bonus3:bonus3,bonus4:bonus4,bonus5:bonus5,bonus6:bonus6,bonus7:bonus7,bonus8:bonus8,bonus9:bonus9,bonus10:bonus10},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {

          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  getSpifByEmployeeAndDates(employeeId:string,startDate: moment.Moment,endDate: moment.Moment): Promise<JSonResult<EmployeeSpif[]>>{
   //this.traceService.sendTrace('getSpifByEmployeeAndDates',{'EMPLOYEE_ID':employeeId,fromDt: startDate,toDt: endDate});
    return this.http.post( this.serverUrl('getSpifByEmployeeAndDates'), {'EMPLOYEE_ID':employeeId,fromDt: startDate,toDt: endDate},
      this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<EmployeeSpif[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );

  }
  deleteEmployeeSpif(bean: EmployeeSpif): Promise<JSonResult<number>> {
   //this.traceService.sendTrace('deleteEmployeeSpif',{id:bean.id});
    return this.http.post( this.serverUrl('deleteEmployeeSpif'), {id:bean.id}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  saveEmployeeSpif(bean: EmployeeSpif): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('saveEmployeeSpif',bean);
    return this.http.post( this.serverUrl('saveEmployeeSpif'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  getAvailableSpifType(): Promise<JSonResult<SpifTypeAggregation[]>>{
   //this.traceService.sendTrace('getAvailableSpifType');
    return this.http.post( this.serverUrl('getAvailableSpifType'), {},
      this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<SpifTypeAggregation[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );

  }

  saveSpifType(bean: SpifTypeAggregation): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('saveSpifType',bean);
    return this.http.post( this.serverUrl('saveSpifType'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  deleteSpifType(bean: SpifType): Promise<JSonResult<number>> {
   //this.traceService.sendTrace('deleteSpifType',{id:bean.id});
    return this.http.post( this.serverUrl('deleteSpifType'),{id:bean.id}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  applyTimesheetParamsToEmployeeFromEnterprise(bean:TimesheetParamsAndEnterpriseId): Promise<JSonResult<number>>{

    const serial = new JSonSerializer();
   //this.traceService.sendTrace('applyTimesheetParamsToEmployeeFromEnterprise',bean);
    return this.http.post( this.serverUrl('applyTimesheetParamsToEmployeeFromEnterprise'),serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );

  }


  applyTimesheetParamsToOneEmployee(bean:TimesheetParamsAndEmployeeId): Promise<JSonResult<number>>{

    const serial = new JSonSerializer();
    return this.http.post( this.serverUrl('applyTimesheetParamsToOneEmployee'),serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );

  }

  applyScheduleParamsToEmployeeFromEnterprise(bean:ScheduleParamsAndEnterpriseId): Promise<JSonResult<number>>{

    const serial = new JSonSerializer();
   //this.traceService.sendTrace('applyScheduleParamsToEmployeeFromEnterprise',bean);
    return this.http.post( this.serverUrl('applyScheduleParamsToEmployeeFromEnterprise'),serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );

  }




  applyScheduleParamsToOneEmployee(bean:ScheduleParamsAndEmployeeId): Promise<JSonResult<number>>{

    const serial = new JSonSerializer();
    //this.traceService.sendTrace('applyPortalParamsToEmployeeFromEnterprise',bean);
    return this.http.post( this.serverUrl('applyScheduleParamsToOneEmployee'),serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );

  }



  applyPunchParamsToEmployeeFromEnterprise(bean:PunchParamsAndEnterpriseId): Promise<JSonResult<number>>{

    const serial = new JSonSerializer();
   //this.traceService.sendTrace('applyPunchParamsToEmployeeFromEnterprise',bean);
    return this.http.post( this.serverUrl('applyPunchParamsToEmployeeFromEnterprise'),serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );

  }



  applyPunchParamsToOneEmployee(bean:PunchParamsAndEmployeeId): Promise<JSonResult<number>>{

    const serial = new JSonSerializer();
    //this.traceService.sendTrace('applyPunchParamsToEmployeeFromEnterprise',bean);
    return this.http.post( this.serverUrl('applyPunchParamsToOneEmployee'),serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );

  }

  applyPortalParamsToEmployeeFromEnterprise(bean:PortalParamsAndEnterpriseId): Promise<JSonResult<number>>{

    const serial = new JSonSerializer();
   //this.traceService.sendTrace('applyPortalParamsToEmployeeFromEnterprise',bean);
    return this.http.post( this.serverUrl('applyPortalParamsToEmployeeFromEnterprise'),serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );

  }


  applyPortalParamsToOneEmployee(bean:PortalParamsAndEmployeeId): Promise<JSonResult<number>>{

    const serial = new JSonSerializer();
    //this.traceService.sendTrace('applyPortalParamsToEmployeeFromEnterprise',bean);
    return this.http.post( this.serverUrl('applyPortalParamsToOneEmployee'),serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );

  }




  notifyEmployeesWithFreeText(beans:NotifyEmployeeWithFreeText[]): Promise<JSonResult<number>>{

    const serial = new JSonSerializer();
   //this.traceService.sendTrace('notifyEmployeesWithFreeText',beans);
    return this.http.post( this.serverUrl('notifyEmployeesWithFreeText'),serial.prepareForJson(beans), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );

  }



  getEstablishmentProgress(): Promise<JSonResult<EstablishmentProgress>> {
   //this.traceService.sendTrace('getEstablishmentProgress');
    return this.http.post( this.serverUrl('getEstablishmentProgress'), {}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<EstablishmentProgress>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  deleteTimedTaskGroupAggregation(bean: TimedTaskGroupAggregation): Promise<JSonResult<number>> {
    const serializer = new JSonSerializer();
   //this.traceService.sendTrace('deleteTimedTaskGroupAggregation',bean);
    return this.http.post( this.serverUrl('deleteTimedTaskGroupAggregation'), serializer.prepareForJson(bean),  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {

          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  deleteTimedTask(bean: TimedTask): Promise<JSonResult<number>> {
    const serializer = new JSonSerializer();
   //this.traceService.sendTrace('deleteTimedTask',bean);
    return this.http.post( this.serverUrl('deleteTimedTask'), serializer.prepareForJson(bean),  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {

          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  deleteTimedTaskGroupUser(bean: TimedTaskGroupUser): Promise<JSonResult<number>> {
    const serializer = new JSonSerializer();
   //this.traceService.sendTrace('deleteTimedTaskGroupUser',bean);
    return this.http.post( this.serverUrl('deleteTimedTaskGroupUser'), serializer.prepareForJson(bean),  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {

          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  getEmployeeTimedTaskGroupAggregation(start:moment.Moment, end: moment.Moment, id: number,includeWages: boolean): Promise<JSonResult<EmployeeTimedTaskGroupAggregation>> {
   //this.traceService.sendTrace('getEmployeeTimedTaskGroupAggregation',{id:id, includeWages: includeWages});
    return this.http.post( this.serverUrl('getEmployeeTimedTaskGroupAggregation'), {fromDt: start, toDt: end,id:id, includeWages: includeWages},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<EmployeeTimedTaskGroupAggregation>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  getAccessibleTimedTaskGroupAggregation(includeInactive: boolean): Promise<JSonResult<TimedTaskGroupAggregation[]>> {
   //this.traceService.sendTrace('getAccessibleTimedTaskGroupAggregation',{includeInactive:includeInactive});
    return this.http.post( this.serverUrl('getAccessibleTimedTaskGroupAggregation'), {includeInactive:includeInactive},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<TimedTaskGroupAggregation[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  saveTimedTaskGroupAggregation(bean: TimedTaskGroupAggregation): Promise<JSonResult<number>> {
    const serializer = new JSonSerializer();
   //this.traceService.sendTrace('saveTimedTaskGroupAggregation',bean);
    return this.http.post( this.serverUrl('saveTimedTaskGroupAggregation'), serializer.prepareForJson(bean),  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  saveTimedTaskGroupAggregationAndEmployeeTimedTask(bean: TimedTaskGroupAggregation): Promise<JSonResult<number>> {
    const serializer = new JSonSerializer();
    //this.traceService.sendTrace('saveTimedTaskGroupAggregation',bean);
    return this.http.post( this.serverUrl('saveTimedTaskGroupAggregationAndEmployeeTimedTask'), serializer.prepareForJson(bean),  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  getUnitAggregation(id: string): Promise<JSonResult<UnitAggregation>> {
   //this.traceService.sendTrace('getUnitAggregation',{id:id});
    return this.http.post( this.serverUrl('getUnitAggregation'), {id:id}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<UnitAggregation>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  deleteThisJob(jobId:string,unitId: string): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('deleteThisJob',{jobId: jobId, unitId: unitId});
    return this.http.post( this.serverUrl('deleteThisJob'), {jobId: jobId, unitId: unitId}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  selectEmployeeForRightOnUnit(unitId: string): Promise<JSonResult<Employee[]>> {
   //this.traceService.sendTrace('selectEmployeeForRightOnUnit',{unitId:unitId});
    return this.http.post( this.serverUrl('selectEmployeeForRightOnUnit'), {unitId:unitId}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<Employee[]>;

        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  deleteUnitForSysAdmin(bean: Unit): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('deleteUnitForSysAdmin',bean);
    return this.http.post( this.serverUrl('deleteUnitForSysAdmin'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  deleteUnitAndJobsForSysAdmin(bean: Unit): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('deleteUnitAndJobsForSysAdmin',bean);
    return this.http.post( this.serverUrl('deleteUnitAndJobsForSysAdmin'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  moveJobFromUnitToAnotherUnit(jobId: string, fromUnitId:string, toUnitId: string): Promise<JSonResult<number>> {
   //this.traceService.sendTrace('moveJobFromUnitToAnotherUnit',{jobId:jobId,fromUnitId:fromUnitId,toUnitId:toUnitId});
    return this.http.post( this.serverUrl('moveJobFromUnitToAnotherUnit'), {jobId:jobId,fromUnitId:fromUnitId,toUnitId:toUnitId},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  addRightToUnitForEmployees(employeeIds: string[], unitId: string[]): Promise<JSonResult<number>> {
   //this.traceService.sendTrace('addRightToUnitForEmployees',{ids:employeeIds, unitId: unitId});
    return this.http.post( this.serverUrl('addRightToUnitForEmployees'), {ids:employeeIds, unitId: unitId}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  removeEmployeeRightOnUnit(employeeId: string, unitId: string[]): Promise<JSonResult<UnitAggregation>> {
   //this.traceService.sendTrace('removeEmployeeRightOnUnit',{EMPLOYEE_ID:employeeId, unitId: unitId});
    return this.http.post( this.serverUrl('removeEmployeeRightOnUnit'), {EMPLOYEE_ID:employeeId, unitId: unitId}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<UnitAggregation>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  getNbDistinctEmployeeWithSchedulesForDivisionPerUnitOfTime(id: string, nbMonth: number): Promise<JSonResult<NbDistinctEmployeeWithSchedulesPerUnitOfTime[]>> {
   //this.traceService.sendTrace('getNbDistinctEmployeeWithSchedulesForDivisionPerUnitOfTime',{unitId:id,nbMonth:nbMonth});
    return this.http.post( this.serverUrl('getNbDistinctEmployeeWithSchedulesForDivisionPerUnitOfTime'), {unitId:id,nbMonth:nbMonth}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<NbDistinctEmployeeWithSchedulesPerUnitOfTime[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  getUniqueEmployeeWithScheduleBetweenDatesXls1062(divisionId: string, from: moment.Moment, to: moment.Moment): Promise<JSonResult<string>> {
   //this.traceService.sendTrace('getUniqueEmployeeWithScheduleBetweenDatesXls1062',{unitId:divisionId,fromDt:from, toDt: to});
    return this.http.post( this.serverUrl('getUniqueEmployeeWithScheduleBetweenDatesXls1062'), {unitId:divisionId,fromDt:from, toDt: to}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<string>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  getUniqueEmployeeWithApprovedTimesheetBetweenDatesXls1063(enterpriseId: number, from: moment.Moment, to: moment.Moment): Promise<JSonResult<string>> {
   //this.traceService.sendTrace('getUniqueEmployeeWithApprovedTimesheetBetweenDatesXls1063',{enterpriseId:enterpriseId,fromDt:from, toDt: to});
    return this.http.post( this.serverUrl('getUniqueEmployeeWithApprovedTimesheetBetweenDatesXls1063'), {enterpriseId:enterpriseId,fromDt:from, toDt: to}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<string>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  /*
  saveDivisionForSysAdmin(bean: Unit): Promise<JSonResult<string>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('saveDivisionForSysAdmin',bean);
    return this.http.post( this.serverUrl('saveDivisionForSysAdmin'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<string>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }
  */

  saveDivisionForSysAdmin(bean: SaveDivisionRequest): Promise<JSonResult<string>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('saveDivisionForSysAdmin',bean);
    return this.http.post( this.serverUrl('saveDivisionForSysAdmin'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<string>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }




  createNewJobAndUnitInfoForSysAdmin(bean: JobAndUnitInfo): Promise<JSonResult<string>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('createNewJobAndUnitInfoForSysAdmin',bean);
    return this.http.post( this.serverUrl('createNewJobAndUnitInfoForSysAdmin'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<string>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  applyExportCodesToAllEmployeeWithSameJobAndUnitForSysAdmin(bean: JobAndUnitInfo): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('applyExportCodesToAllEmployeeWithSameJobAndUnitForSysAdmin',bean);
    return this.http.post( this.serverUrl('applyExportCodesToAllEmployeeWithSameJobAndUnitForSysAdmin'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  createNewUnitForSysAdmin(bean: Unit): Promise<JSonResult<string>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('createNewUnitForSysAdmin',bean);
    return this.http.post( this.serverUrl('createNewUnitForSysAdmin'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<string>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  getEmployeeTimedTaskParamsAggregationByEmployee(employeeId: string): Promise<JSonResult<EmployeeTimedTaskParamsAggregation[]>> {
   //this.traceService.sendTrace('getEmployeeTimedTaskParamsAggregationByEmployee',{EMPLOYEE_ID:employeeId});
    return this.http.post( this.serverUrl('getEmployeeTimedTaskParamsAggregationByEmployee'), {EMPLOYEE_ID:employeeId}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<EmployeeTimedTaskParamsAggregation[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  getEmployeeTimedTaskParamsAggregation(employeeTimedTaskParamId: number,canSeeAmount: boolean): Promise<JSonResult<EmployeeTimedTaskParamsAggregation>> {
   //this.traceService.sendTrace('getEmployeeTimedTaskParamsAggregation',{id:employeeTimedTaskParamId});
    return this.http.post( this.serverUrl('getEmployeeTimedTaskParamsAggregation'), {id:employeeTimedTaskParamId}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<EmployeeTimedTaskParamsAggregation>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  getEmployeeTimedTaskParamsAggregationBySchedule(scheduleId: number): Promise<JSonResult<EmployeeTimedTaskParamsAggregation[]>> {

   //this.traceService.sendTrace('getEmployeeTimedTaskParamsAggregationBySchedule',{id:scheduleId});
    return this.http.post( this.serverUrl('getEmployeeTimedTaskParamsAggregationBySchedule'), {id:scheduleId}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<EmployeeTimedTaskParamsAggregation[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  saveEmployeeTimedTaskParamsAggregation(bean: EmployeeTimedTaskParamsAggregation): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('saveEmployeeTimedTaskParamsAggregation',bean);
    return this.http.post( this.serverUrl('saveEmployeeTimedTaskParamsAggregation'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  deleteEmployeeTimedTaskParams(bean: EmployeeTimedTaskParams): Promise<JSonResult<number>> {
    const serializer = new JSonSerializer();
   //this.traceService.sendTrace('deleteEmployeeTimedTaskParams',bean);
    return this.http.post( this.serverUrl('deleteEmployeeTimedTaskParams'), serializer.prepareForJson(bean),  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {

          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  saveEmailForUser(username: string, email: string): Promise<JSonResult<number>> {
   //this.traceService.sendTrace('saveEmailForUser',{user: username, email:email});
    return this.http.post( this.serverUrl('saveEmailForUser'),{user: username, email:email}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  savePasswordForUser(username: string, pwd: string, newPwd: string): Promise<JSonResult<number>> {
//    const headers = new HttpHeaders({ 'Content-Type': 'application/json','X-XSRF-TOKEN':this.sessionService.xsrfToken});
    const headers = new HttpHeaders({ 'Content-Type': 'application/json'});
    // const options = new RequestOptions({ headers: headers });

    // this.traceService.sendTrace('savePasswordForUser',{user: username, pwd: pwd, newPwd: newPwd},username);
    // findServerUrlForUsername(username: string)
    //

    return this.http.post( this.serverUrl('savePasswordForUser'),{user: username, pwd: pwd, newPwd: newPwd}, { headers: headers })
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  verifyOTP(username: string, otp:number): Promise<JSonResult<number>> {
    return this.http.post( this.serverUrl('verifyOTP'),{user: username, otp: otp}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  saveUserTwoFactorAuthentication(employeeId: string, secret: string, activateTwoFactor: boolean): Promise<JSonResult<number>> {
   //this.traceService.sendTrace('saveUserTwoFactorAuthentication',{EMPLOYEE_ID: employeeId, secret: secret,activateTwoFactor: activateTwoFactor});

    return this.http.post( this.serverUrl('saveUserTwoFactorAuthentication'),{EMPLOYEE_ID: employeeId, secret: secret,activateTwoFactor: activateTwoFactor}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  getUserForTwoFactorAuthentication(employeeId: string): Promise<JSonResult<User>> {
   //this.traceService.sendTrace('getUserForTwoFactorAuthentication',{EMPLOYEE_ID: employeeId});
    return this.http.post( this.serverUrl('getUserForTwoFactorAuthentication'),{EMPLOYEE_ID: employeeId}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<User>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  generateSecret(): Promise<JSonResult<string>> {
   //this.traceService.sendTrace('generateSecret');
    return this.http.post( this.serverUrl('generateSecret'),{}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<string>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  getAddWeeklySpifAggregation(bean:AddWeeklySpifRequest): Promise<JSonResult<AddSpifAggregation[]>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('getWeeklySpifBatchRecord',bean);
    return this.http.post( this.serverUrl('getWeeklySpifBatchRecord'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<AddSpifAggregation[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  getAddSpifAggregation(bean:AddSpifRequest): Promise<JSonResult<AddSpifAggregation[]>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('getSpifBatchRecord',bean);
    return this.http.post( this.serverUrl('getSpifBatchRecord'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<AddSpifAggregation[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  saveAddSpifAggregation(bean:AddSpifAggregation): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('saveAddSpifAggregation',bean);
    return this.http.post( this.serverUrl('saveAddSpifAggregation'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  saveAddWeeklySpifAggregation(bean:AddWeeklySpifAggregation): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('saveAddWeeklySpifAggregation',bean);
    return this.http.post( this.serverUrl('saveAddWeeklySpifAggregation'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  getCCQConfigurationForEmployee(employeeId: string): Promise<JSonResult<CCQConfigurationForEmployee>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('getCCQConfigurationForEmployee',{'EMPLOYEE_ID':employeeId});
    return this.http.post( this.serverUrl('getCCQConfigurationForEmployee'), {'EMPLOYEE_ID':employeeId}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<CCQConfigurationForEmployee>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  saveCCQConfigurationForEmployee(bean:CCQConfigurationForEmployee): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('saveCCQConfigurationForEmployee',bean);
    return this.http.post( this.serverUrl('saveCCQConfigurationForEmployee'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  saveSecurityPerUser(bean: SecurityPerUser): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('saveSecurityPerUser',bean);
    return this.http.post( this.serverUrl('saveSecurityPerUser'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  saveSecurityPerUserForEmployeeOfEnterprise(bean: ApplySecurityForAllEmployee): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('saveSecurityPerUserForEmployeeOfEnterprise',bean);
    return this.http.post( this.serverUrl('saveSecurityPerUserForEmployeeOfEnterprise'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  /**
   * Etag is not necessary!
   * @param username
   */
  getSecurityPerUserForUser(username: string): Promise<JSonResult<SecurityPerUser>> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    // const options = new RequestOptions({ headers: headers, withCredentials:true });

    /*
     * Fucking TraceService removing Session.
     *
     */

    //this.traceService.sendTrace('getSecurityPerUserForUser',{user:username});
    return this.http.post( this.serverUrl('getSecurityPerUserForUser'), {user:username},{ headers: headers, withCredentials:true })
      .toPromise()
      .then((response) => {
          return response as JSonResult<SecurityPerUser>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  reactivateUser(username: string): Promise<JSonResult<number>> {
   //this.traceService.sendTrace('reactivateUser',{user:username});
    return this.http.post( this.serverUrl('reactivateUser'), {user: username},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {

          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  getAccessibleParamsProfileAggregation(includeInactive: boolean): Promise<JSonResult<ParamsProfileAggregation[]>> {

   //this.traceService.sendTrace('getAccessibleParamsProfileAggregation',{includeInactive:includeInactive});
    return this.http.post( this.serverUrl('getAccessibleParamsProfileAggregation'), {includeInactive:includeInactive},this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<ParamsProfileAggregation[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  saveParamsProfileAggregation(bean: ParamsProfileAggregation): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('saveParamsProfileAggregation',bean);
    return this.http.post( this.serverUrl('saveParamsProfileAggregation'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  deleteParamsProfile(bean: ParamsProfile): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('deleteParamsProfile',bean);
    return this.http.post( this.serverUrl('deleteParamsProfile'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  deleteParamsProfileUser(bean: ParamsProfileUser): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("deleteParamsProfileUser",bean);
    const serializer = new JSonSerializer();
    return this.http.post( this.serverUrl('deleteParamsProfileUser'), serializer.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {

          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  createUDataExportFileForEmployee(employeeId: string): Promise<JSonResult<string>> {
   //this.traceService.sendTrace('createUDataExportFileForEmployee',{EMPLOYEE_ID:employeeId});
    return this.http.post( this.serverUrl('createUDataExportFileForEmployee'), {EMPLOYEE_ID:employeeId}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //

          return response as JSonResult<string>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  sendUDataExportFileForEmployee(employeeId: string): Promise<JSonResult<UdataFileResponseContainer>> {
   //this.traceService.sendTrace('sendUDataExportFileForEmployee',{EMPLOYEE_ID:employeeId});
    return this.http.post( this.serverUrl('sendUDataExportFileForEmployee'), {EMPLOYEE_ID:employeeId}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //

          return response as JSonResult<UdataFileResponseContainer>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  getEmployeeToExportToUData(): Promise<JSonResult<Employee[]>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('getEmployeeToExportToUData');

    return this.http.post( this.serverUrl('getEmployeeToExportToUData'), {}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<Employee[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  verifyEmployeeInformation(bean: VerifyEmployeeRequest): Promise<JSonResult<DetectedIssueOnEmployee[]>> {
    const serializer = new JSonSerializer();
   //this.traceService.sendTrace('verifyEmployeeInformation',bean);
    return this.http.post( this.serverUrl('verifyEmployeeInformation'),  serializer.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //

          return response as JSonResult<DetectedIssueOnEmployee[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  verifyEmployeeInformationByStructure(bean: VerifyEmployeeRequest): Observable<JSonResult<DetectedIssueOnEmployee[]>> {
    const serializer = new JSonSerializer();

    return new Observable<JSonResult<DetectedIssueOnEmployee[]>>((observer)=>{
      this.http.post<JSonResult<DetectedIssueOnEmployee[]>>( this.serverUrl('verifyEmployeeInformationByStructure'),  serializer.prepareForJson(bean), this._retrieveJSonRequestOptions())
        .subscribe({
            next: (response) => {
              observer.next(response);
              observer.complete();
              observer.unsubscribe();
            },
            error: (rejected) => {
              // @ts-ignore
              observer.next(this._handleRejected(rejected));
              observer.complete();
              observer.unsubscribe();
            }
          }
        );
    });
  }

  printBanksForAWeek(bean: EmployeeBankInformation): Promise<JSonResult<string>> {
    const serial = new JSonSerializer();
    // const tmp = new Array<EmployeeHoraire>();
    // for (const b of beans){
    //   tmp.push(serial.prepareForJson(b));
    // }
   //this.traceService.sendTrace('printBanksForAWeek',bean);

    return this.http.post( this.serverUrl('printBanksForAWeek'),serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<string>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  createRetailNextFileForDivision(divisionId: string,fromDt: Date, toDt: Date): Promise<JSonResult<string>> {
   //this.traceService.sendTrace('createRetailNextFileForDivision',{unitId:divisionId,fromDt: fromDt, toDt: toDt});
    return this.http.post( this.serverUrl('createRetailNextFileForDivision'), {unitId:divisionId,fromDt: fromDt, toDt: toDt}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //

          return response as JSonResult<string>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  getUsagerBudget(employeeId: string): Promise<JSonResult<UsagerBudget>> {
   //this.traceService.sendTrace("getUsagerBudget",{EMPLOYEE_ID: employeeId});
    return this.http.post( this.serverUrl('getUsagerBudget'), {EMPLOYEE_ID: employeeId}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<UsagerBudget>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  saveUsagerBudget(budget: UsagerBudget): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace("saveUsagerBudget",budget);
    return this.http.post( this.serverUrl('saveUsagerBudget'), serial.prepareForJson(budget), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {

          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  getSurveyAggregations(includeInactive: boolean): Promise<JSonResult<SurveyAggregation[]>> {
   //this.traceService.sendTrace('getSurveyAggregations',{includeInactive:includeInactive});
    return this.http.post( this.serverUrl('getSurveyAggregations'), {includeInactive:includeInactive},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<SurveyAggregation[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  deleteSurveyAggregation(bean: SurveyAggregation): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("deleteSurveyAggregation",bean);
    const serializer = new JSonSerializer();
    return this.http.post( this.serverUrl('deleteSurveyAggregation'), serializer.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {

          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  deleteSurveyQuestionAggregation(bean: SurveyQuestionAggregation): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("deleteSurveyQuestionAggregation",bean);
    const serializer = new JSonSerializer();
    return this.http.post( this.serverUrl('deleteSurveyQuestionAggregation'), serializer.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {

          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  deleteSurveyAnswerChoice(bean: SurveyAnswerChoice): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("deleteSurveyAnswerChoice",bean);
    const serializer = new JSonSerializer();
    return this.http.post( this.serverUrl('deleteSurveyAnswerChoice'), serializer.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {

          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  saveSurveyAggregation(bean: SurveyAggregation): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace("saveSurveyAggregation",bean);
    return this.http.post( this.serverUrl('saveSurveyAggregation'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {

          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  saveSurveySortOrder(bean: Survey): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace("saveSurveySortOrder",bean);
    return this.http.post( this.serverUrl('saveSurveySortOrder'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {

          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  saveMultipleSurveysSortOrder(beans: Survey[]): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace("saveMultipleSurveysSortOrder",beans);
    return this.http.post( this.serverUrl('saveMultipleSurveysSortOrder'), beans, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {

          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  getSurveyEmployeeWithNameProgress(surveyId: number): Promise<JSonResult<SurveyWithEmployeeProgress>> {
   //this.traceService.sendTrace('getSurveyEmployeeWithNameProgress',{id:surveyId});
    return this.http.post( this.serverUrl('getSurveyEmployeeWithNameProgress'), {id:surveyId},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<SurveyWithEmployeeProgress>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  searchEmployeeForSurvey(bean: SearchEmployeeForSurvey): Promise<JSonResult<SurveyWithEmployeeProgress>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('searchEmployeeForSurvey',serial.prepareForJson(bean));
    return this.http.post( this.serverUrl('searchEmployeeForSurvey'), serial.prepareForJson(bean),  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<SurveyWithEmployeeProgress>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  saveSurveyEmployeeProgress(bean: SurveyEmployeeProgress): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace("saveSurveyEmployeeProgress",bean);
    return this.http.post( this.serverUrl('saveSurveyEmployeeProgress'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {

          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  deleteSurveyEmployeeProgress(bean: SurveyEmployeeProgress): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace("deleteSurveyEmployeeProgress",bean);
    return this.http.post( this.serverUrl('deleteSurveyEmployeeProgress'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {

          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  resetSurveyEmployeeProgress(surveyId: number): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("resetSurveyEmployeeProgress",surveyId);
    return this.http.post( this.serverUrl('resetSurveyEmployeeProgress'), {id:surveyId}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {

          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  exportSurveyResults(surveyId: number,exportJson: boolean,from:Date,to:Date): Promise<JSonResult<string>> {
   //this.traceService.sendTrace("exportSurveyResults",{id:surveyId,exportJson:exportJson,fromDt:moment(from),toDt: moment(to)});
    return this.http.post( this.serverUrl('exportSurveyResults'), {id:surveyId,exportJson:exportJson,fromDt:moment(from),toDt: moment(to)}, this._retrieveJSonRequestOptions())
    .toPromise()
      .then((response) => {

          return response as JSonResult<string>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  exportAllSurveyResults(surveyIds: number[]): Promise<JSonResult<string>> {
 //this.traceService.sendTrace("exportAllSurveyResults",surveyIds);
  return this.http.post( this.serverUrl('exportAllSurveyResults'), {surveyIds:surveyIds}, this._retrieveJSonRequestOptions())
.toPromise()
  .then((response) => {

      return response as JSonResult<string>;
    },
    (rejected) => { return this._handleRejected(rejected); }
  );
}

  getAvailableApiAccessForCurrentUser(): Promise<JSonResult<ApiAccessToUser[]>> {
   //this.traceService.sendTrace('getAvailableApiAccessForCurrentUser',{});
    return this.http.post( this.serverUrl('getAvailableApiAccessForCurrentUser'), {},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<ApiAccessToUser[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  saveAvailableApiAccessToUser(bean: ApiAccessToUser): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace("saveAvailableApiAccessToUser",bean);
    return this.http.post( this.serverUrl('saveAvailableApiAccessToUser'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {

          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  deleteAvailableApiAccessToUser(bean: ApiAccessToUser): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace("deleteAvailableApiAccessToUser",{id:bean.id});
    return this.http.post( this.serverUrl('deleteAvailableApiAccessToUser'), {id: bean.id}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {

          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  getAccessibleUnitJobCustomPayExport(enterpriseId: number): Promise<JSonResult<UnitJobCustomPayExport[]>> {
   //this.traceService.sendTrace('getAccessibleUnitJobCustomPayExport',{enterpriseId:enterpriseId});
    return this.http.post( this.serverUrl('getAccessibleUnitJobCustomPayExport'), {enterpriseId:enterpriseId},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<UnitJobCustomPayExport[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  saveUnitJobCustomPayExport(bean: UnitJobCustomPayExport): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace("saveUnitJobCustomPayExport",bean);
    return this.http.post( this.serverUrl('saveUnitJobCustomPayExport'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {

          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  deleteUnitJobCustomPayExport(bean: UnitJobCustomPayExport): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace("deleteUnitJobCustomPayExport",bean);
    return this.http.post( this.serverUrl('deleteUnitJobCustomPayExport'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {

          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }




  getEmployeePictureForProfile(employeeId: number): Promise<JSonResult<EmployeePicture[]>> {
   //this.traceService.sendTrace('getEmployeePictureForProfile',{EMPLOYEE_ID:employeeId});
    return this.http.post( this.serverUrl('getEmployeePictureForProfile'), {EMPLOYEE_ID:employeeId},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<EmployeePicture[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  saveEmployeePictureForProfile(employeeId: string, img64: string): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace("saveEmployeePictureForProfile",{employeeId: employeeId, img64: img64});
    return this.http.post( this.serverUrl('saveEmployeePictureForProfile'), {'EMPLOYEE_ID':employeeId, img64: img64}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {

          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  deleteEmployeePictureForProfile(employeeId: string): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace("deleteEmployeePictureForProfile",{employeeId: employeeId});
    return this.http.post( this.serverUrl('deleteEmployeePictureForProfile'), {'EMPLOYEE_ID':employeeId}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {

          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  getEmployeeOtherBadges(employeeId: string): Promise<JSonResult<EmployeeOtherBadge[]>> {
   //this.traceService.sendTrace("getEmployeeOtherBadges",{EMPLOYEE_ID: employeeId});
    return this.http.post( this.serverUrl('getEmployeeOtherBadges'), {EMPLOYEE_ID: employeeId}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {

          return response as JSonResult<EmployeeOtherBadge[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  deleteEmployeeOtherBadge(id: number): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("deleteEmployeeOtherBadge",{id: id});
    return this.http.post( this.serverUrl('deleteEmployeeOtherBadge'), {id: id}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {

          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  saveEmployeeOtherBadge(bean: EmployeeOtherBadge): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace("saveEmployeeOtherBadge",bean);
    return this.http.post( this.serverUrl('saveEmployeeOtherBadge'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {

          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  getUsagerBudgetAggregations(): Promise<JSonResult<UsagerBudgetAggregation[]>> {
   //this.traceService.sendTrace('getUsagerBudgetAggregations');
    return this.http.post( this.serverUrl('getUsagerBudgetAggregations'), {}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<UsagerBudgetAggregation[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  getDayEventAggregationByDates(from: moment.Moment, to: moment.Moment): Promise<JSonResult<DayEventAggregation[]>> {
   //this.traceService.sendTrace('getDayEventAggregationByDates');
    return this.http.post( this.serverUrl('getDayEventAggregationByDates'), {fromDt: from, toDt: to}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<DayEventAggregation[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  getAllDayEventAggregationByDates(from: moment.Moment, to: moment.Moment): Promise<JSonResult<DayEventAggregation[]>> {
   //this.traceService.sendTrace('getAllDayEventAggregationByDates');
    return this.http.post( this.serverUrl('getAllDayEventAggregationByDates'), {fromDt: from, toDt: to}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<DayEventAggregation[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  deleteDayEvent(id: number): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("deleteDayEvent",{id: id});
    return this.http.post( this.serverUrl('deleteDayEvent'), {id: id}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {

          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  saveDayEventAggregation(bean: DayEventAggregation): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace("saveDayEventAggregation",bean);
    return this.http.post( this.serverUrl('saveDayEventAggregation'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {

          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }




  getDaySalesCostObjectiveAggregationByDates(from: moment.Moment, to: moment.Moment): Promise<JSonResult<DaySalesCostObjectiveAggregation[]>> {
   //this.traceService.sendTrace('getDaySalesCostObjectiveAggregationByDates');
    return this.http.post( this.serverUrl('getDaySalesCostObjectiveAggregationByDates'), {fromDt: from, toDt: to}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<DaySalesCostObjectiveAggregation[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  getAllDaySalesCostObjectiveAggregationByDates(from: moment.Moment, to: moment.Moment): Promise<JSonResult<DaySalesCostObjectiveAggregation[]>> {
   //this.traceService.sendTrace('getAllDaySalesCostObjectiveAggregationByDates');
    return this.http.post( this.serverUrl('getAllDaySalesCostObjectiveAggregationByDates'), {fromDt: from, toDt: to}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<DaySalesCostObjectiveAggregation[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  deleteDaySalesCostObjective(id: number): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("deleteDaySalesCostObjective",{id: id});
    return this.http.post( this.serverUrl('deleteDaySalesCostObjective'), {id: id}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {

          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  saveDaySalesCostObjectiveAggregation(bean: DaySalesCostObjectiveAggregation): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace("saveDaySalesCostObjectiveAggregation",bean);
    return this.http.post( this.serverUrl('saveDaySalesCostObjectiveAggregation'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {

          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  saveEmprezMessageRead(bean: EmprezMessageRead): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace("saveEmprezMessageRead",bean);
    return this.http.post( this.serverUrl('saveEmprezMessageRead'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {

          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  getMemoAggregation(memoId: number): Promise<JSonResult<MemoAggregation>> {
   //this.traceService.sendTrace('getMemoAggregation',{id:memoId});
    return this.http.post( this.serverUrl('getMemoAggregation'), {id:memoId}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<MemoAggregation>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  saveEmployeePositionLevel(employeeId: string, jobId: string, unitId: string, positionLevel: number): Promise<JSonResult<number>> {
   //this.traceService.sendTrace('saveEmployeePositionLevel',{'EMPLOYEE_ID':employeeId,jobId: jobId, unitId: unitId,jobEchelon: +positionLevel});
    return this.http.post( this.serverUrl('saveEmployeePositionLevel'), {'EMPLOYEE_ID':employeeId,jobId: jobId, unitId: unitId,jobEchelon: +positionLevel},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {

          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  getEmployeeSortOrderByEnterpriseOrNameOrUnit(bean:AddJobRequest): Promise<JSonResult<EmployeeSortOrder[]>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('getEmployeeSortOrderByEnterpriseOrNameOrUnit',bean);
    return this.http.post( this.serverUrl('getEmployeeSortOrderByEnterpriseOrNameOrUnit'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<EmployeeSortOrder[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  getEmployeeEmailByEnterpriseOrNameOrUnit(bean:AddJobRequest): Promise<JSonResult<EmployeeWithEmail[]>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('getEmployeeEmailByEnterpriseOrNameOrUnit',bean);
    return this.http.post( this.serverUrl('getEmployeeEmailByEnterpriseOrNameOrUnit'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<EmployeeWithEmail[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  getHolidayRecord(bean:CreateHolidaysRequest): Promise<JSonResult<CreateHolidayAggregation[]>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('getHolidayRecord',bean);

    return this.http.post( this.serverUrl('getHolidayRecord'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<CreateHolidayAggregation[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  saveHolidayRecord(bean:CreateHolidayAggregation): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('saveHolidayRecord',bean);
    return this.http.post( this.serverUrl('saveHolidayRecord'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  getAllCommitmentAggregationByHRConfig(includeInactive:boolean): Promise<JSonResult<CommitmentAggregation[]>> {
    const serial = new JSonSerializer();
    return this.http.post( this.serverUrl('getAllCommitmentAggregationByHRConfig'), {includeInactive: includeInactive}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<CommitmentAggregation[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  getAllCommitmentAggregationByOwner(includeInactive:boolean): Promise<JSonResult<CommitmentAggregation[]>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('getAllCommitmentAggregationByOwner',{includeInactive: includeInactive});

    return this.http.post( this.serverUrl('getAllCommitmentAggregationByOwner'), {includeInactive: includeInactive}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<CommitmentAggregation[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  deleteCommitmentAggregation(bean:CommitmentAggregation): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('deleteCommitmentAggregation',bean);
    return this.http.post( this.serverUrl('deleteCommitmentAggregation'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  resetCommitmentAggregation(bean:CommitmentAggregation): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('resetCommitmentAggregation',bean);
    return this.http.post( this.serverUrl('resetCommitmentAggregation'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  saveCommitmentAggregation(bean:CommitmentAggregation): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('saveCommitmentAggregation',bean);
    return this.http.post( this.serverUrl('saveCommitmentAggregation'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }




  searchEmployeeForCommitment(bean: SearchEmployeeForCommitment): Promise<JSonResult<CommitmentAggregation>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('searchEmployeeForCommitment',serial.prepareForJson(bean));
    return this.http.post( this.serverUrl('searchEmployeeForCommitment'), serial.prepareForJson(bean),  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<CommitmentAggregation>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  getCommitmentAggregationById(commitmentId: number): Promise<JSonResult<CommitmentAggregation>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('getCommitmentAggregationById',{id:commitmentId});
    return this.http.post( this.serverUrl('getCommitmentAggregationById'), {id:commitmentId},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<CommitmentAggregation>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  saveCommitmentEmployee(bean: CommitmentEmployee): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace("saveCommitmentEmployee",bean);
    return this.http.post( this.serverUrl('saveCommitmentEmployee'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {

          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  deleteCommitmentEmployee(bean: CommitmentEmployee): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace("deleteCommitmentEmployee",bean);
    return this.http.post( this.serverUrl('deleteCommitmentEmployee'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {

          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  deleteCommitmentUser(bean: CommitmentUser): Observable<JSonResult<number>> {
    //this.traceService.sendTrace("deleteGeoFenceUser",bean);
    return this._updateData<JSonResult<number>>('deleteCommitmentUser', bean,new JSonSerializer());
  }



  deleteShiftBonus(bean:ShiftBonus): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('deleteShiftBonus',bean);
    return this.http.post( this.serverUrl('deleteShiftBonus'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  saveShiftBonus(bean:ShiftBonusAggregation): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('saveShiftBonus',bean);
    return this.http.post( this.serverUrl('saveShiftBonus'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  deleteWorkShiftBonus(bean:WorkShiftBonus): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('deleteWorkShiftBonus',bean);
    return this.http.post( this.serverUrl('deleteWorkShiftBonus'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  saveWorkShiftBonus(bean:WorkShiftBonus): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('saveWorkShiftBonus',bean);
    return this.http.post( this.serverUrl('saveWorkShiftBonus'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  saveMultipleWorkShiftBonus(beans:WorkShiftBonus[]): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
    let toSave = new Array();
    for (const bean of beans){
      toSave.push(serial.prepareForJson(bean));
    }
   //this.traceService.sendTrace('saveMultipleWorkShiftBonus',toSave);
    return this.http.post( this.serverUrl('saveMultipleWorkShiftBonus'), toSave, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  deleteNamedWorkShiftBonus(bean:NamedWorkShiftBonus): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('deleteNamedWorkShiftBonus',bean);
    return this.http.post( this.serverUrl('deleteNamedWorkShiftBonus'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  getEmployeeBadgesByEnterpriseOrNameOrUnit(bean:EmployeeWithBadgeRequest): Promise<JSonResult<EmployeeWithBadge[]>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('getEmployeeBadgesByEnterpriseOrNameOrUnit',bean);
    return this.http.post( this.serverUrl('getEmployeeBadgesByEnterpriseOrNameOrUnit'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<EmployeeWithBadge[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }
  //bean.data.data.id,this.jobToAdd.job.jobId,this.jobToAdd.unit.unitCode




  deleteGeoFenceUser(bean: GeoFenceUser): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("deleteGeoFenceUser",bean);

    const serializer = new JSonSerializer();
    return this.http.post( this.serverUrl('deleteGeoFenceUser'), serializer.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {

          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  deleteGeoFenceAggregation(bean: GeoFenceAggregation): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("deleteGeoFenceAggregation",bean);

    const serializer = new JSonSerializer();
    return this.http.post( this.serverUrl('deleteGeoFenceAggregation'), serializer.prepareForJson(bean),  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {

          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }
  // SaveNamedWorkShiftAggregationAction


  saveGeoFenceAggregation(bean: GeoFenceAggregation): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("saveGeoFenceAggregation",bean);

    const serializer = new JSonSerializer();
    return this.http.post( this.serverUrl('saveGeoFenceAggregation'), serializer.prepareForJson(bean),  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {

          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  getAccessibleGeoFence(includeInactive: boolean): Promise<JSonResult<GeoFenceAggregation[]>> {
   //this.traceService.sendTrace("getAccessibleGeoFence",{includeInactive:includeInactive});
    return this.http.post( this.serverUrl('getAccessibleGeoFence'), {includeInactive:includeInactive},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<GeoFenceAggregation[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  getActiveGeoFenceByUser(): Promise<JSonResult<GeoFence[]>> {
   //this.traceService.sendTrace("getActiveGeoFenceByUser",{});
    return this.http.post( this.serverUrl('getActiveGeoFenceByUser'), {},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<GeoFence[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  deleteGeoFenceNamedWorkShift(bean:GeoFenceNamedWorkShift): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('deleteGeoFenceNamedWorkShift',bean);
    return this.http.post( this.serverUrl('deleteGeoFenceNamedWorkShift'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  createChatUsers(employeeIds: string[]): Promise<JSonResult<DashboardEmployeeAggregation>> {
   //this.traceService.sendTrace("createChatUsers",{employeeIds: employeeIds});
    return this.http.post( this.serverUrl('createChatUsers'), {employeeIds: employeeIds},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<DashboardEmployeeAggregation>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  getChatToken(): Promise<JSonResult<string>> {
   //this.traceService.sendTrace("getChatToken",{});
    return this.http.post( this.serverUrl('getChatToken'), {},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<string>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  getAllActiveEmployeeAndDevices(includeUserSameLevel:boolean): Promise<JSonResult<EmployeeWithUserDevices[]>> {
   //this.traceService.sendTrace('getAllActiveEmployeeAndDevices',{includeUserSameLevel:includeUserSameLevel});

    return this.http.post( this.serverUrl('getAllActiveEmployeeAndDevices'), {includeUserSameLevel:includeUserSameLevel}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<EmployeeWithUserDevices[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  getAllActiveEmployeeAndDevicesPerUnit(unitIds: string[],includeUserSameLevel:boolean): Promise<JSonResult<EmployeeWithUserDevices[]>> {
   //this.traceService.sendTrace('getAllActiveEmployeeAndDevicesPerUnit',{unitId:unitIds,includeUserSameLevel:includeUserSameLevel});

    return this.http.post( this.serverUrl('getAllActiveEmployeeAndDevicesPerUnit'), {unitId:unitIds,includeUserSameLevel:includeUserSameLevel}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<EmployeeWithUserDevices[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }




  deleteBankTypeUser(bean: BankTypeUser): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("deleteBankTypeUser",bean);

    const serializer = new JSonSerializer();
    return this.http.post( this.serverUrl('deleteBankTypeUser'), serializer.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {

          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  deleteBankTypeAggregation(bean: BankTypeAggregation): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("deleteBankTypeAggregation",bean);

    const serializer = new JSonSerializer();
    return this.http.post( this.serverUrl('deleteBankTypeAggregation'), serializer.prepareForJson(bean),  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {

          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }
  // SaveNamedWorkShiftAggregationAction


  saveBankTypeAggregation(bean: BankTypeAggregation): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("saveBankTypeAggregation",bean);

    const serializer = new JSonSerializer();
    return this.http.post( this.serverUrl('saveBankTypeAggregation'), serializer.prepareForJson(bean),  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {

          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  deleteBankTypeEmployee(bean:BankTypeEmployee): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('deleteBankTypeEmployee',bean);
    return this.http.post( this.serverUrl('deleteBankTypeEmployee'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  saveBankTypeEmployee(bean:BankTypeEmployee): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('saveBankTypeEmployee',bean);
    return this.http.post( this.serverUrl('saveBankTypeEmployee'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  getAccessibleBankType(includeInactive: boolean): Promise<JSonResult<BankTypeAggregation[]>> {
   //this.traceService.sendTrace("getAccessibleBankType",{includeInactive:includeInactive});
    return this.http.post( this.serverUrl('getAccessibleBankType'), {includeInactive:includeInactive},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<BankTypeAggregation[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }




  getActiveBankTypeByUser(): Promise<JSonResult<BankType[]>> {
   //this.traceService.sendTrace("getActiveBankTypeByUser",{});
    return this.http.post( this.serverUrl('getActiveBankTypeByUser'), {},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<BankType[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  getBankTypeEmployeeAndBankTypeForAnEmployee(employeeId: string): Promise<JSonResult<BankTypeEmployeeAndBankType>> {
   //this.traceService.sendTrace("getBankTypeEmployeeAndBankTypeForAnEmployee",{});
    return this.http.post( this.serverUrl('getBankTypeEmployeeAndBankTypeForAnEmployee'), {employeeId:employeeId},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<BankTypeEmployeeAndBankType>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  getBankTypeEmployeeForEmployee(employeeIds: string[]): Promise<JSonResult<BankTypeEmployee[]>> {
   //this.traceService.sendTrace("getBankTypeEmployeeForEmployee",{employeeIds: employeeIds});
    return this.http.post( this.serverUrl('getBankTypeEmployeeForEmployee'), {employeeIds: employeeIds},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<BankTypeEmployee[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  saveBankTypeEmployeHoraire(bean:BankTypeEmployeHoraire): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('saveBankTypeEmployeHoraire',bean);
    return this.http.post( this.serverUrl('saveBankTypeEmployeHoraire'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  deleteBankTypeEmployeeTransaction(bean:BankTypeEmployeeTransaction): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('deleteBankTypeEmployeeTransaction',bean);
    return this.http.post( this.serverUrl('deleteBankTypeEmployeeTransaction'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  saveBankTypeEmployeeTransaction(bean:BankTypeEmployeeTransaction): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('saveBankTypeEmployeeTransaction',bean);
    return this.http.post( this.serverUrl('saveBankTypeEmployeeTransaction'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  getBankTypeEmployeeTransactionsByDatesAndEmployees(employeeIds: string[], from: moment.Moment, to: moment.Moment): Promise<JSonResult<BankTypeEmployeeTransactionAggregation>> {
   //this.traceService.sendTrace("getBankTypeEmployeeTransactionsByDatesAndEmployees",{employeeIds:employeeIds,fromDt: from, toDt: to});
    return this.http.post( this.serverUrl('getBankTypeEmployeeTransactionsByDatesAndEmployees'), {employeeIds:employeeIds,fromDt: from, toDt: to},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<BankTypeEmployeeTransactionAggregation>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  getBankTypeEmployeeTransactionsByDatesAndUnits(unitIds: string[], from: moment.Moment, to: moment.Moment): Promise<JSonResult<BankTypeEmployeeTransactionAggregation>> {
   //this.traceService.sendTrace("getBankTypeEmployeeTransactionsByDatesAndUnits",{unitIds:unitIds,fromDt: from, toDt: to});
  return this.http.post( this.serverUrl('getBankTypeEmployeeTransactionsByDatesAndUnits'), {unitIds:unitIds,fromDt: from, toDt: to},  this._retrieveJSonRequestOptions())
    .toPromise()
    .then((response) => {
        return response as JSonResult<BankTypeEmployeeTransactionAggregation>;
      },
      (rejected) => { return this._handleRejected(rejected); }
    );
  }




  getBankTypeRecord(bean:CreateBankTypeRecordRequest): Promise<JSonResult<CreateBankTypeRecordAggregation[]>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('getBankTypeRecord',bean);

    return this.http.post( this.serverUrl('getBankTypeRecord'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<CreateBankTypeRecordAggregation[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  saveBankTypeRecord(bean:CreateBankTypeRecordAggregation): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('saveBankTypeRecord',bean);

    return this.http.post( this.serverUrl('saveBankTypeRecord'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


    deleteBankTypeRecord(bean:DeleteBankTypeRecordAggregation): Promise<JSonResult<number>> {
        const serial = new JSonSerializer();
       //this.traceService.sendTrace('deleteBankTypeRecord',bean);

        return this.http.post( this.serverUrl('deleteBankTypeRecord'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
            .toPromise()
            .then((response) => {
                    return response as JSonResult<number>;
                },
                (rejected) => { return this._handleRejected(rejected); }
            );
    }



    updateLastReadMessageForUserAndChannel(bean:UpdateLastMessage): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();

   //this.traceService.sendTrace('updateLastReadMessageForUserAndChannel',bean);

    return this.http.post( this.serverUrl('updateLastReadMessageForUserAndChannel'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }




  importSurvey(surveys:SurveyAggregation[]): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();

   //this.traceService.sendTrace('importSurvey',surveys);

    return this.http.post( this.serverUrl('importSurvey'), serial.prepareForJson(surveys), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  deleteSchedulesAfterTerminationDate(employeeId: string): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("deleteSchedulesAfterTerminationDate",{employeeId: employeeId});
    const serializer = new JSonSerializer();
    return this.http.post( this.serverUrl('deleteSchedulesAfterTerminationDate'), {employeeId: employeeId},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //

          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  addEmployeeIdsToTimedTask(employeeIds: string[],timedTaskId: number): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("addEmployeeIdsToTimedTask",{employeeIds: employeeIds,id:timedTaskId});
    const serializer = new JSonSerializer();
    return this.http.post( this.serverUrl('addEmployeeIdsToTimedTask'), {employeeIds: employeeIds,id:timedTaskId},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //

          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  removeEmployeeIdsFromTimedTask(employeeIds: string[],timedTaskId: number): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("removeEmployeeIdsFromTimedTask",{employeeIds: employeeIds,id:timedTaskId});
    const serializer = new JSonSerializer();
    return this.http.post( this.serverUrl('removeEmployeeIdsFromTimedTask'), {employeeIds: employeeIds,id:timedTaskId},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //

          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  getTimedTaskGroupAggregationById(timedTaskGroupId: number): Promise<JSonResult<TimedTaskGroupAggregation>> {
   //this.traceService.sendTrace('getTimedTaskGroupAggregationById',{id:timedTaskGroupId});
    return this.http.post( this.serverUrl('getTimedTaskGroupAggregationById'), {id:timedTaskGroupId},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<TimedTaskGroupAggregation>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

   /*
     getActionManager().register(AddEmployeeIdsToTimedTask.class,"TASK");
        getActionManager().register(RemoveEmployeeIdsFromTimedTask.class,"TASK");
    */




  getUserPreferencesByUsername(username: string): Promise<JSonResult<UserPreference[]>> {
   //this.traceService.sendTrace('getUserPreferencesByUsername',{user:username});
    return this.http.post( this.serverUrl('getUserPreferencesByUsername'), {user:username},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<UserPreference[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  saveUserPreferences(beans:UserPreference[]): Promise<JSonResult<UserPreference[]>> {
   //this.traceService.sendTrace('saveUserPreferences',beans);

    const serial = new JSonSerializer();
    return this.http.post( this.serverUrl('saveUserPreferences'), serial.prepareForJson(beans),  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<UserPreference[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  saveCustomCumulativePremiumConfiguration(bean:CustomCumulativePremiumConfiguration<any>): Promise<JSonResult<number>> {
   //this.traceService.sendTrace('saveCustomCumulativePremiumConfiguration',bean);

    const serial = new JSonSerializer();
    return this.http.post( this.serverUrl('saveCustomCumulativePremiumConfiguration'), serial.prepareForJson(bean),  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  deleteCustomCumulativePremiumConfiguration(bean:CustomCumulativePremiumConfiguration<any>): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('deleteCustomCumulativePremiumConfiguration',bean);
    return this.http.post( this.serverUrl('deleteCustomCumulativePremiumConfiguration'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }




  getActiveCustomCumulativePremiumConfiguration(): Promise<JSonResult<CustomCumulativePremiumConfiguration<any>[]>> {
   //this.traceService.sendTrace("getActiveCustomCumulativePremiumConfiguration",{});
    return this.http.post( this.serverUrl('getActiveCustomCumulativePremiumConfiguration'), {},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<CustomCumulativePremiumConfiguration<any>[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  saveReportToEmail(bean:ReportToEmail): Promise<JSonResult<number>> {
   //this.traceService.sendTrace('saveReportToEmail',bean);

    const serial = new JSonSerializer();
    return this.http.post( this.serverUrl('saveReportToEmail'), serial.prepareForJson(bean),  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  deleteReportToEmail(bean:ReportToEmail): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('deleteReportToEmail',bean);
    return this.http.post( this.serverUrl('deleteReportToEmail'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  getReportToEmailByOwner(includeInactive:boolean): Promise<JSonResult<ReportToEmail[]>> {
   //this.traceService.sendTrace("getReportToEmailByOwner",{includeInactive:includeInactive});
    return this.http.post( this.serverUrl('getReportToEmailByOwner'), {includeInactive:includeInactive},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<ReportToEmail[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  deleteEnterpriseCostDistributionConfig(bean:EnterpriseCostDistributionConfig): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('deleteEnterpriseCostDistributionConfig',bean);
    return this.http.post( this.serverUrl('deleteEnterpriseCostDistributionConfig'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  saveEnterpriseCostDistributionConfig(bean:EnterpriseCostDistributionConfig): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('saveEnterpriseCostDistributionConfig',bean);
    return this.http.post( this.serverUrl('saveEnterpriseCostDistributionConfig'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  saveMultipleEnterpriseCostDistributionConfig(beans:EnterpriseCostDistributionConfig[]): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('saveMultipleEnterpriseCostDistributionConfig',beans);
    const tmp = new Array<EnterpriseCostDistributionConfig>();
    for (const bean of beans){
      tmp.push(serial.prepareForJson(bean));
    }
    return this.http.post( this.serverUrl('saveMultipleEnterpriseCostDistributionConfig'), tmp, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }





  getEnterpriseCostDistributionConfigs(enterpriseId:number): Promise<JSonResult<EnterpriseCostDistributionConfig[]>> {
   //this.traceService.sendTrace("getEnterpriseCostDistributionConfigs",{id:enterpriseId});
    return this.http.post( this.serverUrl('getEnterpriseCostDistributionConfigs'), {id:enterpriseId},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<EnterpriseCostDistributionConfig[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  retrieveConfigurationFromSageIntacct(enterprise: Enterprise): Promise<JSonResult<EnterpriseCostDistributionConfig[]>> {
    //this.traceService.sendTrace("getEnterpriseCostDistributionConfigs",{id:enterpriseId});
    const serializer = new JSonSerializer();
    return this.http.post( this.serverUrl('retrieveConfigurationFromSageIntacct'), serializer.prepareForJson(enterprise),  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<EnterpriseCostDistributionConfig[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }




  updateAllEnterprisePassword(bean:UpdateAllEnterprisePassword): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('updateAllEnterprisePassword',bean);
    return this.http.post( this.serverUrl('updateAllEnterprisePassword'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  retrieveSegmentConfigurationFromNethris(req:SegmentConfigurationRequest): Promise<JSonResult<EnterpriseSegmentConfigurationFromAPI>> {
   //this.traceService.sendTrace("retrieveSegmentConfigurationFromNethris",req);
    const serial = new JSonSerializer();
    return this.http.post( this.serverUrl('retrieveSegmentConfigurationFromNethris'), serial.prepareForJson(req),  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<EnterpriseSegmentConfigurationFromAPI>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  saveSyncAPIConfig(bean:SyncAPIConfig): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('saveSyncAPIConfig',bean);
    return this.http.post( this.serverUrl('saveSyncAPIConfig'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  getSyncAPIConfig(enterpriseId: number): Promise<JSonResult<SyncAPIConfig>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('getSyncAPIConfigPerEnterprise',{enterpriseId:enterpriseId});

    return this.http.post( this.serverUrl('getSyncAPIConfigPerEnterprise'), {enterpriseId:enterpriseId}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<SyncAPIConfig>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  saveSyncAPIConfigFolks(bean:SyncAPIConfigFolks): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('saveSyncAPIConfigFolks',bean);
    return this.http.post( this.serverUrl('saveSyncAPIConfigFolks'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  getSyncAPIConfigFolks(enterpriseId: number): Promise<JSonResult<SyncAPIConfigFolks>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('getSyncAPIConfigFolksPerEnterprise',{enterpriseId:enterpriseId});

    return this.http.post( this.serverUrl('getSyncAPIConfigFolksPerEnterprise'), {enterpriseId:enterpriseId}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<SyncAPIConfigFolks>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  saveSyncAPIConfigOdoo(bean:SyncAPIConfigOdoo): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
    return this.http.post( this.serverUrl('saveSyncAPIConfigOdoo'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  getSyncAPIConfigOdoo(enterpriseId: number): Promise<JSonResult<SyncAPIConfigOdoo>> {
    const serial = new JSonSerializer();
    return this.http.post( this.serverUrl('getSyncAPIConfigOdooPerEnterprise'), {enterpriseId:enterpriseId}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<SyncAPIConfigOdoo>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  getMainHrKPI(bean: MainHrKPI): Promise<JSonResult<MainHrKPI>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace("getMainHrKPI",serial.prepareForJson(bean));

    return this.http.post( this.serverUrl('getMainHrKPI'), serial.prepareForJson(bean),  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return <JSonResult<MainHrKPI>> response;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  getMainHrPerformanceIndicatorsPerEmployee(refDt: moment.Moment, employeeIds: string[]): Promise<JSonResult<HrPerformanceForAnEmployeeAggregation>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace("getMainHrPerformanceIndicatorsPerEmployee",employeeIds);

    return this.http.post( this.serverUrl('getMainHrPerformanceIndicatorsPerEmployee'), {refDt: refDt,employeeIds: employeeIds},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return <JSonResult<HrPerformanceForAnEmployeeAggregation>> response;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }




  deleteWorkAccident(bean:WorkAccident): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('deleteWorkAccident',bean);
    return this.http.post( this.serverUrl('deleteWorkAccident'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  saveWorkAccident(bean:WorkAccident): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('saveWorkAccident',bean);
    return this.http.post( this.serverUrl('saveWorkAccident'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  deleteWorkAccidentFile(bean:WorkAccidentFile): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
    return this.http.post( this.serverUrl('deleteWorkAccidentFile'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  getAllWorkAccidentPerEmployee(employeeId: string): Promise<JSonResult<WorkAccidentsPerEmployee>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('getAllWorkAccidentPerEmployee',{EMPLOYEE_ID: employeeId});

    return this.http.post( this.serverUrl('getAllWorkAccidentPerEmployee'), {EMPLOYEE_ID: employeeId}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<WorkAccidentsPerEmployee>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  getWorkAccidentPerEmployeesByHRConfig(fromDt: moment.Moment, toDt: moment.Moment, includeHidden:boolean, includeInactive: boolean): Promise<JSonResult<WorkAccidentsPerEmployee[]>> {
    return this.http.post( this.serverUrl('getWorkAccidentPerEmployeesByHRConfig'), {fromDt: fromDt, toDt: toDt, includeHidden: includeHidden,includeInactive: includeInactive}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<WorkAccidentsPerEmployee[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }





  /*

  getAccessibleNamedWorkShift(): Promise<JSonResult<NamedWorkShiftAggregation[]>> {
   //this.traceService.sendTrace("getAccessibleNamedWorkShift",);
    return this.http.post( this.serverUrl('getAccessibleNamedWorkShift'), {includeInactive:includeInactive},  this._retrieveJSonRequestOptions())
      .toPromise()
   */

  getAllCustomReportAvailable(includeInactive: boolean): Promise<JSonResult<AllCustomReportAvailable>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('getAllCustomReportAvailable',{includeInactive:includeInactive});

    return this.http.post( this.serverUrl('getAllCustomReportAvailable'), {includeInactive:includeInactive}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<AllCustomReportAvailable>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }




  saveCustomReport(bean: CustomReport): Promise<JSonResult<number>> {
   //this.traceService.sendTrace('saveCustomReport',bean);
    const serializer = new JSonSerializer();
    ;
    return this.http.post( this.serverUrl('saveCustomReport'), serializer.prepareForJson(bean),  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {

          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  deleteCustomReport(bean: CustomReport): Promise<JSonResult<number>> {
   //this.traceService.sendTrace('deleteCustomReport',bean);
    const serializer = new JSonSerializer();
    ;
    return this.http.post( this.serverUrl('deleteCustomReport'), serializer.prepareForJson(bean),  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {

          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  lockTimesheet(id: number): Promise<JSonResult<EmployeHoraireLock>> {
   //this.traceService.sendTrace("lockTimesheet",{id:id});
    const serial = new JSonSerializer();
    return this.http.post( this.serverUrl('lockTimesheet'), {id:id},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {

          return response as JSonResult<EmployeHoraireLock>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  unlockTimesheet(id: number): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("unlockTimesheet",{id:id});
    const serial = new JSonSerializer();
    return this.http.post( this.serverUrl('unlockTimesheet'), {id:id},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {

          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  /**
   * Not Working
   */
  downloadCommitmentDocument(id: number): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("downloadCommitmentDocument",{id:id});
    const serial = new JSonSerializer();
    return this.http.post( this.serverUrl('downloadCommitmentDocument'), {id:id},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {

          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  printEmprezBIForAnEmployee(bean: EmprezBIForAnEmployeeInformation): Promise<JSonResult<string>> {
    const serial = new JSonSerializer();
    // const tmp = new Array<EmployeeHoraire>();
    // for (const b of beans){
    //   tmp.push(serial.prepareForJson(b));
    // }
   //this.traceService.sendTrace('printEmprezBIForAnEmployee',bean);

    return this.http.post( this.serverUrl('printEmprezBIForAnEmployee'),serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<string>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  saveEmployeePunches(bean: EmployeePunches): Promise<JSonResult<number>> {
   //this.traceService.sendTrace('saveEmployeePunches',bean);
    const serializer = new JSonSerializer();
    ;
    return this.http.post( this.serverUrl('saveEmployeePunches'), serializer.prepareForJson(bean),  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {

          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  getPunchPerEmployee(employeeId: string, start: moment.Moment, end:moment.Moment): Promise<JSonResult<PunchPerEmployee>> {
   //this.traceService.sendTrace('getPunchPerEmployee',{EMPLOYEE_ID:employeeId, fromDt: start, toDt: end});
    return this.http.post( this.serverUrl('getPunchPerEmployee'), {EMPLOYEE_ID:employeeId, fromDt: start, toDt: end},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<PunchPerEmployee>;

        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  saveEmployeeScheduleForSysAdmin(bean: EmployeeSchedule): Promise<JSonResult<number>> {
   //this.traceService.sendTrace('saveEmployeeScheduleForSysAdmin',bean);
    const serializer = new JSonSerializer();
    ;
    return this.http.post( this.serverUrl('saveEmployeeScheduleForSysAdmin'), serializer.prepareForJson(bean),  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {

          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  deleteEmployeFTempsSommaireDetail(bean:EmployeFTempsSommaireDetail): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('deleteEmployeFTempsSommaireDetail',bean);
    return this.http.post( this.serverUrl('deleteEmployeFTempsSommaireDetail'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  removeAccessForAllEmployeesOnUnitAndChildren(unitId: string): Promise<JSonResult<number>> {
   //this.traceService.sendTrace('removeAccessForAllEmployeesOnUnitAndChildren',{unitId:unitId});
    return this.http.post( this.serverUrl('removeAccessForAllEmployeesOnUnitAndChildren'), {unitId:unitId}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<number>;

        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }




  deleteExpenseType(bean:ExpenseType): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('deleteExpenseType',bean);
    return this.http.post( this.serverUrl('deleteExpenseType'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  saveExpenseType(bean:ExpenseTypeAggregation): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('saveExpenseType',bean);
    return this.http.post( this.serverUrl('saveExpenseType'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  getAllExpensesTypes(): Promise<JSonResult<ExpenseTypeList>> {
   //this.traceService.sendTrace('getAllExpensesTypes');
    return this.http.post( this.serverUrl('getAllExpensesTypes'), {}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<ExpenseTypeList>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  getExpenseAggregationPerIds(expenseIds: number[]): Promise<JSonResult<EmployeeExpenseAggregation[]>> {
   //this.traceService.sendTrace('getExpenseAggregationPerIds',{expenseIds:expenseIds});
    return this.http.post( this.serverUrl('getExpenseAggregationPerIds'), {expenseIds:expenseIds}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<EmployeeExpenseAggregation[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  getExpenseAggregationsByHRConfig(from: moment.Moment, to: moment.Moment, doNotIncludeApprovedExpenses: boolean, includeHiddenEmployee: boolean, includeInactiveEmployee: boolean): Promise<JSonResult<EmployeeExpenseAggregation[]>> {
    return this.http.post( this.serverUrl('getExpenseAggregationsByHRConfig'), {fromDt: from, toDt: to,  doNotIncludeApprovedExpenses: doNotIncludeApprovedExpenses, includeHidden: includeHiddenEmployee, includeInactive: includeInactiveEmployee}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<EmployeeExpenseAggregation[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  getExpenseAggregationPerEmployee(from: moment.Moment, to: moment.Moment, employeeIds: string[], doNotIncludeApprovedExpenses: boolean): Promise<JSonResult<EmployeeExpenseAggregation[]>> {
   //this.traceService.sendTrace('getExpenseAggregationPerEmployee');
    return this.http.post( this.serverUrl('getExpenseAggregationPerEmployee'), {fromDt: from, toDt: to, employeeIds: employeeIds, doNotIncludeApprovedExpenses: doNotIncludeApprovedExpenses}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<EmployeeExpenseAggregation[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

    getExpenseAggregationPerUnit(unitIds: string[],  start: moment.Moment, end: moment.Moment, doNotIncludeApprovedExpenses: boolean): Promise<JSonResult<EmployeeExpenseAggregation[]>> {

       //this.traceService.sendTrace("getExpenseAggregationPerUnit",{unitId: unitIds, fromDt: start, toDt: end,doNotIncludeApprovedExpenses:doNotIncludeApprovedExpenses});

        return this.http.post( this.serverUrl('getExpenseAggregationPerUnit'), {unitId: unitIds, fromDt: start, toDt: end, doNotIncludeApprovedExpenses:doNotIncludeApprovedExpenses},  this._retrieveJSonRequestOptions())
            .toPromise()
            .then((response) => {
                    //
                    //
                    // return response as JSonResult<EmployeeForScheduling[]>;
                    // const res: JSonResult<EmployeeForScheduling[]> = Object.assign(new JSonResult<EmployeeForScheduling[]>(),response);
                    // return res;
                    return <JSonResult<EmployeeExpenseAggregation[]>> response;
                },
                (rejected) => { return this._handleRejected(rejected); }
            );
    }


  saveExpense(bean:Expense): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('saveExpense',bean);
    return this.http.post( this.serverUrl('saveExpense'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


    deleteExpense(bean:Expense): Promise<JSonResult<number>> {
        const serial = new JSonSerializer();
       //this.traceService.sendTrace('deleteExpense',bean);
        return this.http.post( this.serverUrl('deleteExpense'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
            .toPromise()
            .then((response) => {
                    return response as JSonResult<number>;
                },
                (rejected) => { return this._handleRejected(rejected); }
            );
    }


    public createTokenForDownloadingExpenseFile(expenseFileId: number, employeeId: string): Promise<JSonResult<string>> {
       //this.traceService.sendTrace("createTokenForDownloadingExpenseFile",{id:expenseFileId,EMPLOYEE_ID:employeeId});

        return this.http.post( this.serverUrl('createTokenForDownloadingExpenseFile'), {id:expenseFileId,EMPLOYEE_ID:employeeId}, this._retrieveJSonRequestOptions())
            .toPromise()
            .then((response) => {
                    //
                    return response as JSonResult<string>;
                },
                (rejected) => { return this._handleRejected(rejected); }
            );
    }


    public async downloadExpenseFile(expenseFileId: number, employeeId: string ): Promise<JSonResult<string>> {
        let res =  await this.createTokenForDownloadingExpenseFile(expenseFileId,employeeId);
        if (res.success){
            res.data = this._downloadContent('expenseFile?token=' + res.data + '&inline=true');
        }
        return res;
        // return this.downloadUrl('?docId=' + docId);
    }


    deleteExpenseFile(bean:ExpenseFile): Promise<JSonResult<number>> {
        const serial = new JSonSerializer();
       //this.traceService.sendTrace('deleteExpenseFile',bean);
        return this.http.post( this.serverUrl('deleteExpenseFile'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
            .toPromise()
            .then((response) => {
                    return response as JSonResult<number>;
                },
                (rejected) => { return this._handleRejected(rejected); }
            );
    }


    public createACopyOfEmployee(bean:CopyEmployeeRequest): Promise<JSonResult<String>> {
        const serial = new JSonSerializer();
       //this.traceService.sendTrace('createACopyOfEmployee',bean);
        return this.http.post( this.serverUrl('createACopyOfEmployee'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
            .toPromise()
            .then((response) => {
                    return response as JSonResult<String>;
                },
                (rejected) => { return this._handleRejected(rejected); }
            );
    }


  public generateAutomaticSchedules(request:PlanningRequest): Promise<JSonResult<PlanningResponse>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('generateAutomaticSchedules',request);
    return this.http.post( this.serverUrl('generateAutomaticSchedules'), serial.prepareForJson(request), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<PlanningResponse>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  getAccessibleStatutoryHolidays(includeEventsInThePast: boolean): Promise<JSonResult<EnterpriseStatutoryHoliday[]>> {
   //this.traceService.sendTrace('getAccessibleStatutoryHolidays');
    return this.http.post( this.serverUrl('getAccessibleStatutoryHolidays'), {includeEventsInThePast:includeEventsInThePast}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<EnterpriseStatutoryHoliday[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  deleteEnterpriseStatutoryHoliday(bean:EnterpriseStatutoryHoliday): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('deleteEnterpriseStatutoryHoliday',bean);
    return this.http.post( this.serverUrl('deleteEnterpriseStatutoryHoliday'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  saveEnterpriseStatutoryHoliday(bean:EnterpriseStatutoryHoliday): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('saveEnterpriseStatutoryHoliday',bean);
    return this.http.post( this.serverUrl('saveEnterpriseStatutoryHoliday'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  copyEnterpriseStatutoryHolidayToAnotherEnterprise(from: number, to: number): Promise<JSonResult<number>> {

   //this.traceService.sendTrace('copyEnterpriseStatutoryHolidayToAnotherEnterprise', {fromEnterpriseId: from, toEnterpriseId: to});
    return this.http.post( this.serverUrl('copyEnterpriseStatutoryHolidayToAnotherEnterprise'), {fromEnterpriseId: from , toEnterpriseId: to}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  findUnsubscribedEmails(toFind:string): Promise<JSonResult<MailgunItem[]>> {
   //this.traceService.sendTrace('findUnsubscribedEmails',{toSearch:toFind});
    return this.http.post( this.serverUrl('findUnsubscribedEmails'), {toSearch:toFind}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<MailgunItem[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  deleteUnsubscribedEmail(bean:MailgunItem): Promise<JSonResult<MailgunItem[]>> {
   //this.traceService.sendTrace('deleteUnsubscribedEmail',bean);
    const serial = new JSonSerializer();
    return this.http.post( this.serverUrl('deleteUnsubscribedEmail'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<MailgunItem[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  findLastEvents(recipient:string): Promise<JSonResult<MailgunEvent[]>> {
   //this.traceService.sendTrace('findLastEvents',{email:recipient});
    return this.http.post( this.serverUrl('findLastEvents'), {email:recipient}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<MailgunEvent[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  measureSpeed(): Promise<Object> {

    return this.loadConfiguration().then((configuration)=>{

      const headers = new HttpHeaders({ 'Content-Type': 'text/plain'});

      const url =  configuration.server.concat('measureSpeed');

      return this.http.post(url, {},  { headers: headers})
        .toPromise()
        .then((response) => {
            return response ;
          },
          (rejected) => { return this._handleRejected(rejected); }
        );

    })
  }



  getEvaluationAggregations(includeInactive: boolean): Promise<JSonResult<EvaluationAggregation[]>> {
   //this.traceService.sendTrace('getEvaluationAggregations',{includeInactive:includeInactive});
    return this.http.post( this.serverUrl('getEvaluationAggregations'), {includeInactive:includeInactive},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<EvaluationAggregation[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  deleteEvaluationAggregation(bean: EvaluationAggregation): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("deleteEvaluationAggregation",bean);
    const serializer = new JSonSerializer();
    return this.http.post( this.serverUrl('deleteEvaluationAggregation'), serializer.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {

          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  deleteEvaluationQuestionAggregation(bean: EvaluationQuestionAggregation): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("deleteEvaluationQuestionAggregation",bean);
    const serializer = new JSonSerializer();
    return this.http.post( this.serverUrl('deleteEvaluationQuestionAggregation'), serializer.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {

          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  deleteEvaluationAnswerChoice(bean: EvaluationAnswerChoice): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("deleteEvaluationAnswerChoice",bean);
    const serializer = new JSonSerializer();
    return this.http.post( this.serverUrl('deleteEvaluationAnswerChoice'), serializer.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {

          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  saveEvaluationAggregation(bean: EvaluationAggregation): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace("saveEvaluationAggregation",bean);
    return this.http.post( this.serverUrl('saveEvaluationAggregation'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {

          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }




  deleteEvaluationEmployee(bean:EvaluationEmployee): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('deleteEvaluationEmployee',bean);
    return this.http.post( this.serverUrl('deleteEvaluationEmployee'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  saveEvaluationEmployee(bean:EvaluationEmployee): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('saveEvaluationEmployee',bean);
    return this.http.post( this.serverUrl('saveEvaluationEmployee'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  getAllEvaluationEmployee(employeeId: string): Promise<JSonResult<EvaluationEmployeeAggregation[]>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('getAllEvaluationEmployee',{employeeIds: [employeeId]});

    return this.http.post( this.serverUrl('getAllEvaluationEmployee'), {employeeIds: [employeeId]}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<EvaluationEmployeeAggregation[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  getRecordEvaluationEmployee(bean:EmployeeEvaluationRequest): Promise<JSonResult<EvaluationEmployeeAggregation[]>> {
    const serial = new JSonSerializer();

    return this.http.post( this.serverUrl('getRecordEvaluationEmployee'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<EvaluationEmployeeAggregation[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  getAccessibleEvaluations(): Promise<JSonResult<Evaluation[]>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('getAccessibleEvaluations',{includeInactive:true});

    return this.http.post( this.serverUrl('getAccessibleEvaluations'), {includeInactive:true}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<Evaluation[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  saveEvaluationAnswersForEvaluationEmployee(bean:EvaluationEmployeeAggregation): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('saveEvaluationAnswersForEvaluationEmployee',bean);
    return this.http.post( this.serverUrl('saveEvaluationAnswersForEvaluationEmployee'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  saveEvaluationEmployeeByAssessor(bean:EvaluationEmployeeAggregation): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('saveEvaluationEmployeeByAssessor',bean);
    return this.http.post( this.serverUrl('saveEvaluationEmployeeByAssessor'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  deleteAnswersForEvaluationEmployee(bean:EvaluationEmployee): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('deleteAnswersForEvaluationEmployee',bean);
    return this.http.post( this.serverUrl('deleteAnswersForEvaluationEmployee'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  public createTokenForDownloadingEvaluationFile(employeeEvaluationId: number, employeeId: string): Promise<JSonResult<string>> {
   //this.traceService.sendTrace("createTokenForDownloadingEvaluationFile",{id:employeeEvaluationId,EMPLOYEE_ID:employeeId});

    return this.http.post( this.serverUrl('createTokenForDownloadingEvaluationFile'), {id:employeeEvaluationId,EMPLOYEE_ID:employeeId}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<string>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  public async downloadEvaluationFile(employeeEvaluationId: number, employeeId: string ): Promise<JSonResult<string>> {
    let res =  await this.createTokenForDownloadingEvaluationFile(employeeEvaluationId,employeeId);
    if (res.success){
      res.data = this._downloadContent('evaluationFile?token=' + res.data + '&inline=true');
    }
    return res;
    // return this.downloadUrl('?docId=' + docId);
  }



  deleteEvaluationFile(bean:EvaluationFile): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('deleteEvaluationFile',bean);
    return this.http.post( this.serverUrl('deleteEvaluationFile'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  cloneEmployeePositions(bean: CloneEmployeePositions): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('cloneEmployeePositions',bean);
    return this.http.post( this.serverUrl('cloneEmployeePositions'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  getAllEmployeesPresentNow(): Observable<JSonResult<ScheduleAndTSPerEmployeeAggregation>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('getAllEmployeesPresentNow',{});
    return new Observable<JSonResult<ScheduleAndTSPerEmployeeAggregation>>((observer)=>{
      this.http.post<JSonResult<ScheduleAndTSPerEmployeeAggregation>>( this.serverUrl('getAllEmployeesPresentNow'), {}, this._retrieveJSonRequestOptions())

        .subscribe({
            next: (response) => {
              observer.next(response);
              observer.complete();
              observer.unsubscribe();
            },
            error: (rejected) => {
              observer.next(this._handleRejected(rejected));
              observer.complete();
              observer.unsubscribe();
            }
          }
        );

    });
  }


  exportEmployeesPresentToExcel(bean:ScheduleAndTSPerEmployeeAggregation): Promise<JSonResult<string>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('exportEmployeesPresentNowToExcel',bean);

    return this.http.post( this.serverUrl('exportEmployeesPresentNowToExcel'),serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<string>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  retrieveIntuitAutorizationUrl(): Observable<JSonResult<string>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('retrieveIntuitAutorizationUrl', {});

    return new Observable<JSonResult<string>>((observer)=>{
      this.http.post<JSonResult<string>>( this.serverUrl('retrieveIntuitAutorizationUrl'), {}, this._retrieveJSonRequestOptions())

        .subscribe({
            next: (response) => {
              observer.next(response);
              observer.complete();
              observer.unsubscribe();
            },
            error: (rejected) => {
              observer.next(this._handleRejected(rejected));
              observer.complete();
              observer.unsubscribe();
            }
          }
        );

    });

  }


  verifyIntuitConnection(): Observable<JSonResult<string>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('verifyIntuitConnection', {});

    return new Observable<JSonResult<string>>((observer)=>{
      this.http.post<JSonResult<string>>( this.serverUrl('verifyIntuitConnection'), {}, this._retrieveJSonRequestOptions())

        .subscribe({
            next: (response) => {
              observer.next(response);
              observer.complete();
              observer.unsubscribe();
            },
            error: (rejected) => {
              observer.next(this._handleRejected(rejected));
              observer.complete();
              observer.unsubscribe();
            }
          }
        );

    });

  }



  retrieveIntuitEmployees(): Observable<JSonResult<IntuitEmployee[]>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('retrieveIntuitEmployees', {});

    return new Observable<JSonResult<IntuitEmployee[]>>((observer)=>{
      this.http.post<JSonResult<IntuitEmployee[]>>( this.serverUrl('retrieveIntuitEmployees'), {}, this._retrieveJSonRequestOptions())

        .subscribe({
            next: (response) => {
              observer.next(response);
              observer.complete();
              observer.unsubscribe();
            },
            error: (rejected) => {
              observer.next(this._handleRejected(rejected));
              observer.complete();
              observer.unsubscribe();
            }
          }
        );

    });



  }



  saveIntuitEmployee(employee:IntuitEmployee): Observable<JSonResult<IntuitEmployee[]>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('saveIntuitEmployee', serial.prepareForJson(employee));

    return new Observable<JSonResult<IntuitEmployee[]>>((observer)=>{
      this.http.post<JSonResult<IntuitEmployee[]>>( this.serverUrl('saveIntuitEmployee'), serial.prepareForJson(employee), this._retrieveJSonRequestOptions())

        .subscribe({
            next: (response) => {
              observer.next(response);
              observer.complete();
              observer.unsubscribe();
            },
            error: (rejected) => {
              observer.next(this._handleRejected(rejected));
              observer.complete();
              observer.unsubscribe();
            }
          }
        );

    });


  }



  retrieveCgiAutorizationUrl(enterpriseId: number): Observable<JSonResult<string>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('retrieveCgiAutorizationUrl', {id:enterpriseId});

    return new Observable<JSonResult<string>>((observer)=>{
      this.http.post<JSonResult<string>>( this.serverUrl('retrieveCgiAutorizationUrl'), {id:enterpriseId}, this._retrieveJSonRequestOptions())

        .subscribe({
            next: (response) => {
              observer.next(response);
              observer.complete();
              observer.unsubscribe();
            },
            error: (rejected) => {
              observer.next(this._handleRejected(rejected));
              observer.complete();
              observer.unsubscribe();
            }
          }
        );

    });

  }


  verifyCgiConnection(enterpriseId: number): Observable<JSonResult<string>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('verifyCgiConnection', {id:enterpriseId});

    return new Observable<JSonResult<string>>((observer)=>{
      this.http.post<JSonResult<string>>( this.serverUrl('verifyCgiConnection'), {id:enterpriseId}, this._retrieveJSonRequestOptions())

        .subscribe({
            next: (response) => {
              observer.next(response);
              observer.complete();
              observer.unsubscribe();
            },
            error: (rejected) => {
              observer.next(this._handleRejected(rejected));
              observer.complete();
              observer.unsubscribe();
            }
          }
        );

    });

  }



  getMatchingEmployeeFromFolks(bean:SearchEmployeeRequest): Observable<JSonResult<MatchingEmployeeResult>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('getMatchingEmployeeFromFolks',bean);


    return new Observable<JSonResult<MatchingEmployeeResult>>((observer)=>{
      this.http.post<JSonResult<MatchingEmployeeResult>>( this.serverUrl('getMatchingEmployeeFromFolks'),  serial.prepareForJson(bean), this._retrieveJSonRequestOptions())

        .subscribe({
            next: (response) => {
              observer.next(response);
              observer.complete();
              observer.unsubscribe();
            },
            error: (rejected) => {
              observer.next(this._handleRejected(rejected));
              observer.complete();
              observer.unsubscribe();
            }
          }
        );

    });

  }



  updateMatchedEmployeeWithFolksInformation(bean: UpdateMatchingEmployeeWithMatriculeRequest): Observable<JSonResult<JSonResult<string>[]>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('updateMatchedEmployeeWithFolksInformation',bean);

    return new Observable<JSonResult<JSonResult<string>[]>>((observer)=>{
      this.http.post<JSonResult<JSonResult<string>[]>>( this.serverUrl('updateMatchedEmployeeWithFolksInformation'),  serial.prepareForJson(bean), this._retrieveJSonRequestOptions())

        .subscribe({
            next: (response) => {
              observer.next(response);
              observer.complete();
              observer.unsubscribe();
            },
            error: (rejected) => {
              observer.next(this._handleRejected(rejected));
              observer.complete();
              observer.unsubscribe();
            }
          }
        );

    });

  }



  getEmployeeFromFolks(bean:SearchEmployeeRequest): Observable<JSonResult<CreateNewEmployee[]>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('getEmployeeFromFolks',bean);


    return new Observable<JSonResult<CreateNewEmployee[]>>((observer)=>{
      this.http.post<JSonResult<CreateNewEmployee[]>>( this.serverUrl('getEmployeeFromFolks'),  serial.prepareForJson(bean), this._retrieveJSonRequestOptions())

        .subscribe({
            next: (response) => {
              observer.next(response);
              observer.complete();
              observer.unsubscribe();
            },
            error: (rejected) => {
              observer.next(this._handleRejected(rejected));
              observer.complete();
              observer.unsubscribe();
            }
          }
        );

    });

  }




  getEmployeeScheduleParameters(employeeId: string): Promise<JSonResult<EmployeeScheduleParams>> {
   //this.traceService.sendTrace("getEmployeeScheduleParameters",{EMPLOYEE_ID: employeeId});

    return this.http.post( this.serverUrl('getEmployeeScheduleParameters'), {EMPLOYEE_ID: employeeId},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<EmployeeScheduleParams>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  saveEmployeeScheduleParameters(bean: EmployeeScheduleParams): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("saveEmployeeScheduleParameters",bean);
    const serializer = new JSonSerializer();
    return this.http.post( this.serverUrl('saveEmployeeScheduleParameters'), serializer.prepareForJson(bean),  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {

          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }




  getEmployeeTimesheetParameters(employeeId: string): Promise<JSonResult<EmployeeTimesheetParams>> {
   //this.traceService.sendTrace("getEmployeeTimesheetParameters",{EMPLOYEE_ID: employeeId});

    return this.http.post( this.serverUrl('getEmployeeTimesheetParameters'), {EMPLOYEE_ID: employeeId},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<EmployeeTimesheetParams>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  saveEmployeeTimesheetParameters(bean: EmployeeTimesheetParams): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("saveEmployeeTimesheetParameters",bean);
    const serializer = new JSonSerializer();
    return this.http.post( this.serverUrl('saveEmployeeTimesheetParameters'), serializer.prepareForJson(bean),  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {

          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  getEmployeePayParams(employeeId: string): Promise<JSonResult<EmployeePayParams>> {
   //this.traceService.sendTrace("getEmployeePayParams",{EMPLOYEE_ID: employeeId});

    return this.http.post( this.serverUrl('getEmployeePayParams'), {EMPLOYEE_ID: employeeId},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<EmployeePayParams>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  saveEmployeePayParams(bean: EmployeePayParams): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("saveEmployeePayParams",bean);
    const serializer = new JSonSerializer();
    return this.http.post( this.serverUrl('saveEmployeePayParams'), serializer.prepareForJson(bean),  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {

          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  getCgiBusinessItems(bean: Enterprise): Promise<JSonResult<BusinessItem[]>> {



   //this.traceService.sendTrace("getCgiBusinessItems",bean);
    const serializer = new JSonSerializer();

    return this.http.post( this.serverUrl('getCgiBusinessItems'), serializer.prepareForJson(bean),  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<BusinessItem[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  getCgiCompanyItems(bean: Enterprise): Promise<JSonResult<CompanyItem[]>> {

   //this.traceService.sendTrace("getCgiCompanyItems",bean);
    const serializer = new JSonSerializer();

    return this.http.post( this.serverUrl('getCgiCompanyItems'), serializer.prepareForJson(bean),  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<CompanyItem[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  saveCgiConfigurationForAPIV2(bean: Enterprise): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("saveCgiConfigurationForAPIV2",bean);
    const serializer = new JSonSerializer();
    return this.http.post( this.serverUrl('saveCgiConfigurationForAPIV2'), serializer.prepareForJson(bean),  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {

          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  getBirthdays(nbDays:number): Promise<JSonResult<CustomValidation<Employee>[]>> {
   //this.traceService.sendTrace("getBirthdays", {nbDays:nbDays});

    return this.http.post( this.serverUrl('getBirthdays'), {nbDays:nbDays},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<CustomValidation<Employee>[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  getExpiringAndExpiredSkills(nbDays:number): Promise<JSonResult<CustomValidation<EmployeeSkill>[]>> {
   //this.traceService.sendTrace("getExpiringAndExpiredSkills", {nbDays:nbDays});

    return this.http.post( this.serverUrl('getExpiringAndExpiredSkills'), {nbDays:nbDays},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<CustomValidation<EmployeeSkill>[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  getAllEntities(includeInactive:boolean): Promise<JSonResult<Entity[]>> {
   //this.traceService.sendTrace('getAllEntities');
    return this.http.post( this.serverUrl('getAllEntities'), {includeInactive:includeInactive},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          // console.log('response searchPunch : ' + response + ' ');
          // console.log('available Recipients: ' + JSON.stringify(response, null, 2));
          return response as JSonResult<Entity[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  sendQuestionToOllama(query:string): Promise<JSonResult<AiResponse>> {
   //this.traceService.sendTrace('sendQuestionToOllama');
    return this.http.post( this.serverUrl('sendQuestionToOllama'), {question:query},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<AiResponse>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  saveEmployeeFamilyDays(bean: EmployeeFamilyDays): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("saveEmployeeFamilyDays",bean);
    const serializer = new JSonSerializer();
    return this.http.post( this.serverUrl('saveEmployeeFamilyDays'), serializer.prepareForJson(bean),  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  deleteEmployeeFamilyDays(bean: EmployeeFamilyDays): Promise<JSonResult<number>> {
   //this.traceService.sendTrace("deleteEmployeeFamilyDays",bean);
    const serializer = new JSonSerializer();
    return this.http.post( this.serverUrl('deleteEmployeeFamilyDays'), serializer.prepareForJson(bean),  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  getFamilyDaysRecord(bean:CreateFamilyDaysRequest): Promise<JSonResult<CreateSickDaysAggregation[]>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('getFamilyDaysRecord',bean);

    return this.http.post( this.serverUrl('getFamilyDaysRecord'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<CreateSickDaysAggregation[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  saveFamilyDaysRecord(bean:CreateFamilyDaysAggregation): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('saveFamilyDaysRecord',bean);
    return this.http.post( this.serverUrl('saveFamilyDaysRecord'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  deleteFamilyDaysRecord(bean:DeleteFamilyDaysAggregation): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
   //this.traceService.sendTrace('deleteFamilyDaysRecord',bean);
    return this.http.post( this.serverUrl('deleteFamilyDaysRecord'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  getAutoAttendanceMessages(): Promise<JSonResult<AutoAttendanceMessage[]>> {
    const serial = new JSonSerializer();

    return this.http.post( this.serverUrl('getAutoAttendanceMessages'), {}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<AutoAttendanceMessage[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  deleteAutoAttendanceMessages(beans :AutoAttendanceMessage[]): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
    return this.http.post( this.serverUrl('deleteAutoAttendanceMessages'), serial.prepareForJson(beans), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  getAutoAttendanceRecord(bean:CreateAutoAttendanceRequest): Promise<JSonResult<CreateAutoAttendanceRecordAggregation[]>> {
    const serial = new JSonSerializer();
    // this.traceService.sendTrace('getFamilyDaysRecord',bean);

    return this.http.post( this.serverUrl('getAutoAttendanceRecord'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<CreateAutoAttendanceRecordAggregation[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  saveAutoAttendanceRecord(bean:CreateAutoAttendanceRecordAggregation): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
    // this.traceService.sendTrace('saveFamilyDaysRecord',bean);
    return this.http.post( this.serverUrl('saveAutoAttendanceRecord'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  importProject(projectName: string,format: ImportProjectType, data: string): Promise<JSonResult<ImportProjectResponse>> {
    return this.http.post( this.serverUrl('importProject'), {projectName: projectName,format: format.code,data: data}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<ImportProjectResponse>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  importTimedTaskGroupAggregation(bean: TimedTaskGroupAggregation): Promise<JSonResult<number>> {
    const serializer = new JSonSerializer();
    return this.http.post( this.serverUrl('importTimedTaskGroupAggregation'), serializer.prepareForJson(bean),  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  getEmployeeFromOdoo(bean:SearchEmployeeRequest): Observable<JSonResult<CreateNewEmployee[]>> {
    const serial = new JSonSerializer();


    return new Observable<JSonResult<CreateNewEmployee[]>>((observer)=>{
      this.http.post<JSonResult<CreateNewEmployee[]>>( this.serverUrl('getEmployeeFromOdoo'),  serial.prepareForJson(bean), this._retrieveJSonRequestOptions())

        .subscribe({
            next: (response) => {
              observer.next(response);
              observer.complete();
              observer.unsubscribe();
            },
            error: (rejected) => {
              observer.next(this._handleRejected(rejected));
              observer.complete();
              observer.unsubscribe();
            }
          }
        );

    });

  }




  getMatchingEmployeeFromOdoo(bean:SearchEmployeeRequest): Observable<JSonResult<MatchingEmployeeResult>> {
    const serial = new JSonSerializer();


    return new Observable<JSonResult<MatchingEmployeeResult>>((observer)=>{
      this.http.post<JSonResult<MatchingEmployeeResult>>( this.serverUrl('getMatchingEmployeeFromOdoo'),  serial.prepareForJson(bean), this._retrieveJSonRequestOptions())

        .subscribe({
            next: (response) => {
              observer.next(response);
              observer.complete();
              observer.unsubscribe();
            },
            error: (rejected) => {
              observer.next(this._handleRejected(rejected));
              observer.complete();
              observer.unsubscribe();
            }
          }
        );

    });

  }


  updateMatchedEmployeeWithOdooInformation(bean: UpdateMatchingEmployeeWithMatriculeRequest): Observable<JSonResult<JSonResult<string>[]>> {
    const serial = new JSonSerializer();

    return new Observable<JSonResult<JSonResult<string>[]>>((observer)=>{
      this.http.post<JSonResult<JSonResult<string>[]>>( this.serverUrl('updateMatchedEmployeeWithOdooInformation'),  serial.prepareForJson(bean), this._retrieveJSonRequestOptions())

        .subscribe({
            next: (response) => {
              observer.next(response);
              observer.complete();
              observer.unsubscribe();
            },
            error: (rejected) => {
              observer.next(this._handleRejected(rejected));
              observer.complete();
              observer.unsubscribe();
            }
          }
        );

    });

  }


  retrieveAndUpdateEmployeeWithOdooInformation(bean: UpdateMultipleEmployeeWithOptionsToUpdateFromOdooRequest[]): Promise<JSonResult<JSonResult<string>[]>> {
    const serial = new JSonSerializer();
    return this.http.post( this.serverUrl('retrieveAndUpdateEmployeeWithOdooInformation'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<JSonResult<string>[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  getEmployeeFromSageIntacct(bean:SearchEmployeeRequest): Observable<JSonResult<CreateNewEmployee[]>> {
    const serial = new JSonSerializer();


    return new Observable<JSonResult<CreateNewEmployee[]>>((observer)=>{
      this.http.post<JSonResult<CreateNewEmployee[]>>( this.serverUrl('getEmployeeFromSageIntacct'),  serial.prepareForJson(bean), this._retrieveJSonRequestOptions())

        .subscribe({
            next: (response) => {
              observer.next(response);
              observer.complete();
              observer.unsubscribe();
            },
            error: (rejected) => {
              observer.next(this._handleRejected(rejected));
              observer.complete();
              observer.unsubscribe();
            }
          }
        );

    });

  }




  getMatchingEmployeeFromSageIntacct(bean:SearchEmployeeRequest): Observable<JSonResult<MatchingEmployeeResult>> {
    const serial = new JSonSerializer();


    return new Observable<JSonResult<MatchingEmployeeResult>>((observer)=>{
      this.http.post<JSonResult<MatchingEmployeeResult>>( this.serverUrl('getMatchingEmployeeFromSageIntacct'),  serial.prepareForJson(bean), this._retrieveJSonRequestOptions())

        .subscribe({
            next: (response) => {
              observer.next(response);
              observer.complete();
              observer.unsubscribe();
            },
            error: (rejected) => {
              observer.next(this._handleRejected(rejected));
              observer.complete();
              observer.unsubscribe();
            }
          }
        );

    });

  }


  updateMatchedEmployeeWithSageIntacctInformation(bean: UpdateMatchingEmployeeWithMatriculeRequest): Observable<JSonResult<JSonResult<string>[]>> {
    const serial = new JSonSerializer();

    return new Observable<JSonResult<JSonResult<string>[]>>((observer)=>{
      this.http.post<JSonResult<JSonResult<string>[]>>( this.serverUrl('updateMatchedEmployeeWithSageIntacctInformation'),  serial.prepareForJson(bean), this._retrieveJSonRequestOptions())

        .subscribe({
            next: (response) => {
              observer.next(response);
              observer.complete();
              observer.unsubscribe();
            },
            error: (rejected) => {
              observer.next(this._handleRejected(rejected));
              observer.complete();
              observer.unsubscribe();
            }
          }
        );

    });

  }


  retrieveAndUpdateEmployeeWithSageIntacctInformation(bean: UpdateMultipleEmployeeWithOptionsToUpdateFromSageIntacctRequest[]): Promise<JSonResult<JSonResult<string>[]>> {
    const serial = new JSonSerializer();
    return this.http.post( this.serverUrl('retrieveAndUpdateEmployeeWithSageIntacctInformation'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<JSonResult<string>[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



retrieveCostDistributionByAccessibleEnterprise(): Observable<JSonResult<EnterpriseCostDistributionConfig[]>> {
    // const serializer = new JSonSerializer();


    return new Observable<JSonResult<EnterpriseCostDistributionConfig[]>>((observer)=>{
      this.http.post<JSonResult<EnterpriseCostDistributionConfig[]>>( this.serverUrl('retrieveCostDistributionByAccessibleEnterprise'), {}, this._retrieveJSonRequestOptions())

        .subscribe({
            next: (response) => {
              observer.next(response);
              observer.complete();
              observer.unsubscribe();
            },
            error: (rejected) => {
              // @ts-ignore
              observer.next(this._handleRejected(rejected));
              observer.complete();
              observer.unsubscribe();
            }
          }
        );

    });

  }



  retrieveSageIntacctProjects(): Observable<JSonResult<SageIntacctProjectsResponse[]>> {
    return new Observable<JSonResult<SageIntacctProjectsResponse[]>>((observer)=>{
      this.http.post<JSonResult<SageIntacctProjectsResponse[]>>( this.serverUrl('retrieveSageIntacctProjects'), {}, this._retrieveJSonRequestOptions())

        .subscribe({
            next: (response) => {
              observer.next(response);
              observer.complete();
              observer.unsubscribe();
            },
            error: (rejected) => {
              // @ts-ignore
              observer.next(this._handleRejected(rejected));
              observer.complete();
              observer.unsubscribe();
            }
          }
        );

    });
  }

  retrieveSageIntacctProjectsToImport(): Observable<JSonResult<SageIntacctProjectsResponse[]>> {
    return new Observable<JSonResult<SageIntacctProjectsResponse[]>>((observer)=>{
      this.http.post<JSonResult<SageIntacctProjectsResponse[]>>( this.serverUrl('retrieveSageIntacctProjectsToImport'), {}, this._retrieveJSonRequestOptions())

        .subscribe({
            next: (response) => {
              observer.next(response);
              observer.complete();
              observer.unsubscribe();
            },
            error: (rejected) => {
              // @ts-ignore
              observer.next(this._handleRejected(rejected));
              observer.complete();
              observer.unsubscribe();
            }
          }
        );

    });
  }


  retrieveSageIntacctProjectWithDetails(bean: SageIntacctProjectDetailRequest): Observable<JSonResult<SageIntacctProjectsResponse[]>> {
    const serializer = new JSonSerializer();
    return new Observable<JSonResult<SageIntacctProjectsResponse[]>>((observer)=>{
      this.http.post<JSonResult<SageIntacctProjectsResponse[]>>( this.serverUrl('retrieveSageIntacctProjectWithDetails'), serializer.prepareForJson(bean), this._retrieveJSonRequestOptions())

        .subscribe({
            next: (response) => {
              observer.next(response);
              observer.complete();
              observer.unsubscribe();
            },
            error: (rejected) => {
              // @ts-ignore
              observer.next(this._handleRejected(rejected));
              observer.complete();
              observer.unsubscribe();
            }
          }
        );

    });
  }





  sendTaskToSageIntacct(bean: EmployeeTimedTask): Promise<JSonResult<number>> {
    const serializer = new JSonSerializer();
    return this.http.post( this.serverUrl('sendTaskToSageIntacct'), serializer.prepareForJson(bean),  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  searchEmployeeByUnitAndEnterprise(bean: SearchEmployeeByUnitAndEnterprise): Observable<JSonResult<SearchEmployeeResponse>> {
    const serializer = new JSonSerializer();
    return new Observable<JSonResult<SearchEmployeeResponse>>((observer)=>{
      this.http.post<JSonResult<SearchEmployeeResponse>>( this.serverUrl('searchEmployeeByUnitAndEnterprise'), serializer.prepareForJson(bean), this._retrieveJSonRequestOptions())

        .subscribe({
            next: (response) => {
              observer.next(response);
              observer.complete();
              observer.unsubscribe();
            },
            error: (rejected) => {
              // @ts-ignore
              observer.next(this._handleRejected(rejected));
              observer.complete();
              observer.unsubscribe();
            }
          }
        );

    });
  }



  getAbsenceTimesheetsByHRConfig(from: moment.Moment, to: moment.Moment,includeHidden:boolean, includeInactive: boolean): Promise<JSonResult<HREmployeeAbsenceDetail[]>> {
    return this.http.post( this.serverUrl('getAbsenceTimesheetsByHRConfig'), {fromDt: from, toDt: to,includeHidden:includeHidden,includeInactive:includeInactive}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<HREmployeeAbsenceDetail[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }




  getEmployeeRemunerationAndBonusByHRConfig(includeHidden:boolean, includeInactive: boolean): Promise<JSonResult<RemunerationAndBonusAggregation[]>> {
    return this.http.post( this.serverUrl('getEmployeeRemunerationAndBonusByHRConfig'), {includeHidden:includeHidden,includeInactive:includeInactive}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<RemunerationAndBonusAggregation[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  getEmployeeAndStatusByHRConfig(includeHidden:boolean, includeInactive: boolean): Promise<JSonResult<EmployeeAndStatus[]>> {
    return this.http.post( this.serverUrl('getEmployeeAndStatusByHRConfig'), {includeHidden:includeHidden,includeInactive:includeInactive}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<EmployeeAndStatus[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  deleteDisciplineFile(bean:DisciplineFile): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
    //this.traceService.sendTrace('deleteExpenseFile',bean);
    return this.http.post( this.serverUrl('deleteDisciplineFile'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  saveDiscipline(bean:Discipline): Promise<JSonResult<string>> {
    const serial = new JSonSerializer();
    return this.http.post( this.serverUrl('saveDiscipline'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<string>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  deleteDisciplineAggregation(bean:DisciplineAggregation): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
    return this.http.post( this.serverUrl('deleteDisciplineAggregation'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  getDisciplineAggregationByEmployeeId(employeeId: string): Promise<JSonResult<DisciplineAggregation[]>> {
    const serial = new JSonSerializer();

    return this.http.post( this.serverUrl('getDisciplineAggregationByEmployeeId'), {employeeId: employeeId}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<DisciplineAggregation[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  getDisciplineAggregationsByHRConfig(includeHidden:boolean, includeInactive: boolean): Promise<JSonResult<DisciplineAggregation[]>> {
    return this.http.post( this.serverUrl('getDisciplineAggregationsByHRConfig'), {includeHidden:includeHidden,includeInactive:includeInactive}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<DisciplineAggregation[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }




  public async downloadDisciplineFile(disciplineFileId: string, employeeId: string ): Promise<JSonResult<string>> {
    let res =  await this.createTokenForDownloadingDisciplineFile(disciplineFileId,employeeId);
    if (res.success){
      res.data = this._downloadContent('disciplineFile?token=' + res.data + '&inline=true');
    }
    return res;
    // return this.downloadUrl('?docId=' + docId);
  }


  public createTokenForDownloadingDisciplineFile(disciplineFileId: string, employeeId: string): Promise<JSonResult<string>> {
    return this.http.post( this.serverUrl('createTokenForDownloadingDisciplineFile'), {id:disciplineFileId,EMPLOYEE_ID: employeeId}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<string>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  saveHRConfigParam(bean:HRConfigParam): Promise<JSonResult<HRConfigAggregation>> {
    const serial = new JSonSerializer();
    return this.http.post( this.serverUrl('saveHRConfigParam'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<HRConfigAggregation>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }





  deleteGrievanceFile(bean:GrievanceFile): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
    return this.http.post( this.serverUrl('deleteGrievanceFile'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  saveGrievance(bean:Grievance): Promise<JSonResult<string>> {
    const serial = new JSonSerializer();
    return this.http.post( this.serverUrl('saveGrievance'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<string>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  getGrievanceAggregationsByHRConfig(includeHidden:boolean, includeInactive: boolean): Promise<JSonResult<GrievanceAggregation[]>> {
    return this.http.post( this.serverUrl('getGrievanceAggregationsByHRConfig'), {includeHidden:includeHidden,includeInactive:includeInactive}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<GrievanceAggregation[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }




  public async downloadGrievanceFile(grievanceFileId: string, employeeId: string ): Promise<JSonResult<string>> {
    let res =  await this.createTokenForDownloadingGrievanceFile(grievanceFileId,employeeId);
    if (res.success){
      res.data = this._downloadContent('grievanceFile?token=' + res.data + '&inline=true');
    }
    return res;
    // return this.downloadUrl('?docId=' + docId);
  }


  public createTokenForDownloadingGrievanceFile(grievanceFileId: string, employeeId: string): Promise<JSonResult<string>> {
    return this.http.post( this.serverUrl('createTokenForDownloadingGrievanceFile'), {id:grievanceFileId,EMPLOYEE_ID: employeeId}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<string>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  getCertificatAggregationsByHRConfig(): Promise<JSonResult<CertificatAggregation[]>> {
    return this.http.post( this.serverUrl('getCertificatAggregationsByHRConfig'), {}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<CertificatAggregation[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  saveCertificat(bean:Certificat): Promise<JSonResult<string>> {
    const serial = new JSonSerializer();
    return this.http.post( this.serverUrl('saveCertificat'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<string>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  saveCertificatRequirement(bean:CertificatRequirement): Promise<JSonResult<string>> {
    const serial = new JSonSerializer();
    return this.http.post( this.serverUrl('saveCertificatRequirement'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<string>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  deleteCertificatRequirement(bean:CertificatRequirement): Promise<JSonResult<string>> {
    const serial = new JSonSerializer();
    return this.http.post( this.serverUrl('deleteCertificatRequirement'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<string>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  getEmployeeCertificateAggregationsByHRConfig(includeHidden:boolean, includeInactive: boolean): Promise<JSonResult<EmployeeCertificateAggregation[]>> {
    return this.http.post( this.serverUrl('getEmployeeCertificateAggregationsByHRConfig'), {includeHidden:includeHidden,includeInactive:includeInactive}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<EmployeeCertificateAggregation[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  saveEmployeeCertificate(bean:EmployeeCertificate): Promise<JSonResult<string>> {
    const serial = new JSonSerializer();
    return this.http.post( this.serverUrl('saveEmployeeCertificate'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<string>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }




  deleteEmployeeCertificateFile(bean:EmployeeCertificateFile): Promise<JSonResult<number>> {
    const serial = new JSonSerializer();
    return this.http.post( this.serverUrl('deleteEmployeeCertificateFile'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<number>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  public async downloadEmployeeCertificateFile(employeeCertificateFileId: string, employeeId: string ): Promise<JSonResult<string>> {
    let res =  await this.createTokenForDownloadingEmployeeCertificateFile(employeeCertificateFileId,employeeId);
    if (res.success){
      res.data = this._downloadContent('employeeCertificateFile?token=' + res.data + '&inline=true');
    }
    return res;
    // return this.downloadUrl('?docId=' + docId);
  }


  public createTokenForDownloadingEmployeeCertificateFile(employeeCertificateFileId: string, employeeId: string): Promise<JSonResult<string>> {
    return this.http.post( this.serverUrl('createTokenForDownloadingEmployeeCertificateFile'), {id:employeeCertificateFileId,EMPLOYEE_ID: employeeId}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<string>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }




  getTrainingProgramAggregationsByHRConfig(from: moment.Moment, to: moment.Moment,includeHidden:boolean, includeInactive: boolean): Promise<JSonResult<TrainingProgramAggregation[]>> {
    return this.http.post( this.serverUrl('getTrainingProgramAggregationsByHRConfig'), {fromDt: from, toDt: to,includeHidden:includeHidden,includeInactive:includeInactive}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<TrainingProgramAggregation[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }



  saveTrainingProgram(bean:TrainingProgram): Promise<JSonResult<string>> {
    const serial = new JSonSerializer();
    return this.http.post( this.serverUrl('saveTrainingProgram'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<string>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }




  saveEmployeeTrainingProgram(bean:EmployeeTrainingProgram): Promise<JSonResult<string>> {
    const serial = new JSonSerializer();
    return this.http.post( this.serverUrl('saveEmployeeTrainingProgram'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<string>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  deleteEmployeeTrainingProgram(bean:EmployeeTrainingProgram): Promise<JSonResult<string>> {
    const serial = new JSonSerializer();
    return this.http.post( this.serverUrl('deleteEmployeeTrainingProgram'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<string>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  getEmployeesToChooseFromByHRConfig(includeHidden:boolean, includeInactive: boolean): Promise<JSonResult<EmployeeWithDefaultPositionAndSalary[]>> {
    return this.http.post( this.serverUrl('getEmployeesToChooseFromByHRConfig'), {includeHidden:includeHidden,includeInactive:includeInactive}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          //
          return response as JSonResult<EmployeeWithDefaultPositionAndSalary[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }




  getEvaluationAggregationsByHRConfig(from: moment.Moment, to: moment.Moment, includeHiddenEmployee: boolean, includeInactiveEmployee: boolean): Promise<JSonResult<EmployeeExpenseAggregation[]>> {
    return this.http.post( this.serverUrl('getEvaluationAggregationsByHRConfig'), {fromDt: from, toDt: to,  includeHidden: includeHiddenEmployee, includeInactive: includeInactiveEmployee}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<EmployeeExpenseAggregation[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  getEvaluationEmployeeAggregationsByHRConfig(from: moment.Moment, to: moment.Moment, includeHiddenEmployee: boolean, includeInactiveEmployee: boolean): Promise<JSonResult<EmployeeExpenseAggregation[]>> {
    return this.http.post( this.serverUrl('getEvaluationEmployeeAggregationsByHRConfig'), {fromDt: from, toDt: to,  includeHidden: includeHiddenEmployee, includeInactive: includeInactiveEmployee}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<EmployeeExpenseAggregation[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  getEmployeeAbilitiesAggregationsByHRConfig( includeHiddenEmployee: boolean, includeInactiveEmployee: boolean): Promise<JSonResult<EmployeeAbilitiesAggregation[]>> {
    return this.http.post( this.serverUrl('getEmployeeAbilitiesAggregationsByHRConfig'), { includeHidden: includeHiddenEmployee, includeInactive: includeInactiveEmployee}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<EmployeeAbilitiesAggregation[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  saveEmployeeAbility(bean:EmployeeAbility): Promise<JSonResult<string>> {
    const serial = new JSonSerializer();
    return this.http.post( this.serverUrl('saveEmployeeAbility'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<string>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  deleteEmployeeAbility(bean:EmployeeAbility): Promise<JSonResult<string>> {
    const serial = new JSonSerializer();
    return this.http.post( this.serverUrl('deleteEmployeeAbility'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<string>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  saveEmployeeAbilityReview(bean:EmployeeAbilityReview): Observable<JSonResult<string>> {
    const serializer = new JSonSerializer();

    return this._updateData<JSonResult<string>>('saveEmployeeAbilityReview',serializer.prepareForJson(bean));
    /*
    const serial = new JSonSerializer();
    return this.http.post( this.serverUrl('saveEmployeeAbilityReview'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<string>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
      
     */
  }


  deleteEmployeeAbilityReview(bean:EmployeeAbilityReview): Observable<JSonResult<string>> {
    const serializer = new JSonSerializer();

    return this._updateData<JSonResult<string>>('deleteEmployeeAbilityReview',serializer.prepareForJson(bean));
    // const serial = new JSonSerializer();
    // return this.http.post( this.serverUrl('deleteEmployeeAbilityReview'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
    //   .toPromise()
    //   .then((response) => {
    //       return response as JSonResult<string>;
    //     },
    //     (rejected) => { return this._handleRejected(rejected); }
    //   );
  }

  saveEmployeePerformance(bean:EmployeePerformance): Observable<JSonResult<string>> {
    return this._updateData<JSonResult<string>>('saveEmployeePerformance',bean,new JSonSerializer());
    /*
    const serial = new JSonSerializer();
    return this.http.post( this.serverUrl('saveEmployeePerformance'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<string>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
      
     */
  }


  saveEmployeePerformanceReviewer(bean:EmployeePerformanceReviewer): Observable<JSonResult<string>> {
    return this._updateData<JSonResult<string>>('saveEmployeePerformanceReviewer',bean,new JSonSerializer());
  }

  deleteEmployeePerformanceReviewer(bean:EmployeePerformanceReviewer): Observable<JSonResult<string>> {
    return this._updateData<JSonResult<string>>('deleteEmployeePerformanceReviewer',bean,new JSonSerializer());
  }


  saveHRAbility(bean:HRAbility): Promise<JSonResult<HRConfigAggregation>> {
    const serial = new JSonSerializer();
    return this.http.post( this.serverUrl('saveHRAbility'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<HRConfigAggregation>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  saveHRCompetency(bean:HRCompetency): Promise<JSonResult<HRConfigAggregation>> {
    const serial = new JSonSerializer();
    return this.http.post( this.serverUrl('saveHRCompetency'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<HRConfigAggregation>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  saveHRKeyResponsibilityArea(bean:HRKeyResponsibilityArea): Promise<JSonResult<HRConfigAggregation>> {
    const serial = new JSonSerializer();
    return this.http.post( this.serverUrl('saveHRKeyResponsibilityArea'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<HRConfigAggregation>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  saveHRPerformanceTemplate(bean:HRPerformanceTemplate): Promise<JSonResult<HRConfigAggregation>> {
    const serial = new JSonSerializer();
    return this.http.post( this.serverUrl('saveHRPerformanceTemplate'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<HRConfigAggregation>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  getEmployeePerformancesByHRConfig(from: moment.Moment, to: moment.Moment, includeHiddenEmployee: boolean, includeInactiveEmployee: boolean): Promise<JSonResult<EmployeePerformance[]>> {
    return this.http.post( this.serverUrl('getEmployeePerformancesByHRConfig'), {fromDt: from, toDt: to,  includeHidden: includeHiddenEmployee, includeInactive: includeInactiveEmployee}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<EmployeePerformance[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  getEmployeePerformanceAggregationById(employeePerformanceId: string): Promise<JSonResult<EmployeePerformanceAggregation>> {
    return this.http.post( this.serverUrl('getEmployeePerformanceAggregationById'), {id:employeePerformanceId}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<EmployeePerformanceAggregation>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }






  getEmployeeCompetenciesAggregationsByHRConfig( includeHiddenEmployee: boolean, includeInactiveEmployee: boolean): Promise<JSonResult<EmployeeCompetenciesAggregation[]>> {
    return this.http.post( this.serverUrl('getEmployeeCompetenciesAggregationsByHRConfig'), { includeHidden: includeHiddenEmployee, includeInactive: includeInactiveEmployee}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<EmployeeCompetenciesAggregation[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  saveEmployeeCompetency(bean:EmployeeCompetency): Promise<JSonResult<string>> {
    const serial = new JSonSerializer();
    return this.http.post( this.serverUrl('saveEmployeeCompetency'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<string>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  deleteEmployeeCompetency(bean:EmployeeCompetency): Promise<JSonResult<string>> {
    const serial = new JSonSerializer();
    return this.http.post( this.serverUrl('deleteEmployeeCompetency'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<string>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  saveEmployeeCompetencyReview(bean:EmployeeCompetencyReview): Observable<JSonResult<string>> {
    return this._updateData<JSonResult<string>>('saveEmployeeCompetencyReview',bean,new JSonSerializer());
  }


  deleteEmployeeCompetencyReview(bean:EmployeeCompetencyReview): Observable<JSonResult<string>> {
    return this._updateData<JSonResult<string>>('deleteEmployeeCompetencyReview',bean,new JSonSerializer());
  }





  getEmployeeKRAsAggregationsByHRConfig( includeHiddenEmployee: boolean, includeInactiveEmployee: boolean): Promise<JSonResult<EmployeeKRAsAggregation[]>> {
    return this.http.post( this.serverUrl('getEmployeeKRAsAggregationsByHRConfig'), { includeHidden: includeHiddenEmployee, includeInactive: includeInactiveEmployee}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<EmployeeKRAsAggregation[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }


  saveEmployeeKRA(bean:EmployeeKRA): Promise<JSonResult<string>> {
    const serial = new JSonSerializer();
    return this.http.post( this.serverUrl('saveEmployeeKRA'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<string>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  deleteEmployeeKRA(bean:EmployeeKRA): Promise<JSonResult<string>> {
    const serial = new JSonSerializer();
    return this.http.post( this.serverUrl('deleteEmployeeKRA'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<string>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  saveEmployeeKRAReview(bean:EmployeeKRAReview): Observable<JSonResult<string>> {
    const serializer = new JSonSerializer();

    return this._updateData<JSonResult<string>>('saveEmployeeKRAReview',serializer.prepareForJson(bean));


    // const serial = new JSonSerializer();
    // return this.http.post( this.serverUrl('saveEmployeeKRAReview'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
    //   .toPromise()
    //   .then((response) => {
    //       return response as JSonResult<string>;
    //     },
    //     (rejected) => { return this._handleRejected(rejected); }
    //   );
  }


  deleteEmployeeKRAReview(bean:EmployeeKRAReview): Observable<JSonResult<string>> {
    const serializer = new JSonSerializer();

    return this._updateData<JSonResult<string>>('deleteEmployeeKRAReview',serializer.prepareForJson(bean));

    // const serial = new JSonSerializer();
    // return this.http.post( this.serverUrl('deleteEmployeeKRAReview'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
    //   .toPromise()
    //   .then((response) => {
    //       return response as JSonResult<string>;
    //     },
    //     (rejected) => { return this._handleRejected(rejected); }
    //   );
  }

  getEmployeeGoalsAggregationsByHRConfig(from: moment.Moment, to: moment.Moment, includeHiddenEmployee: boolean, includeInactiveEmployee: boolean): Observable<JSonResult<EmployeeGoalsAggregation[]>> {
    return this._updateData<JSonResult<EmployeeGoalsAggregation[]>>('getEmployeeGoalsAggregationsByHRConfig',{fromDt: from, toDt: to,  includeHidden: includeHiddenEmployee, includeInactive: includeInactiveEmployee});
    /*
    return this.http.post( this.serverUrl('getEmployeeGoalsAggregationsByHRConfig'), {fromDt: from, toDt: to,  includeHidden: includeHiddenEmployee, includeInactive: includeInactiveEmployee}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<EmployeeGoalsAggregation[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
      
     */
  }

  saveEmployeeGoal(bean:EmployeeGoal): Promise<JSonResult<string>> {
    const serial = new JSonSerializer();
    return this.http.post( this.serverUrl('saveEmployeeGoal'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<string>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  deleteEmployeeGoal(bean:EmployeeGoal): Promise<JSonResult<string>> {
    const serial = new JSonSerializer();
    return this.http.post( this.serverUrl('deleteEmployeeGoal'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<string>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  saveEmployeeGoalReview(bean:EmployeeGoalReview): Observable<JSonResult<string>> {
    // const serial = new JSonSerializer();

    const serializer = new JSonSerializer();

    return this._updateData<JSonResult<string>>('saveEmployeeGoalReview',serializer.prepareForJson(bean));
    /*
    return this.http.post( this.serverUrl('saveEmployeeGoalReview'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<string>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );

     */
  }


  deleteEmployeeGoalReview(bean:EmployeeGoalReview): Observable<JSonResult<string>> {
    const serializer = new JSonSerializer();

    return this._updateData<JSonResult<string>>('deleteEmployeeGoalReview',serializer.prepareForJson(bean));
    /*
    const serial = new JSonSerializer();
    return this.http.post( this.serverUrl('deleteEmployeeGoalReview'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<string>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
      
     */
  }


  saveEmployeeReview360(bean:EmployeeReview360): Observable<JSonResult<string>> {
    const serializer = new JSonSerializer();

    return this._updateData<JSonResult<string>>('saveEmployeeReview360',serializer.prepareForJson(bean));
    // const serial = new JSonSerializer();
    // return this.http.post( this.serverUrl('saveEmployeeReview360'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
    //   .toPromise()
    //   .then((response) => {
    //       return response as JSonResult<string>;
    //     },
    //     (rejected) => { return this._handleRejected(rejected); }
    //   );
  }


  deleteEmployeeReview360(bean:EmployeeReview360): Observable<JSonResult<string>> {

    const serializer = new JSonSerializer();

    return this._updateData<JSonResult<string>>('deleteEmployeeReview360',serializer.prepareForJson(bean));
    // const serial = new JSonSerializer();
    // return this.http.post( this.serverUrl('deleteEmployeeReview360'), serial.prepareForJson(bean), this._retrieveJSonRequestOptions())
    //   .toPromise()
    //   .then((response) => {
    //       return response as JSonResult<string>;
    //     },
    //     (rejected) => { return this._handleRejected(rejected); }
    //   );
  }


   saveHRGoalAggregation(bean:HRGoalAggregation): Observable<JSonResult<HRConfigAggregation>> {
     return this._updateData<JSonResult<HRConfigAggregation>>('saveHRGoalAggregation',bean,new JSonSerializer());
    }

    saveHRKeyResponsibilityAreaAggregation(bean:HRKeyResponsibilityAreaAggregation): Observable<JSonResult<HRConfigAggregation>> {
      return this._updateData<JSonResult<HRConfigAggregation>>('saveHRKeyResponsibilityAreaAggregation',bean,new JSonSerializer());
    }


    getEmployeeManagerAggregationsByHRConfig( includeHiddenEmployee: boolean, includeInactiveEmployee: boolean): Observable<JSonResult<EmployeeManagerAggregation[]>> {
      return this._updateData<JSonResult<EmployeeManagerAggregation[]>>('getEmployeeManagerAggregationsByHRConfig',{ includeHidden: includeHiddenEmployee, includeInactive: includeInactiveEmployee});
    }

    saveEmployeeManager(bean:EmployeeManager): Observable<JSonResult<string>> {
      return this._updateData<JSonResult<string>>('saveEmployeeManager',bean,new JSonSerializer());
    }

    deleteEmployeeManager(bean:EmployeeManager): Observable<JSonResult<string>> {
      return this._updateData<JSonResult<string>>('deleteEmployeeManager',bean,new JSonSerializer());
    }

  getManagersForActivePositionsOfEmployee( employeeId:string): Observable<JSonResult<Employee[]>> {
    return this._updateData<JSonResult<Employee[]>>('getManagersForActivePositionsOfEmployee',{ 'EMPLOYEE_ID':employeeId});
  }


  saveEmployeeCareerAggregation(bean:EmployeeCareerAggregation): Observable<JSonResult<string>> {
    return this._updateData<JSonResult<string>>('saveEmployeeCareerAggregation',bean,new JSonSerializer());
  }

  saveHRCareerAggregation(bean:HRCareerAggregation): Observable<JSonResult<HRConfigAggregation>> {
    return this._updateData<JSonResult<HRConfigAggregation>>('saveHRCareerAggregation',bean,new JSonSerializer());
  }


  getEmployeeCareerAggregationsByHRConfig(includeHidden:boolean, includeInactive: boolean): Observable<JSonResult<EmployeeCareerAggregation[]>> {
    return this._updateData<JSonResult<EmployeeCareerAggregation[]>>('getEmployeeCareerAggregationsByHRConfig',{includeHidden:includeHidden,includeInactive:includeInactive});
  }


  getEmployeeRecognitionAggregationsByHRConfig(from: moment.Moment, to: moment.Moment, includeHiddenEmployee: boolean, includeInactiveEmployee: boolean): Observable<JSonResult<EmployeeRecognitionAggregation[]>> {
    return this._updateData<JSonResult<EmployeeRecognitionAggregation[]>>('getEmployeeRecognitionAggregationsByHRConfig',
        {fromDt: from, toDt: to,   includeHidden: includeHiddenEmployee, includeInactive: includeInactiveEmployee});
  }


  saveEmployeeRecognition(bean:EmployeeRecognition): Observable<JSonResult<string>> {
    return this._updateData<JSonResult<string>>('saveEmployeeRecognition',bean,new JSonSerializer());
  }

  deleteEmployeeRecognition(bean:EmployeeRecognition): Observable<JSonResult<string>> {
    return this._updateData<JSonResult<string>>('deleteEmployeeRecognition',bean,new JSonSerializer());
  }



  printEmployeePerformance(bean: EmployeePerformanceReportRequest): Observable<JSonResult<string>> {
    return this._updateData<JSonResult<string>>('printEmployeePerformance',bean,new JSonSerializer());
  }

  getEmployeePerformanceReviewersByEmployeePerformance(bean:EmployeePerformance): Observable<JSonResult<EmployeePerformanceReviewer[]>> {
    return this._updateData<JSonResult<EmployeePerformanceReviewer[]>>('getEmployeePerformanceReviewersByEmployeePerformance',bean,new JSonSerializer());
  }



  getEmployeePerformanceToReviewInTheNextDays(nbDays:number): Observable<JSonResult<CustomValidation<EmployeePerformance>[]>> {
    return this._updateData<JSonResult<CustomValidation<EmployeePerformance>[]>>('getEmployeePerformanceToReviewInTheNextDays',{nbDays:nbDays},new JSonSerializer());
  }

  completedReview(reviewerEmployeeId:string,employeePerformanceId: string): Observable<JSonResult<string>> {
    return this._updateData<JSonResult<string>>('completedReview',{reviewerEmployeeId:reviewerEmployeeId,employeePerformanceId: employeePerformanceId},new JSonSerializer());
  }


  getHRDashboardInformation(from: moment.Moment, to: moment.Moment): Observable<JSonResult<HRDashboardInformation>> {
    return this._updateData<JSonResult<HRDashboardInformation>>('getHRDashboardInformation', {fromDt: from, toDt: to});
  }



  getEnterpriseLogsByEnterpriseId(enterpriseId: number): Observable<JSonResult<EnterpriseLog[]>> {
    return this._updateData<JSonResult<EnterpriseLog[]>>('getEnterpriseLogsByEnterpriseId', {id:enterpriseId});
  }



  saveEmployeeTimedTask(bean: EmployeeTimedTask): Observable<JSonResult<number>> {
    return this._updateData<JSonResult<number>>('saveEmployeeTimedTask',bean,new JSonSerializer());
  }

  deleteEmployeeTimedTask(bean: EmployeeTimedTask): Observable<JSonResult<number>> {
    return this._updateData<JSonResult<number>>('deleteEmployeeTimedTask',bean,new JSonSerializer());
  }

  // removeUnapprovedSchedules(): Promise<JSonResult<number>> {
  //   //this.traceService.sendTrace("removeUnapprovedSchedules",{jobId: jobId, unitId: unitId,'EMPLOYEE_ID':employeeId});
  //   return this.http.post( this.serverUrl('removeUnapprovedSchedules'),  {jobId: jobId, unitId: unitId,'EMPLOYEE_ID':employeeId},  this._retrieveJSonRequestOptions())

  removeUnapprovedSchedulesAndTemplates(jobId: string, unitId: string, employeeId: string,refDate: moment.Moment): Observable<JSonResult<number>> {
    return this._updateData<JSonResult<number>>('removeUnapprovedSchedulesAndTemplates',{jobId: jobId, unitId: unitId,'EMPLOYEE_ID':employeeId,refDt:refDate});
  }

  retrieveInformationAboutEmployeesToNotify(employeeIds: string[]): Observable<JSonResult<EmployeeInfo[]>> {
    return this._updateData<JSonResult<EmployeeInfo[]>>('retrieveInformationAboutEmployeesToNotify', {employeeIds:employeeIds});
  }


  updateTimesheetNote(timesheetId: number, timesheetNote: string): Observable<JSonResult<number>> {
    return this._updateData<JSonResult<number>>('updateTimesheetNote',{id: timesheetId, note: timesheetNote});
  }

  private _configurationAsObservable(){
    return new Observable<ServerConfiguration>((observer)=>{
      this.http.get<ServerConfiguration>('configuration.json',{headers : this._getHeaders() }).subscribe(
          {
            next: (response) => {
              observer.next(response);
              observer.complete();
              observer.unsubscribe();
            },
            error: (rejected) => {
              // @ts-ignore
              observer.next(this._handleRejected(rejected));
              observer.complete();
              observer.unsubscribe();
            }
          }
      );
    });
  }

  loginOpenId(): Observable<JSonResult<UserInfo>> {
    return new Observable<JSonResult<UserInfo>>((observer)=>{
      this._configurationAsObservable().subscribe((res)=>{
        console.log('Received server: ',res);
        this.sessionService.serverConfiguration = res;
        return this._updateData<JSonResult<UserInfo>>('loginOpenId', {});
      });
    });


  }

  loginOpenIdUrl(type:string): Observable<string> {
    return new Observable<string>((observer)=>{
      this._configurationAsObservable().subscribe((res)=>{
        console.log('Received server: ',res);
        this.sessionService.serverConfiguration = res;
        // return this.serverUrl('loginOpenId');
          observer.next(this.serverUrl('loginOpenId')+'?oidType=' + type);
          observer.complete();
          observer.unsubscribe();
      });
    });


  }



  private _updateData<T>(url:string, bean: any,serializer?: JSonSerializer){
      let toSend = bean;
      if (serializer){
        toSend = serializer.prepareForJson(bean);
      }

    console.log('UpdateData : ',this.serverUrl(url));


    return new Observable<T>((observer)=>{
        this.http.post<T>( this.serverUrl(url),toSend, this._retrieveJSonRequestOptions())
            .subscribe({
                  next: (response) => {
                    observer.next(response);
                    observer.complete();
                    observer.unsubscribe();
                  },
                  error: (rejected) => {
                    // @ts-ignore
                    observer.next(this._handleRejected(rejected));
                    observer.complete();
                    observer.unsubscribe();
                  }
                }
            );
      });

    }




}

class WorkCodeParameter {
  EMPLOYEE_ID: string;
  refDt: Date;
  seniorityDt?: Date;
  countryCode?: string;
  provinceCode?: string;
}


